import { Vector3, Vector4, Matrix4, Quaternion, Box3, Object3D, Color, Matrix3, Plane, Line3 } from 'three';
import { Root, Reader } from 'protobufjs';
/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */

/* global Reflect, Promise */

var _extendStatics = function extendStatics(d, b) {
  _extendStatics = Object.setPrototypeOf || {
    __proto__: []
  } instanceof Array && function (d, b) {
    d.__proto__ = b;
  } || function (d, b) {
    for (var p in b) {
      if (b.hasOwnProperty(p)) d[p] = b[p];
    }
  };

  return _extendStatics(d, b);
};

function __extends(d, b) {
  _extendStatics(d, b);

  function __() {
    this.constructor = d;
  }

  d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

function __awaiter(thisArg, _arguments, P, generator) {
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : new P(function (resolve) {
        resolve(result.value);
      }).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
}

function __generator(thisArg, body) {
  var _ = {
    label: 0,
    sent: function sent() {
      if (t[0] & 1) throw t[1];
      return t[1];
    },
    trys: [],
    ops: []
  },
      f,
      y,
      t,
      g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;

  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }

  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");

    while (_) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];

        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;

          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };

          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;

          case 7:
            op = _.ops.pop();

            _.trys.pop();

            continue;

          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }

            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }

            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }

            if (t && _.label < t[2]) {
              _.label = t[2];

              _.ops.push(op);

              break;
            }

            if (t[2]) _.ops.pop();

            _.trys.pop();

            continue;
        }

        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }

    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
}

function __values(o) {
  var m = typeof Symbol === "function" && o[Symbol.iterator],
      i = 0;
  if (m) return m.call(o);
  return {
    next: function next() {
      if (o && i >= o.length) o = void 0;
      return {
        value: o && o[i++],
        done: !o
      };
    }
  };
}

function __read(o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
      r,
      ar = [],
      e;

  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) {
      ar.push(r.value);
    }
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }

  return ar;
} // Copyright 2019 Cognite AS


var RenderedPrimitiveNames = ['Box', 'Circle', 'Cone', 'EccentricCone', 'EllipsoidSegment', 'GeneralCylinder', 'GeneralRing', 'Nut', 'Quad', 'SphericalSegment', 'TorusSegment', 'Trapezium'];
var primitiveProperties = {
  Box: ['size', 'center', 'normal', 'angle', 'delta'],
  Circle: ['size', 'center', 'normal', 'radiusA'],
  Cone: ['size', 'centerA', 'centerB', 'radiusA', 'radiusB', 'angle', 'arcAngle', 'localXAxis'],
  EccentricCone: ['size', 'centerA', 'centerB', 'radiusA', 'radiusB', 'normal'],
  EllipsoidSegment: ['size', 'center', 'normal', 'hRadius', 'vRadius', 'height'],
  GeneralCylinder: ['size', 'centerA', 'centerB', 'radiusA', 'heightA', 'heightB', 'slopeA', 'slopeB', 'zAngleA', 'zAngleB', 'angle', 'arcAngle', 'planeA', 'planeB', 'capNormalA', 'capNormalB', 'localXAxis'],
  GeneralRing: ['size', 'center', 'normal', 'radiusA', 'radiusB', 'thickness', 'angle', 'arcAngle', 'localXAxis'],
  Nut: ['size', 'centerA', 'centerB', 'radiusA', 'rotationAngle'],
  Quad: ['size', 'vertex1', 'vertex2', 'vertex3'],
  SphericalSegment: ['size', 'center', 'normal', 'hRadius', 'height'],
  TorusSegment: ['size', 'center', 'normal', 'radius', 'tubeRadius', 'angle', 'arcAngle'],
  Trapezium: ['size', 'vertex1', 'vertex2', 'vertex3', 'vertex4']
};
var primitiveAttributes = {
  Box: [],
  Circle: [],
  Cone: ['centerA', 'centerB', 'radiusA', 'radiusB', 'localXAxis', 'angle', 'arcAngle'],
  EccentricCone: ['centerA', 'centerB', 'radiusA', 'radiusB', 'normal'],
  EllipsoidSegment: ['center', 'normal', 'hRadius', 'vRadius', 'height'],
  GeneralCylinder: ['centerA', 'centerB', 'planeA', 'planeB', 'localXAxis', 'radiusA', 'angle', 'arcAngle'],
  GeneralRing: ['thickness', 'angle', 'arcAngle'],
  Nut: ['centerA', 'centerB'],
  Quad: [],
  SphericalSegment: ['center', 'normal', 'hRadius', 'height'],
  TorusSegment: ['arcAngle', 'radius', 'tubeRadius'],
  Trapezium: ['vertex1', 'vertex2', 'vertex3', 'vertex4']
};
var float64Properties = new Set(['nodeId']);
var float32Properties = new Set(['treeIndex', 'radiusA', 'radiusB', 'angle', 'arcAngle', 'heightA', 'heightB', 'slopeA', 'slopeB', 'zAngleA', 'zAngleB', 'thickness', 'triangleOffset', 'triangleCount', 'rotationAngle', 'radius', 'tubeRadius', 'height', 'vRadius', 'hRadius', 'size']);
var vector3Properties = new Set(['centerA', 'centerB', 'normal', 'delta', 'localXAxis', 'vertex1', 'vertex2', 'vertex3', 'vertex4', 'capNormalA', 'capNormalB', 'center']);
var vector4Properties = new Set(['planeA', 'planeB']);

function getAttributeItemSize(property) {
  if (float32Properties.has(property)) {
    return 1;
  } else if (vector3Properties.has(property)) {
    return 3;
  } else if (vector4Properties.has(property)) {
    return 4;
  } else {
    throw Error('Unknown attribute size for property ' + property);
  }
} // Copyright 2019 Cognite AS


var PrimitiveGroupData =
/** @class */
function () {
  function PrimitiveGroupData(type, capacity) {
    var _this = this;

    this.type = type;
    this.count = 0;
    this.capacity = capacity;
    this.arrays = {};
    primitiveProperties[this.type].forEach(function (property) {
      if (float64Properties.has(property)) {
        _this.arrays[property] = new Float64Array(_this.capacity);
      } else if (float32Properties.has(property)) {
        _this.arrays[property] = new Float32Array(_this.capacity);
      } else if (vector3Properties.has(property)) {
        _this.arrays[property] = new Float32Array(_this.capacity * 3);
      } else if (vector4Properties.has(property)) {
        _this.arrays[property] = new Float32Array(_this.capacity * 4);
      } else {
        throw Error('Property ' + property + ' does not have an associated memory structure');
      }
    });
  }

  PrimitiveGroupData.prototype.setNumber = function (property, value, index) {
    this.arrays[property][index] = value;
  };

  PrimitiveGroupData.prototype.setVector3 = function (property, value, index) {
    this.arrays[property][3 * index] = value.x;
    this.arrays[property][3 * index + 1] = value.y;
    this.arrays[property][3 * index + 2] = value.z;
  };

  PrimitiveGroupData.prototype.setVector4 = function (property, value, index) {
    this.arrays[property][4 * index] = value.x;
    this.arrays[property][4 * index + 1] = value.y;
    this.arrays[property][4 * index + 2] = value.z;
    this.arrays[property][4 * index + 3] = value.w;
  };

  PrimitiveGroupData.prototype.getNumber = function (property, index) {
    return this.arrays[property][index];
  };

  PrimitiveGroupData.prototype.getVector3 = function (property, target, index) {
    target.x = this.arrays[property][3 * index];
    target.y = this.arrays[property][3 * index + 1];
    target.z = this.arrays[property][3 * index + 2];
    return target;
  };

  PrimitiveGroupData.prototype.getVector4 = function (property, target, index) {
    target.x = this.arrays[property][4 * index];
    target.y = this.arrays[property][4 * index + 1];
    target.z = this.arrays[property][4 * index + 2];
    target.w = this.arrays[property][4 * index + 3];
    return target;
  };

  PrimitiveGroupData.prototype.add = function (properties) {
    var _this = this;

    Object.keys(properties).forEach(function (name) {
      if (_this.arrays[name] === undefined) {
        throw Error('Property ' + name + ' is not present on groups with type ' + _this.type + '. See primitiveProperties in PrimitiveGroupDataParameters.ts');
      }

      var property = name;

      if (float64Properties.has(property) || float32Properties.has(property)) {
        _this.setNumber(property, properties[property], _this.count);
      } else if (vector3Properties.has(property)) {
        _this.setVector3(property, properties[property], _this.count);
      } else if (vector4Properties.has(property)) {
        _this.setVector4(property, properties[property], _this.count);
      } else {
        throw Error('Property ' + property + ' does not have an associated type. See PrimitiveGroupDataParameters.ts');
      }
    });
    this.count += 1;
  };

  PrimitiveGroupData.prototype.memoryUsage = function (usage) {
    var _this = this;

    var totalSize = 0;
    Object.keys(this.arrays).forEach(function (property) {
      var array = _this.arrays[property];
      totalSize += array.length * array.BYTES_PER_ELEMENT;
      usage.byProperty[property] = usage.byProperty[property] ? usage.byProperty[property] : 0;
      usage.byProperty[property] += array.length * array.BYTES_PER_ELEMENT;
    });
    usage.byGeometry[this.type] += totalSize;
    usage.total += totalSize;
    return usage;
  };

  PrimitiveGroupData.prototype.getPropertiesAsObject = function (index, reusableObject) {
    var _this = this;

    var data = reusableObject !== undefined ? reusableObject : {};
    Object.keys(this.arrays).forEach(function (name) {
      var property = name;

      if (float64Properties.has(property) || float32Properties.has(property)) {
        data[property] = _this.getNumber(property, index);
      } else if (vector3Properties.has(property)) {
        data[property] = _this.getVector3(property, new Vector3(), index);
      } else if (vector4Properties.has(property)) {
        data[property] = _this.getVector4(property, new Vector4(), index);
      } else {
        throw Error('Property ' + property + ' does not have an associated memory structure');
      }
    });
    return data;
  };

  PrimitiveGroupData.prototype.sort = function () {
    var _this = this;

    var sizeAndIndex = [];
    this.arrays.size.forEach(function (size, index) {
      if (index < _this.count) {
        sizeAndIndex.push([size, index]);
      }
    });
    var sortedIndices = sizeAndIndex.sort(function (_a, _b) {
      var _c = __read(_a, 1),
          size1 = _c[0];

      var _d = __read(_b, 1),
          size2 = _d[0];

      return size2 - size1;
    }).map(function (_a) {
      var _b = __read(_a, 2),
          index = _b[1];

      return index;
    });
    var newArrays = {};
    Object.keys(this.arrays).forEach(function (name) {
      var newArray;
      var property = name;

      if (float64Properties.has(property)) {
        newArray = new Float64Array(_this.count);
        sortedIndices.forEach(function (index, i) {
          newArray[i] = _this.arrays[name][index];
        });
      } else if (float32Properties.has(property)) {
        newArray = new Float32Array(_this.count);
        sortedIndices.forEach(function (index, i) {
          newArray[i] = _this.arrays[name][index];
        });
      } else if (vector3Properties.has(property)) {
        newArray = new Float32Array(_this.count * 3);
        sortedIndices.forEach(function (index, i) {
          newArray[i * 3] = _this.arrays[name][index * 3];
          newArray[i * 3 + 1] = _this.arrays[name][index * 3 + 1];
          newArray[i * 3 + 2] = _this.arrays[name][index * 3 + 2];
        });
      } else if (vector4Properties.has(property)) {
        newArray = new Float32Array(_this.count * 4);
        sortedIndices.forEach(function (index, i) {
          newArray[i * 4] = _this.arrays[name][index * 4];
          newArray[i * 4 + 1] = _this.arrays[name][index * 4 + 1];
          newArray[i * 4 + 2] = _this.arrays[name][index * 4 + 2];
          newArray[i * 4 + 3] = _this.arrays[name][index * 4 + 3];
        });
      } else {
        throw Error('Property ' + property + ' does not have an associated memory structure');
      }

      newArrays[name] = newArray;
    });
    this.arrays = newArrays;
    this.capacity = this.count;
    return sortedIndices;
  };

  return PrimitiveGroupData;
}();

var GeometryGroup =
/** @class */
function () {
  function GeometryGroup() {}

  GeometryGroup.prototype.memoryUsage = function (usage) {
    var _this = this;

    Object.keys(this).forEach(function (key) {
      // @ts-ignore
      if (ArrayBuffer.isView(_this[key])) {
        if (usage.byProperty[key] == null) {
          usage.byProperty[key] = 0;
        }

        if (usage.byGeometry[_this.type] == null) {
          usage.byGeometry[_this.type] = 0;
        } // @ts-ignore


        usage.byGeometry[_this.type] += _this[key].byteLength; // @ts-ignore

        usage.byProperty[key] += _this[key].byteLength; // @ts-ignore

        usage.total += _this[key].byteLength; // @ts-ignore
      } else if (_this[key] instanceof PrimitiveGroupData) {
        // @ts-ignore
        _this[key].memoryUsage(usage);
      }
    });
    return usage;
  };

  return GeometryGroup;
}(); // Copyright 2019 Cognite AS


var xAxis = new Vector3(1, 0, 0);
var yAxis = new Vector3(0, 1, 0);
var zAxis = new Vector3(0, 0, 1);
var twoPI = Math.PI * 2.0;
var degToRadFactor = Math.PI / 180;
var identityMatrix4 = new Matrix4();
var identityPosition = new Vector3(0, 0, 0);
var identityQuaternion = new Quaternion(1, 0, 0, 0);
var identityScale = new Vector3(1, 1, 1); // Copyright 2019 Cognite AS

var globalVector = new Vector3();

function computeBoundingBox(box, matrix, position, index, triangleOffset, triangleCount) {
  box.makeEmpty();
  var start = 3 * triangleOffset;
  var end = start + 3 * triangleCount;
  var array = index.array;
  var isIdentity = matrix.equals(identityMatrix4);

  for (var i = start; i < end; i++) {
    var idx = array[i];
    globalVector.set(position.getX(idx), position.getY(idx), position.getZ(idx));

    if (!isIdentity) {
      globalVector.applyMatrix4(matrix);
    }

    box.expandByPoint(globalVector);
  }

  return box;
} // Copyright 2019 Cognite AS


var globalBox = new Box3();

var MergedMeshMappings =
/** @class */
function () {
  function MergedMeshMappings(capacity) {
    this.count = 0;
    this.capacity = capacity;
    this.triangleOffsets = new Uint32Array(this.capacity);
    this.triangleCounts = new Uint32Array(this.capacity);
    this.treeIndex = new Float32Array(this.capacity);
    this.transform0 = [];
    this.transform0.length = capacity;
    this.transform1 = [];
    this.transform1.length = capacity;
    this.transform2 = [];
    this.transform2.length = capacity;
    this.transform3 = [];
    this.transform3.length = capacity;
    this.size = new Float32Array(this.capacity);
  }

  MergedMeshMappings.prototype.add = function (triangleOffset, triangleCount, treeIndex, size, transformMatrix) {
    if (this.count + 1 > this.capacity) {
      throw new Error('Error in MergedMeshMappings::add. Trying to add more than capacity.');
    }

    this.setTriangleOffset(triangleOffset, this.count);
    this.setTriangleCount(triangleCount, this.count);
    this.setTreeIndex(treeIndex, this.count);
    this.setSize(size, this.count);

    if (transformMatrix !== undefined) {
      this.setTransform(transformMatrix, this.count);
    }

    this.count += 1;
  };

  MergedMeshMappings.prototype.getTreeIndex = function (index) {
    return this.treeIndex[index];
  };

  MergedMeshMappings.prototype.hasTransform = function (index) {
    return this.transform0[index] !== undefined;
  };

  MergedMeshMappings.prototype.getTransformMatrix = function (target, index) {
    var _this = this;

    var columns = [0, 1, 2, 3].map(function (columnIndex) {
      // @ts-ignore
      var transform = _this["transform" + columnIndex];
      return transform[index];
    });

    var _a = __read(columns[0], 3),
        n11 = _a[0],
        n21 = _a[1],
        n31 = _a[2];

    var _b = __read(columns[1], 3),
        n12 = _b[0],
        n22 = _b[1],
        n32 = _b[2];

    var _c = __read(columns[2], 3),
        n13 = _c[0],
        n23 = _c[1],
        n33 = _c[2];

    var _d = __read(columns[3], 3),
        n14 = _d[0],
        n24 = _d[1],
        n34 = _d[2]; // tslint:disable:prettier


    target.set(n11, n12, n13, n14, n21, n22, n23, n24, n31, n32, n33, n34, 0, 0, 0, 1); // tslint:enable:prettier

    return target;
  };

  MergedMeshMappings.prototype.getTriangleCount = function (index) {
    return this.triangleCounts[index];
  };

  MergedMeshMappings.prototype.getTriangleOffset = function (index) {
    return this.triangleOffsets[index];
  };

  MergedMeshMappings.prototype.getSize = function (index) {
    return this.size[index];
  };

  MergedMeshMappings.prototype.removeIndices = function (indicesToRemove) {
    var newIndex = 0;

    for (var i = 0; i < this.count; i++) {
      if (!indicesToRemove[i]) {
        this.triangleOffsets[newIndex] = this.triangleOffsets[i];
        this.triangleCounts[newIndex] = this.triangleCounts[i];
        this.treeIndex[newIndex] = this.treeIndex[i];
        this.transform0[newIndex] = this.transform0[i];
        this.transform1[newIndex] = this.transform1[i];
        this.transform2[newIndex] = this.transform2[i];
        this.transform3[newIndex] = this.transform3[i];
        newIndex++;
      }
    }

    this.count = newIndex;
  };

  MergedMeshMappings.prototype.setTriangleCount = function (value, index) {
    this.triangleCounts[index] = value;
  };

  MergedMeshMappings.prototype.setTriangleOffset = function (value, index) {
    this.triangleOffsets[index] = value;
  };

  MergedMeshMappings.prototype.setTreeIndex = function (value, index) {
    this.treeIndex[index] = value;
  };

  MergedMeshMappings.prototype.setSize = function (value, index) {
    this.size[index] = value;
  };

  MergedMeshMappings.prototype.setTransform = function (source, index) {
    var _this = this;

    var columns = [0, 1, 2, 3].map(function (columnIndex) {
      // @ts-ignore
      var transform = _this["transform" + columnIndex];
      return transform[index] = new Float32Array(3);
    });
    var matrixIndex = 0;

    for (var columnIndex = 0; columnIndex < 4; ++columnIndex, ++matrixIndex) {
      for (var rowIndex = 0; rowIndex < 3; ++rowIndex) {
        columns[columnIndex][rowIndex] = source.elements[matrixIndex++];
      }
    }
  };

  return MergedMeshMappings;
}();

var MergedMesh =
/** @class */
function () {
  function MergedMesh(capacity, fileId, createdByInstancedMesh) {
    if (createdByInstancedMesh === void 0) {
      createdByInstancedMesh = false;
    }

    this.mappings = new MergedMeshMappings(capacity);
    this.fileId = fileId;
    this.treeIndexMap = {};
    this.createdByInstancedMesh = createdByInstancedMesh;
  }

  return MergedMesh;
}();

var MergedMeshGroup =
/** @class */
function (_super) {
  __extends(MergedMeshGroup, _super);

  function MergedMeshGroup() {
    var _this = _super.call(this) || this;

    _this.meshes = [];
    _this.type = 'MergedMesh';
    _this.treeIndexMap = {};
    return _this;
  }

  MergedMeshGroup.prototype.createTreeIndexMap = function () {
    var _this = this;

    this.treeIndexMap = {};
    this.meshes.forEach(function (mergedMesh, meshIndex) {
      for (var mappingIndex = 0; mappingIndex < mergedMesh.mappings.count; mappingIndex++) {
        var treeIndex = mergedMesh.mappings.getTreeIndex(mappingIndex);

        if (_this.treeIndexMap[treeIndex] === undefined) {
          _this.treeIndexMap[treeIndex] = [];
        }

        _this.treeIndexMap[treeIndex].push({
          meshIndex: meshIndex,
          mappingIndex: mappingIndex
        });
      }
    });
  };

  MergedMeshGroup.prototype.addMesh = function (mesh) {
    this.meshes.push(mesh);
  };

  MergedMeshGroup.prototype.computeBoundingBox = function (matrix, box, treeIndex, geometry) {
    var _this = this;

    box.makeEmpty();
    this.treeIndexMap[treeIndex].forEach(function (mesh) {
      var meshIndex = mesh.meshIndex,
          mappingIndex = mesh.mappingIndex;
      var mergedMesh = _this.meshes[meshIndex];

      if (geometry == null) {
        if (_this.geometry == null) {
          // Geometry may not be loaded yet, skip this geometry.
          return;
        }

        geometry = _this.geometry;
      }

      var triangleCount = mergedMesh.mappings.getTriangleCount(mappingIndex);
      var triangleOffset = mergedMesh.mappings.getTriangleOffset(mappingIndex); // index and position buffer containing the merged mesh

      var index = geometry.getIndex();
      var position = geometry.getAttribute('position');
      computeBoundingBox(globalBox, matrix, position, index, triangleOffset, triangleCount);
      box.union(globalBox);
    });
    return box;
  };

  MergedMeshGroup.prototype.removeTreeIndicesFromMesh = function (treeIndices, mergedMesh) {
    var _this = this;

    var indicesToRemove = {};
    treeIndices.forEach(function (treeIndex) {
      _this.treeIndexMap[treeIndex].forEach(function (mesh) {
        var meshIndex = mesh.meshIndex,
            mappingIndex = mesh.mappingIndex;
        indicesToRemove[mappingIndex] = true;
      });
    });
    mergedMesh.mappings.removeIndices(indicesToRemove);
    this.createTreeIndexMap();
  };

  return MergedMeshGroup;
}(GeometryGroup); // Copyright 2019 Cognite AS


var globalMatrix = new Matrix4();
var globalBox$1 = new Box3();

var InstancedMeshMappings =
/** @class */
function () {
  function InstancedMeshMappings(capacity) {
    this.count = 0;
    this.capacity = capacity;
    this.treeIndex = new Float32Array(this.capacity);
    this.transform0 = new Float32Array(3 * this.capacity);
    this.transform1 = new Float32Array(3 * this.capacity);
    this.transform2 = new Float32Array(3 * this.capacity);
    this.transform3 = new Float32Array(3 * this.capacity);
    this.size = new Float32Array(this.capacity);
  }

  InstancedMeshMappings.prototype.removeIndices = function (indicesToRemove) {
    var newIndex = 0;

    for (var i = 0; i < this.count; i++) {
      if (!indicesToRemove[i]) {
        this.treeIndex[newIndex] = this.treeIndex[i];
        this.transform0[3 * newIndex + 0] = this.transform0[3 * i + 0];
        this.transform0[3 * newIndex + 1] = this.transform0[3 * i + 1];
        this.transform0[3 * newIndex + 2] = this.transform0[3 * i + 2];
        this.transform1[3 * newIndex + 0] = this.transform1[3 * i + 0];
        this.transform1[3 * newIndex + 1] = this.transform1[3 * i + 1];
        this.transform1[3 * newIndex + 2] = this.transform1[3 * i + 2];
        this.transform2[3 * newIndex + 0] = this.transform2[3 * i + 0];
        this.transform2[3 * newIndex + 1] = this.transform2[3 * i + 1];
        this.transform2[3 * newIndex + 2] = this.transform2[3 * i + 2];
        this.transform3[3 * newIndex + 0] = this.transform3[3 * i + 0];
        this.transform3[3 * newIndex + 1] = this.transform3[3 * i + 1];
        this.transform3[3 * newIndex + 2] = this.transform3[3 * i + 2];
        newIndex++;
      }
    }

    this.count = newIndex;
    this.resize(newIndex);
  };

  InstancedMeshMappings.prototype.add = function (nodeId, treeIndex, size, transformMatrix) {
    this.setTreeIndex(treeIndex, this.count);

    if (transformMatrix !== undefined) {
      this.setTransform(transformMatrix, this.count);
    }

    this.setSize(size, this.count);
    this.count += 1;
  };

  InstancedMeshMappings.prototype.getTreeIndex = function (index) {
    return this.treeIndex[index];
  };

  InstancedMeshMappings.prototype.getSize = function (index) {
    return this.size[index];
  };

  InstancedMeshMappings.prototype.getTransformMatrix = function (target, index) {
    var columns = [this.transform0, this.transform1, this.transform2, this.transform3];

    for (var columnIndex = 0; columnIndex < 4; columnIndex++) {
      for (var rowIndex = 0; rowIndex < 3; rowIndex++) {
        var i = 4 * columnIndex + rowIndex;
        target.elements[i] = columns[columnIndex][3 * index + rowIndex];
      }
    }

    target.elements[3] = 0;
    target.elements[7] = 0;
    target.elements[11] = 0;
    target.elements[15] = 1;
    return target;
  };

  InstancedMeshMappings.prototype.resize = function (capacity) {
    // TODO(anders.hafreager) Create proper helper functions to simplify/automate constructor and resize
    if (capacity < this.count) {
      throw new Error('Error, tried to resize InstancedMeshMappings to smaller value than current count.');
    }

    var tmp;
    tmp = this.treeIndex;
    this.treeIndex = new Float32Array(capacity);
    this.treeIndex.set(tmp.subarray(0, this.count), 0);
    tmp = this.size;
    this.size = new Float32Array(capacity);
    this.size.set(tmp.subarray(0, this.count), 0);
    tmp = this.transform0;
    this.transform0 = new Float32Array(3 * capacity);
    this.transform0.set(tmp.subarray(0, 3 * this.count), 0);
    tmp = this.transform1;
    this.transform1 = new Float32Array(3 * capacity);
    this.transform1.set(tmp.subarray(0, 3 * this.count), 0);
    tmp = this.transform2;
    this.transform2 = new Float32Array(3 * capacity);
    this.transform2.set(tmp.subarray(0, 3 * this.count), 0);
    tmp = this.transform3;
    this.transform3 = new Float32Array(3 * capacity);
    this.transform3.set(tmp.subarray(0, 3 * this.count), 0);
    this.capacity = capacity;
  };

  InstancedMeshMappings.prototype.mergeWithMappings = function (otherMappings) {
    // TODO(anders.hafreager) Create proper helper functions automate this
    var newCapacity = this.count + otherMappings.count;
    this.resize(newCapacity);
    this.treeIndex.set(otherMappings.treeIndex.subarray(0, otherMappings.count), this.count);
    this.size.set(otherMappings.size.subarray(0, otherMappings.count), this.count);
    this.transform0.set(otherMappings.transform0.subarray(0, 3 * otherMappings.count), 3 * this.count);
    this.transform1.set(otherMappings.transform1.subarray(0, 3 * otherMappings.count), 3 * this.count);
    this.transform2.set(otherMappings.transform2.subarray(0, 3 * otherMappings.count), 3 * this.count);
    this.transform3.set(otherMappings.transform3.subarray(0, 3 * otherMappings.count), 3 * this.count);
    this.count = newCapacity;
  };

  InstancedMeshMappings.prototype.setSize = function (value, index) {
    this.size[index] = value;
  };

  InstancedMeshMappings.prototype.setTreeIndex = function (value, index) {
    this.treeIndex[index] = value;
  };

  InstancedMeshMappings.prototype.setTransform = function (source, index) {
    var columns = [this.transform0, this.transform1, this.transform2, this.transform3];

    for (var rowIndex = 0; rowIndex < 4; ++rowIndex) {
      for (var colIndex = 0; colIndex < 4; ++colIndex) {
        var matrixIndex = 4 * colIndex + rowIndex; // Each column is an array containing all columns (length 3) for several nodes

        columns[colIndex][3 * index + rowIndex] = source.elements[matrixIndex];
      }
    }
  };

  return InstancedMeshMappings;
}();

var InstancedMeshCollection =
/** @class */
function () {
  function InstancedMeshCollection(triangleOffset, triangleCount, capacity) {
    this.triangleOffset = triangleOffset;
    this.triangleCount = triangleCount;
    this.mappings = new InstancedMeshMappings(capacity);
  }

  InstancedMeshCollection.prototype.addMapping = function (nodeId, treeIndex, size, transformMatrix) {
    this.mappings.add(nodeId, treeIndex, size, transformMatrix);
  };

  return InstancedMeshCollection;
}();

var InstancedMesh =
/** @class */
function () {
  function InstancedMesh(fileId) {
    this.collections = [];
    this.fileId = fileId;
    this.treeIndexMap = {};
    this.collectionByTriangleOffset = {};
  }

  InstancedMesh.prototype.addCollection = function (collection) {
    // A collection is a geometry with a specific triangleOffset in a file.
    // If another collection shares the same file and triangleOffset, we can merge
    // the two collections to render them in the same draw call.
    var existingCollection = this.collectionByTriangleOffset[collection.triangleOffset];

    if (existingCollection != null) {
      existingCollection.mappings.mergeWithMappings(collection.mappings);
    } else {
      this.collections.push(collection);
      this.collectionByTriangleOffset[collection.triangleOffset] = collection;
    }
  };

  return InstancedMesh;
}();

var InstancedMeshGroup =
/** @class */
function (_super) {
  __extends(InstancedMeshGroup, _super);

  function InstancedMeshGroup() {
    var _this = _super.call(this) || this;

    _this.removeTreeIndicesFromCollection = function (treeIndices, collection) {
      var indicesToRemove = {};
      treeIndices.forEach(function (treeIndex) {
        _this.treeIndexMap[treeIndex].forEach(function (mesh) {
          var mappingIndex = mesh.mappingIndex,
              meshIndex = mesh.meshIndex,
              collectionIndex = mesh.collectionIndex;

          if (_this.meshes[meshIndex].collections[collectionIndex] === collection) {
            indicesToRemove[mappingIndex] = true;
          }
        });
      });
      collection.mappings.removeIndices(indicesToRemove);

      _this.createTreeIndexMap();
    };

    _this.meshes = [];
    _this.type = 'InstancedMesh';
    _this.treeIndexMap = {};
    return _this;
  }

  InstancedMeshGroup.prototype.createTreeIndexMap = function () {
    var _this = this;

    this.treeIndexMap = {};
    this.meshes.forEach(function (instancedMesh, meshIndex) {
      instancedMesh.collections.forEach(function (collection, collectionIndex) {
        for (var mappingIndex = 0; mappingIndex < collection.mappings.count; mappingIndex++) {
          var treeIndex = collection.mappings.getTreeIndex(mappingIndex);

          if (_this.treeIndexMap[treeIndex] === undefined) {
            _this.treeIndexMap[treeIndex] = [];
          }

          _this.treeIndexMap[treeIndex].push({
            meshIndex: meshIndex,
            collectionIndex: collectionIndex,
            mappingIndex: mappingIndex
          });
        }
      });
    });
  };

  InstancedMeshGroup.prototype.addMesh = function (mesh) {
    this.meshes.push(mesh);
  };

  InstancedMeshGroup.prototype.computeBoundingBox = function (matrix, box, treeIndex, geometry) {
    var _this = this;

    box.makeEmpty();
    this.treeIndexMap[treeIndex].forEach(function (mesh) {
      var meshIndex = mesh.meshIndex,
          collectionIndex = mesh.collectionIndex,
          mappingIndex = mesh.mappingIndex;
      var instancedMesh = _this.meshes[meshIndex];
      var collection = instancedMesh.collections[collectionIndex];

      if (geometry == null) {
        if (collection.geometry == null) {
          // Geometry may not be loaded yet, skip this geometry.
          return;
        }

        geometry = collection.geometry;
      }

      collection.mappings.getTransformMatrix(globalMatrix, mappingIndex);
      var triangleCount = collection.triangleCount; // TriangleOffset is 0 since each collection contains exactly one geometry

      var index = geometry.getIndex();
      var position = geometry.getAttribute('position');
      globalMatrix.multiplyMatrices(matrix, globalMatrix);
      computeBoundingBox(globalBox$1, globalMatrix, position, index, 0, triangleCount);
      box.union(globalBox$1);
    });
    return box;
  };

  return InstancedMeshGroup;
}(GeometryGroup); // Copyright 2019 Cognite AS


var Sector =
/** @class */
function () {
  function Sector(id, min, max) {
    this.id = id;
    this.min = min;
    this.max = max;
    this.path = '0/';
    this.primitiveGroups = [];
    this.mergedMeshGroup = new MergedMeshGroup();
    this.instancedMeshGroup = new InstancedMeshGroup();
    this.depth = 0;
    this.object3d = new Object3D();
    this.object3d.frustumCulled = false;
    this.children = [];
    this.geometryMap = {};
  }

  Sector.prototype.addChild = function (child) {
    child.parent = this;
    var childPath = this.path + this.children.length.toString() + '/';
    child.path = childPath;
    this.children.push(child);
    child.depth = this.depth + 1;
    this.object3d.add(child.object3d);
  };

  Sector.prototype.traverseSectors = function () {
    var e_1, _a, _b, _c, child, e_1_1;

    return __generator(this, function (_d) {
      switch (_d.label) {
        case 0:
          return [4
          /*yield*/
          , this];

        case 1:
          _d.sent();

          _d.label = 2;

        case 2:
          _d.trys.push([2, 7, 8, 9]);

          _b = __values(this.children), _c = _b.next();
          _d.label = 3;

        case 3:
          if (!!_c.done) return [3
          /*break*/
          , 6];
          child = _c.value;
          return [5
          /*yield**/
          , __values(child.traverseSectors())];

        case 4:
          _d.sent();

          _d.label = 5;

        case 5:
          _c = _b.next();
          return [3
          /*break*/
          , 3];

        case 6:
          return [3
          /*break*/
          , 9];

        case 7:
          e_1_1 = _d.sent();
          e_1 = {
            error: e_1_1
          };
          return [3
          /*break*/
          , 9];

        case 8:
          try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
          } finally {
            if (e_1) throw e_1.error;
          }

          return [7
          /*endfinally*/
          ];

        case 9:
          return [2
          /*return*/
          ];
      }
    });
  };

  Sector.prototype.traverseSectorsBreadthFirst = function () {
    var stack, nextSector;
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          stack = [this];
          _a.label = 1;

        case 1:
          if (!(stack.length > 0)) return [3
          /*break*/
          , 3];
          nextSector = stack.shift();
          nextSector.children.forEach(function (child) {
            stack.push(child);
          });
          return [4
          /*yield*/
          , nextSector];

        case 2:
          _a.sent();

          return [3
          /*break*/
          , 1];

        case 3:
          return [2
          /*return*/
          ];
      }
    });
  };

  Sector.prototype.traversePrimitiveGroups = function () {
    var e_2, _a, e_3, _b, _c, _d, child, _e, _f, geometryGroup, e_3_1, e_2_1;

    return __generator(this, function (_g) {
      switch (_g.label) {
        case 0:
          _g.trys.push([0, 11, 12, 13]);

          _c = __values(this.traverseSectors()), _d = _c.next();
          _g.label = 1;

        case 1:
          if (!!_d.done) return [3
          /*break*/
          , 10];
          child = _d.value;
          _g.label = 2;

        case 2:
          _g.trys.push([2, 7, 8, 9]);

          _e = __values(child.primitiveGroups), _f = _e.next();
          _g.label = 3;

        case 3:
          if (!!_f.done) return [3
          /*break*/
          , 6];
          geometryGroup = _f.value;
          return [4
          /*yield*/
          , geometryGroup];

        case 4:
          _g.sent();

          _g.label = 5;

        case 5:
          _f = _e.next();
          return [3
          /*break*/
          , 3];

        case 6:
          return [3
          /*break*/
          , 9];

        case 7:
          e_3_1 = _g.sent();
          e_3 = {
            error: e_3_1
          };
          return [3
          /*break*/
          , 9];

        case 8:
          try {
            if (_f && !_f.done && (_b = _e.return)) _b.call(_e);
          } finally {
            if (e_3) throw e_3.error;
          }

          return [7
          /*endfinally*/
          ];

        case 9:
          _d = _c.next();
          return [3
          /*break*/
          , 1];

        case 10:
          return [3
          /*break*/
          , 13];

        case 11:
          e_2_1 = _g.sent();
          e_2 = {
            error: e_2_1
          };
          return [3
          /*break*/
          , 13];

        case 12:
          try {
            if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
          } finally {
            if (e_2) throw e_2.error;
          }

          return [7
          /*endfinally*/
          ];

        case 13:
          return [2
          /*return*/
          ];
      }
    });
  };

  Sector.prototype.memoryUsage = function (recursive, usage) {
    if (recursive === void 0) {
      recursive = true;
    }

    var e_4, _a;

    if (usage == null) {
      usage = {
        total: 0,
        byGeometry: {},
        byProperty: {}
      };
    }

    this.primitiveGroups.forEach(function (geometryGroup) {
      geometryGroup.memoryUsage(usage);
    });

    if (this.mergedMeshGroup != null) {
      this.mergedMeshGroup.memoryUsage(usage);
    }

    if (this.instancedMeshGroup != null) {
      this.instancedMeshGroup.memoryUsage(usage);
    }

    if (recursive) {
      try {
        for (var _b = __values(this.traverseSectors()), _c = _b.next(); !_c.done; _c = _b.next()) {
          var child = _c.value;
          child.memoryUsage(false, usage);
        }
      } catch (e_4_1) {
        e_4 = {
          error: e_4_1
        };
      } finally {
        try {
          if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        } finally {
          if (e_4) throw e_4.error;
        }
      }
    }

    return usage;
  };

  return Sector;
}();

var nested = {
  cognite: {
    nested: {
      data: {
        nested: {
          threed: {
            nested: {
              web: {
                options: {
                  java_package: "com.cognite.threedapi.data.web",
                  csharp_namespace: "Cognite.Data.Threed.Web",
                  go_package: "github.com/cognitedata/3d-data/proto"
                },
                nested: {
                  WebScene: {
                    fields: {
                      nodes: {
                        rule: "repeated",
                        type: "WebNode",
                        id: 1
                      }
                    }
                  },
                  WebNode: {
                    fields: {
                      id: {
                        type: "int64",
                        id: 1
                      },
                      path: {
                        type: "string",
                        id: 2
                      },
                      geometries: {
                        rule: "repeated",
                        type: "Geometry",
                        id: 3
                      },
                      boundingBox: {
                        type: "BoundingBox",
                        id: 4
                      }
                    }
                  },
                  Geometry: {
                    fields: {
                      type: {
                        type: "string",
                        id: 1
                      },
                      nodeId: {
                        type: "int64",
                        id: 2,
                        options: {
                          deprecated: true
                        }
                      },
                      file: {
                        rule: "repeated",
                        type: "GeometryFile",
                        id: 3
                      },
                      properties: {
                        type: "GeometryProperties",
                        id: 4,
                        options: {
                          deprecated: true
                        }
                      },
                      primitiveInfo: {
                        type: "PrimitiveInfo",
                        id: 5
                      },
                      nodes: {
                        rule: "repeated",
                        type: "NodeMapping",
                        id: 6
                      },
                      isInstanced: {
                        type: "bool",
                        id: 7
                      }
                    }
                  },
                  GeometryProperties: {
                    fields: {
                      nodeId: {
                        type: "int64",
                        id: 3
                      },
                      treeIndex: {
                        type: "int64",
                        id: 4
                      },
                      color: {
                        type: "Color",
                        id: 1
                      },
                      transformMatrix: {
                        rule: "repeated",
                        type: "float",
                        id: 5
                      }
                    }
                  },
                  NodeMapping: {
                    fields: {
                      fromVertex: {
                        type: "int64",
                        id: 1,
                        options: {
                          deprecated: true
                        }
                      },
                      toVertex: {
                        type: "int64",
                        id: 2,
                        options: {
                          deprecated: true
                        }
                      },
                      triangleOffset: {
                        type: "int64",
                        id: 5
                      },
                      triangleCount: {
                        type: "int64",
                        id: 6
                      },
                      nodeId: {
                        type: "int64",
                        id: 3,
                        options: {
                          deprecated: true
                        }
                      },
                      properties: {
                        rule: "repeated",
                        type: "GeometryProperties",
                        id: 4
                      }
                    }
                  },
                  GeometryFile: {
                    fields: {
                      type: {
                        type: "string",
                        id: 1
                      },
                      fileId: {
                        type: "int64",
                        id: 2
                      }
                    }
                  },
                  Color: {
                    fields: {
                      rgb: {
                        type: "fixed32",
                        id: 1
                      }
                    }
                  },
                  Vector3: {
                    fields: {
                      x: {
                        type: "float",
                        id: 1
                      },
                      y: {
                        type: "float",
                        id: 2
                      },
                      z: {
                        type: "float",
                        id: 3
                      }
                    }
                  },
                  BoundingBox: {
                    fields: {
                      min: {
                        type: "Vector3",
                        id: 1
                      },
                      max: {
                        type: "Vector3",
                        id: 2
                      }
                    }
                  },
                  PrimitiveInfo: {
                    oneofs: {
                      kind: {
                        oneof: ["box", "circle", "cone", "cylinder", "eccentricCone", "extrudedRing", "extrudedRingSegment", "nut", "sphere", "sphericalSegment", "torusSegment", "ring", "ellipsoid", "ellipsoidSegment", "generalCylinder", "jsonPrimitiveInfo"]
                      }
                    },
                    fields: {
                      box: {
                        type: "BoxPrimitiveInfo",
                        id: 2
                      },
                      circle: {
                        type: "CirclePrimitiveInfo",
                        id: 3
                      },
                      cone: {
                        type: "ConePrimitiveInfo",
                        id: 4
                      },
                      cylinder: {
                        type: "CylinderPrimitiveInfo",
                        id: 5
                      },
                      eccentricCone: {
                        type: "EccentricConePrimitiveInfo",
                        id: 6
                      },
                      extrudedRing: {
                        type: "ExtrudedRingPrimitiveInfo",
                        id: 7
                      },
                      extrudedRingSegment: {
                        type: "ExtrudedRingSegmentPrimitiveInfo",
                        id: 8
                      },
                      nut: {
                        type: "NutPrimitiveInfo",
                        id: 13
                      },
                      sphere: {
                        type: "SpherePrimitiveInfo",
                        id: 9
                      },
                      sphericalSegment: {
                        type: "SphericalSegmentPrimitiveInfo",
                        id: 10
                      },
                      torusSegment: {
                        type: "TorusSegmentPrimitiveInfo",
                        id: 11
                      },
                      ring: {
                        type: "RingPrimitiveInfo",
                        id: 12
                      },
                      ellipsoid: {
                        type: "EllipsoidPrimitiveInfo",
                        id: 14
                      },
                      ellipsoidSegment: {
                        type: "EllipsoidSegmentPrimitiveInfo",
                        id: 15
                      },
                      generalCylinder: {
                        type: "GeneralCylinderPrimitiveInfo",
                        id: 16
                      },
                      jsonPrimitiveInfo: {
                        type: "google.protobuf.Struct",
                        id: 18999
                      }
                    },
                    reserved: [[1, 1]]
                  },
                  BoxPrimitiveInfo: {
                    fields: {
                      angle: {
                        type: "float",
                        id: 1
                      },
                      delta: {
                        type: "Vector3",
                        id: 2
                      },
                      center: {
                        type: "Vector3",
                        id: 3
                      },
                      normal: {
                        type: "Vector3",
                        id: 4
                      }
                    }
                  },
                  CirclePrimitiveInfo: {
                    fields: {
                      center: {
                        type: "Vector3",
                        id: 3
                      },
                      normal: {
                        type: "Vector3",
                        id: 4
                      },
                      radius: {
                        type: "float",
                        id: 5
                      }
                    }
                  },
                  ConePrimitiveInfo: {
                    fields: {
                      centerB: {
                        type: "Vector3",
                        id: 6
                      },
                      centerA: {
                        type: "Vector3",
                        id: 7
                      },
                      radiusB: {
                        type: "float",
                        id: 8
                      },
                      radiusA: {
                        type: "float",
                        id: 9
                      },
                      isClosed: {
                        type: "bool",
                        id: 10
                      }
                    }
                  },
                  CylinderPrimitiveInfo: {
                    fields: {
                      radius: {
                        type: "float",
                        id: 5
                      },
                      isClosed: {
                        type: "bool",
                        id: 10
                      },
                      centerB: {
                        type: "Vector3",
                        id: 6
                      },
                      centerA: {
                        type: "Vector3",
                        id: 7
                      }
                    }
                  },
                  EccentricConePrimitiveInfo: {
                    fields: {
                      isClosed: {
                        type: "bool",
                        id: 10
                      },
                      centerB: {
                        type: "Vector3",
                        id: 6
                      },
                      centerA: {
                        type: "Vector3",
                        id: 7
                      },
                      radiusB: {
                        type: "float",
                        id: 8
                      },
                      radiusA: {
                        type: "float",
                        id: 9
                      },
                      normalB: {
                        type: "Vector3",
                        id: 11,
                        options: {
                          deprecated: true
                        }
                      },
                      normalA: {
                        type: "Vector3",
                        id: 12
                      }
                    }
                  },
                  ExtrudedRingPrimitiveInfo: {
                    fields: {
                      centerB: {
                        type: "Vector3",
                        id: 6
                      },
                      centerA: {
                        type: "Vector3",
                        id: 7
                      },
                      innerRadius: {
                        type: "float",
                        id: 8
                      },
                      outerRadius: {
                        type: "float",
                        id: 9
                      }
                    }
                  },
                  ExtrudedRingSegmentPrimitiveInfo: {
                    fields: {
                      isClosed: {
                        type: "bool",
                        id: 10
                      },
                      angle: {
                        type: "float",
                        id: 13
                      },
                      arcAngle: {
                        type: "float",
                        id: 14
                      },
                      centerB: {
                        type: "Vector3",
                        id: 6
                      },
                      centerA: {
                        type: "Vector3",
                        id: 7
                      },
                      innerRadius: {
                        type: "float",
                        id: 8
                      },
                      outerRadius: {
                        type: "float",
                        id: 9
                      }
                    }
                  },
                  MeshPrimitiveInfo: {
                    fields: {}
                  },
                  NutPrimitiveInfo: {
                    fields: {
                      radius: {
                        type: "float",
                        id: 5
                      },
                      centerB: {
                        type: "Vector3",
                        id: 6
                      },
                      centerA: {
                        type: "Vector3",
                        id: 7
                      },
                      rotationAngle: {
                        type: "float",
                        id: 13
                      }
                    }
                  },
                  SpherePrimitiveInfo: {
                    fields: {
                      center: {
                        type: "Vector3",
                        id: 3
                      },
                      radius: {
                        type: "float",
                        id: 5
                      }
                    }
                  },
                  SphericalSegmentPrimitiveInfo: {
                    fields: {
                      center: {
                        type: "Vector3",
                        id: 3
                      },
                      normal: {
                        type: "Vector3",
                        id: 4
                      },
                      radius: {
                        type: "float",
                        id: 5
                      },
                      height: {
                        type: "float",
                        id: 16
                      },
                      isClosed: {
                        type: "bool",
                        id: 10
                      }
                    }
                  },
                  TorusSegmentPrimitiveInfo: {
                    fields: {
                      angle: {
                        type: "float",
                        id: 13
                      },
                      arcAngle: {
                        type: "float",
                        id: 14
                      },
                      center: {
                        type: "Vector3",
                        id: 3
                      },
                      normal: {
                        type: "Vector3",
                        id: 4
                      },
                      radius: {
                        type: "float",
                        id: 5
                      },
                      tubeRadius: {
                        type: "float",
                        id: 17
                      },
                      isClosed: {
                        type: "bool",
                        id: 10
                      }
                    }
                  },
                  RingPrimitiveInfo: {
                    fields: {
                      center: {
                        type: "Vector3",
                        id: 3
                      },
                      normal: {
                        type: "Vector3",
                        id: 4
                      },
                      innerRadius: {
                        type: "float",
                        id: 8
                      },
                      outerRadius: {
                        type: "float",
                        id: 9
                      }
                    }
                  },
                  EllipsoidPrimitiveInfo: {
                    fields: {
                      center: {
                        type: "Vector3",
                        id: 3
                      },
                      normal: {
                        type: "Vector3",
                        id: 4
                      },
                      verticalRadius: {
                        type: "float",
                        id: 8
                      },
                      horizontalRadius: {
                        type: "float",
                        id: 9
                      }
                    }
                  },
                  EllipsoidSegmentPrimitiveInfo: {
                    fields: {
                      center: {
                        type: "Vector3",
                        id: 3
                      },
                      normal: {
                        type: "Vector3",
                        id: 4
                      },
                      height: {
                        type: "float",
                        id: 16
                      },
                      isClosed: {
                        type: "bool",
                        id: 10
                      },
                      verticalRadius: {
                        type: "float",
                        id: 8
                      },
                      horizontalRadius: {
                        type: "float",
                        id: 9
                      }
                    }
                  },
                  GeneralCylinderPrimitiveInfo: {
                    fields: {
                      centerB: {
                        type: "Vector3",
                        id: 1
                      },
                      centerA: {
                        type: "Vector3",
                        id: 2
                      },
                      radiusB: {
                        type: "float",
                        id: 3
                      },
                      radiusA: {
                        type: "float",
                        id: 4
                      },
                      slopeB: {
                        type: "float",
                        id: 5
                      },
                      slopeA: {
                        type: "float",
                        id: 6
                      },
                      zAngleB: {
                        type: "float",
                        id: 7
                      },
                      zAngleA: {
                        type: "float",
                        id: 8
                      },
                      angle: {
                        type: "float",
                        id: 9
                      },
                      arcAngle: {
                        type: "float",
                        id: 10
                      },
                      thickness: {
                        type: "float",
                        id: 11
                      },
                      isClosed: {
                        type: "bool",
                        id: 12
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  },
  google: {
    nested: {
      protobuf: {
        nested: {
          Struct: {
            fields: {
              fields: {
                keyType: "string",
                type: "Value",
                id: 1
              }
            }
          },
          Value: {
            oneofs: {
              kind: {
                oneof: ["nullValue", "numberValue", "stringValue", "boolValue", "structValue", "listValue"]
              }
            },
            fields: {
              nullValue: {
                type: "NullValue",
                id: 1
              },
              numberValue: {
                type: "double",
                id: 2
              },
              stringValue: {
                type: "string",
                id: 3
              },
              boolValue: {
                type: "bool",
                id: 4
              },
              structValue: {
                type: "Struct",
                id: 5
              },
              listValue: {
                type: "ListValue",
                id: 6
              }
            }
          },
          NullValue: {
            values: {
              NULL_VALUE: 0
            }
          },
          ListValue: {
            fields: {
              values: {
                rule: "repeated",
                type: "Value",
                id: 1
              }
            }
          }
        }
      }
    }
  }
};
var web_scene = {
  nested: nested
};
var WebSceneProto =
/*#__PURE__*/
Object.freeze({
  nested: nested,
  default: web_scene
}); // Copyright 2019 Cognite AS

function makeReader(dataArray) {
  return new Reader(dataArray);
}

var ProtobufDecoder =
/** @class */
function () {
  function ProtobufDecoder() {
    this.root = Root.fromJSON(WebSceneProto);
  }

  ProtobufDecoder.prototype.decode = function (type, dataArray) {
    if (type === ProtobufDecoder.Types.WEB_SCENE) {
      return this.decodeWebScene(dataArray);
    }

    var MessageType = this.root.lookupType(type);
    return MessageType.decode(makeReader(dataArray));
  };

  ProtobufDecoder.prototype.decodeWebScene = function (dataArray) {
    var reader, WebNode, t, _a, node;

    return __generator(this, function (_b) {
      switch (_b.label) {
        case 0:
          reader = makeReader(dataArray);
          WebNode = this.root.lookupType(ProtobufDecoder.Types.WEB_NODE);
          _b.label = 1;

        case 1:
          if (!(reader.pos < reader.len)) return [3
          /*break*/
          , 6];
          t = reader.uint32();
          _a = t >>> 3;

          switch (_a) {
            case 1:
              return [3
              /*break*/
              , 2];
          }

          return [3
          /*break*/
          , 4];

        case 2:
          node = WebNode.decode(reader, reader.uint32());
          return [4
          /*yield*/
          , node];

        case 3:
          _b.sent();

          return [3
          /*break*/
          , 5];

        case 4:
          reader.skipType(t & 7);
          _b.label = 5;

        case 5:
          return [3
          /*break*/
          , 1];

        case 6:
          return [2
          /*return*/
          ];
      }
    });
  };

  ProtobufDecoder.Types = {
    WEB_SCENE: 'cognite.data.threed.web.WebScene',
    WEB_NODE: 'cognite.data.threed.web.WebNode'
  };
  return ProtobufDecoder;
}(); // Copyright 2019 Cognite AS
// return undefined if the path represent the root node


function getParentPath(path) {
  if (path.length <= 2) {
    return;
  }

  return path.slice(0, path.length - 2);
} // Copyright 2019 Cognite AS


function sleep(timeout) {
  return new Promise(function (resolve) {
    return setTimeout(resolve, timeout);
  });
} // Copyright 2019 Cognite AS


var matrix = new Matrix4();
var globalBox$2 = new Box3();

var PrimitiveGroup =
/** @class */
function (_super) {
  __extends(PrimitiveGroup, _super);

  function PrimitiveGroup(capacity) {
    var _this = _super.call(this) || this;

    _this.capacity = capacity;
    _this.treeIndexMap = {};
    _this.treeIndex = new Float32Array(_this.capacity);
    _this.transform0 = new Float32Array(0);
    _this.transform1 = new Float32Array(0);
    _this.transform2 = new Float32Array(0);
    _this.transform3 = new Float32Array(0);
    _this.attributes = [];
    _this.hasCustomTransformAttributes = false;
    _this.sorted = false;
    return _this;
  }

  PrimitiveGroup.prototype.setupAttributes = function () {
    var _this = this;

    this.attributes.push({
      name: 'treeIndex',
      array: this.treeIndex,
      itemSize: 1
    });
    primitiveAttributes[this.type].forEach(function (property) {
      _this.attributes.push({
        name: 'a_' + property,
        array: _this.data.arrays[property],
        itemSize: getAttributeItemSize(property)
      });

      if (_this.data.arrays[property] === undefined) {
        throw Error('Primitive attributes issue. Property: ' + property + ', type: ' + _this.type);
      }
    });
  };

  PrimitiveGroup.prototype.filterLastObject = function (nodeId, filterOptions) {
    if (!filterOptions) {
      return true; // Did add this geometry
    }

    var index = this.data.count - 1;
    this.computeBoundingBox(identityMatrix4, globalBox$2, index);
    var boundingBoxFilterResult = filterOptions.boundingBoxFilter && !filterOptions.boundingBoxFilter.intersectsBox(globalBox$2);
    var nodeIdFilterResult = filterOptions.includeNodeIds && filterOptions.includeNodeIds.indexOf(nodeId) === -1;
    var sizeFilterResult = filterOptions.sizeThreshold && globalBox$2.max.distanceTo(globalBox$2.min) < filterOptions.sizeThreshold;

    if (boundingBoxFilterResult || nodeIdFilterResult || sizeFilterResult) {
      // Reduce count, i.e. remove last geometry
      this.data.count -= 1;
      return false; // Did not add this geometry
    }

    return true; // Did add this geometry
  };

  PrimitiveGroup.prototype.setTreeIndex = function (value, index) {
    this.treeIndex[index] = value;
  };

  PrimitiveGroup.prototype.buildTreeIndexMap = function () {
    this.treeIndexMap = {};

    for (var i = 0; i < this.data.count; i++) {
      var treeIndex = this.treeIndex[i];

      if (this.treeIndexMap[treeIndex] === undefined) {
        this.treeIndexMap[treeIndex] = [i];
      } else {
        this.treeIndexMap[treeIndex].push(i);
      }
    }
  };

  PrimitiveGroup.prototype.getTreeIndex = function (index) {
    return this.treeIndex[index];
  };

  PrimitiveGroup.prototype.computeTransformAttributes = function () {
    if (!this.sorted) {
      throw Error('Computing transform attributes before sorting geometries by size');
    }

    if (this.hasCustomTransformAttributes) {
      return;
    } // the 3x4 matrix to the shader.
    // This array has length 4 (four columns in the matrix)
    // and will contain block of 3 numbers (one block per object)


    this.transform0 = new Float32Array(3 * this.data.count);
    this.transform1 = new Float32Array(3 * this.data.count);
    this.transform2 = new Float32Array(3 * this.data.count);
    this.transform3 = new Float32Array(3 * this.data.count);
    var rowIndex = 0;

    for (var i = 0; i < this.data.count; i++) {
      this.computeModelMatrix(matrix, i);

      for (var row = 0; row < 3; row++) {
        var idx = row;
        this.transform0[rowIndex] = matrix.elements[idx];
        idx += 4;
        this.transform1[rowIndex] = matrix.elements[idx];
        idx += 4;
        this.transform2[rowIndex] = matrix.elements[idx];
        idx += 4;
        this.transform3[rowIndex] = matrix.elements[idx];
        rowIndex++;
      }
    }

    this.attributes.push({
      name: 'matCol0',
      array: this.transform0,
      itemSize: 3
    });
    this.attributes.push({
      name: 'matCol1',
      array: this.transform1,
      itemSize: 3
    });
    this.attributes.push({
      name: 'matCol2',
      array: this.transform2,
      itemSize: 3
    });
    this.attributes.push({
      name: 'matCol3',
      array: this.transform3,
      itemSize: 3
    });
  };

  PrimitiveGroup.prototype.sort = function () {
    var _this = this;

    var newIndices = this.data.sort();
    this.capacity = this.data.count;
    var newTreeIndices = new Float32Array(this.capacity);
    newIndices.forEach(function (index, i) {
      newTreeIndices[i] = _this.treeIndex[index];
    });
    this.treeIndex = newTreeIndices;
    this.buildTreeIndexMap();
    this.setupAttributes();
    this.sorted = true;
  };

  return PrimitiveGroup;
}(GeometryGroup); // Copyright 2019 Cognite AS
// reusable variables


var firstRotation = new Quaternion();
var secondRotation = new Quaternion();
var fullMatrix = new Matrix4();
var globalNormal = new Vector3();
var globalDelta = new Vector3();
var globalCenter = new Vector3();
var globalPoint = new Vector3();

var BoxGroup =
/** @class */
function (_super) {
  __extends(BoxGroup, _super);

  function BoxGroup(capacity) {
    var _this = _super.call(this, capacity) || this;

    _this.type = 'Box';
    _this.hasCustomTransformAttributes = false;
    _this.data = new PrimitiveGroupData('Box', capacity);
    return _this;
  }

  BoxGroup.prototype.add = function (nodeId, treeIndex, size, center, normal, angle, delta, filterOptions) {
    this.setTreeIndex(treeIndex, this.data.count);
    this.data.add({
      size: size,
      center: center,
      normal: normal,
      angle: angle,
      delta: delta
    });
    return this.filterLastObject(nodeId, filterOptions);
  };

  BoxGroup.prototype.computeModelMatrix = function (outputMatrix, index) {
    firstRotation.setFromAxisAngle(zAxis, this.data.getNumber('angle', index));
    secondRotation.setFromUnitVectors(zAxis, this.data.getVector3('normal', globalNormal, index));
    var scale = this.data.getVector3('delta', globalDelta, index);
    return outputMatrix.compose(this.data.getVector3('center', globalCenter, index), secondRotation.multiply(firstRotation), // A.multiply(B) === A*B
    scale);
  };

  BoxGroup.prototype.computeBoundingBox = function (matrix, box, index) {
    box.makeEmpty();
    this.computeModelMatrix(fullMatrix, index).premultiply(matrix);
    var coords = [-0.5, 0.5];
    coords.forEach(function (x) {
      return coords.forEach(function (y) {
        return coords.forEach(function (z) {
          return box.expandByPoint(globalPoint.set(x, y, z).applyMatrix4(fullMatrix));
        });
      });
    });
    return box;
  };

  return BoxGroup;
}(PrimitiveGroup); // Copyright 2019 Cognite AS


var hasWarnedAboutMissingColor = false; // reusable variables

var globalVector$1 = new Vector3();

function parsePrimitiveNodeId(data) {
  return Number(data.nodes[0].properties[0].nodeId);
}

function parsePrimitiveTreeIndex(data) {
  return Number(data.nodes[0].properties[0].treeIndex);
}

function parsePrimitiveColor(data) {
  if (data.properties && data.properties.color) {
    return data.properties.color.rgb;
  }

  if (data.nodes[0].properties[0].color) {
    return data.nodes[0].properties[0].color.rgb;
  }

  if (!hasWarnedAboutMissingColor) {
    hasWarnedAboutMissingColor = true; // tslint:disable-next-line:no-console

    console.warn('3d-web-parser encountered node with missing color while loading', '(using #ff00ff to highlight objects with missing color).');
  }

  return 0xff00ff;
}

function getPrimitiveType(primitiveInfo) {
  return Object.keys(primitiveInfo)[0];
}

function isPrimitive(geometry) {
  return geometry.primitiveInfo != null;
}

function normalizeRadians(angle, lowerBound, upperBound) {
  if (lowerBound === void 0) {
    lowerBound = -Math.PI;
  }

  if (upperBound === void 0) {
    upperBound = Math.PI;
  }

  while (angle < lowerBound) {
    angle += 2 * Math.PI;
  }

  while (angle > upperBound) {
    angle -= 2 * Math.PI;
  }

  return angle;
} // this returns angle between 0 and 2π


function angleBetweenVector3s(v1, v2, up) {
  var angle = v1.angleTo(v2);
  var right = globalVector$1.copy(v1).cross(up);
  var moreThanPi = right.dot(v2) < 0;
  return moreThanPi ? 2 * Math.PI - angle : angle;
}

function parseInstancedMeshTransformMatrix(target, transformMatrix) {
  if (transformMatrix.length === 0) {
    target.identity();
    return target;
  }

  var _a = __read(transformMatrix, 12),
      n11 = _a[0],
      n21 = _a[1],
      n31 = _a[2],
      n12 = _a[3],
      n22 = _a[4],
      n32 = _a[5],
      n13 = _a[6],
      n23 = _a[7],
      n33 = _a[8],
      n14 = _a[9],
      n24 = _a[10],
      n34 = _a[11];

  target.set(n11, n12, n13, n14, n21, n22, n23, n24, n31, n32, n33, n34, 0, 0, 0, 1);
  return target;
} // Copyright 2019 Cognite AS


var color = new Color();
var center = new Vector3();
var normal = new Vector3();
var delta = new Vector3();

function findMatchingGeometries(geometries) {
  var matchingGeometries = {
    count: 0,
    geometries: []
  };
  geometries.forEach(function (geometry) {
    if (geometry.type === 'box') {
      matchingGeometries.geometries.push(geometry);
      matchingGeometries.count += 1;
    }
  });
  return matchingGeometries;
}

function parse(args) {
  var geometries = args.geometries,
      filterOptions = args.filterOptions,
      treeIndexNodeIdMap = args.treeIndexNodeIdMap,
      colorMap = args.colorMap;
  var matchingGeometries = findMatchingGeometries(geometries);
  var group = new BoxGroup(matchingGeometries.count);
  matchingGeometries.geometries.forEach(function (geometry) {
    var _a, _b, _c, _d, _e, _f, _g, _h;

    var primitiveInfo = geometry.primitiveInfo[getPrimitiveType(geometry.primitiveInfo)];
    var nodeId = parsePrimitiveNodeId(geometry);
    var treeIndex = parsePrimitiveTreeIndex(geometry);
    color.setHex(parsePrimitiveColor(geometry));
    var _j = primitiveInfo.center,
        _k = _j.x,
        x = _k === void 0 ? 0 : _k,
        _l = _j.y,
        y = _l === void 0 ? 0 : _l,
        _m = _j.z,
        z = _m === void 0 ? 0 : _m;
    center.set(x, y, z);
    _a = primitiveInfo.normal, _b = _a.x, x = _b === void 0 ? 0 : _b, _c = _a.y, y = _c === void 0 ? 0 : _c, _d = _a.z, z = _d === void 0 ? 0 : _d;
    normal.set(x, y, z);
    _e = primitiveInfo.delta, _f = _e.x, x = _f === void 0 ? 0 : _f, _g = _e.y, y = _g === void 0 ? 0 : _g, _h = _e.z, z = _h === void 0 ? 0 : _h;
    delta.set(x, y, z);
    var _o = geometry.primitiveInfo.box.angle,
        angle = _o === void 0 ? 0 : _o;
    var size = Math.sqrt(Math.pow(delta.x, 2) + Math.pow(delta.y, 2) + Math.pow(delta.z, 2));
    var added = group.add(nodeId, treeIndex, size, center, normal, angle, delta, filterOptions);

    if (added) {
      treeIndexNodeIdMap[treeIndex] = nodeId;
      colorMap[treeIndex] = color.clone();
    }
  });
  return group;
} // Copyright 2019 Cognite AS
// reusable variables


var globalDot = new Vector3();
var globalQuaternion = new Quaternion();
var globalNormalMatrix = new Matrix3();
var globalTransformedCenter = new Vector3();
var globalTransformedNormal = new Vector3();
var globalNormal$1 = new Vector3();
var globalCenter$1 = new Vector3();
var globalScale = new Vector3();

function computeCircleBoundingBox(center, normal, radius, box) {
  normal.normalize();
  globalDot.multiplyVectors(normal, normal);
  var twoRadius = 2 * radius;
  var size = globalDot.set(twoRadius * Math.sqrt(1 - globalDot.x), twoRadius * Math.sqrt(1 - globalDot.y), twoRadius * Math.sqrt(1 - globalDot.z));
  return box.setFromCenterAndSize(center, size);
}

var CircleGroup =
/** @class */
function (_super) {
  __extends(CircleGroup, _super);

  function CircleGroup(capacity) {
    var _this = _super.call(this, capacity) || this;

    _this.type = 'Circle';
    _this.data = new PrimitiveGroupData('Circle', capacity);
    return _this;
  }

  CircleGroup.prototype.add = function (nodeId, treeIndex, size, center, normal, radius, filterOptions) {
    this.setTreeIndex(treeIndex, this.data.count);
    this.data.add({
      size: size,
      center: center,
      normal: normal,
      radiusA: radius
    });
    return this.filterLastObject(nodeId, filterOptions);
  };

  CircleGroup.prototype.computeModelMatrix = function (outputMatrix, index) {
    globalQuaternion.setFromUnitVectors(zAxis, this.data.getVector3('normal', globalNormal$1, index));
    var twoRadius = 2 * this.data.getNumber('radiusA', index);
    globalScale.set(twoRadius, twoRadius, 1);
    return outputMatrix.compose(this.data.getVector3('center', globalCenter$1, index), globalQuaternion, // Rotation
    globalScale // Scale
    );
  };

  CircleGroup.prototype.computeBoundingBox = function (matrix, box, index) {
    globalNormalMatrix.setFromMatrix4(matrix);
    globalTransformedCenter.copy(this.data.getVector3('center', globalCenter$1, index)).applyMatrix4(matrix);
    globalTransformedNormal.copy(this.data.getVector3('normal', globalNormal$1, index)).applyMatrix3(globalNormalMatrix);
    var scaling = matrix.getMaxScaleOnAxis();
    var radius = scaling * this.data.getNumber('radiusA', index);
    return computeCircleBoundingBox(globalTransformedCenter, globalTransformedNormal, radius, box);
  };

  return CircleGroup;
}(PrimitiveGroup); // Copyright 2019 Cognite AS


var color$1 = new Color();
var center$1 = new Vector3();
var centerA = new Vector3();
var centerB = new Vector3();
var normal$1 = new Vector3();
var vector = new Vector3();

function findMatchingGeometries$1(geometries) {
  var matchingGeometries = {
    count: 0,
    geometries: []
  };
  geometries.forEach(function (geometry) {
    if (!isPrimitive(geometry)) {
      return;
    }

    var _a = geometry.primitiveInfo[getPrimitiveType(geometry.primitiveInfo)],
        _b = _a.isClosed,
        isClosed = _b === void 0 ? false : _b,
        _c = _a.thickness,
        thickness = _c === void 0 ? 0 : _c;

    if (geometry.type === 'circle') {
      matchingGeometries.geometries.push(geometry);
      matchingGeometries.count += 1;
    } else if (isClosed) {
      // Closed geometries may produce circles
      if (['cylinder', 'eccentricCone'].indexOf(geometry.type) !== -1) {
        // End caps on the cylinder types
        matchingGeometries.geometries.push(geometry);
        matchingGeometries.count += 2;
      } else if (geometry.type === 'cone' && thickness === 0) {
        // End caps on the cone
        matchingGeometries.geometries.push(geometry);
        matchingGeometries.count += 2;
      } else if (geometry.type === 'sphericalSegment') {
        // End cap on spherical segments
        var EPS = 1e-6;
        var _d = geometry.primitiveInfo.sphericalSegment,
            radius = _d.radius,
            height = _d.height;
        var circleRadius = Math.sqrt(height * (2 * radius - height));

        if (circleRadius / radius > EPS) {
          matchingGeometries.geometries.push(geometry);
          matchingGeometries.count += 1;
        }
      } else if (geometry.type === 'ellipsoidSegment') {
        // End cap on ellipsoid segments
        var EPS = 1e-6;
        var _e = geometry.primitiveInfo.ellipsoidSegment,
            verticalRadius = _e.verticalRadius,
            horizontalRadius = _e.horizontalRadius,
            height = _e.height; // Ellipse equation: x^2 / hR ^2 + y^2 / vR^2 = 1

        var y = verticalRadius - height;
        var circleRadius = Math.sqrt(verticalRadius * verticalRadius - y * y) * horizontalRadius / verticalRadius;

        if (circleRadius / horizontalRadius > EPS) {
          matchingGeometries.geometries.push(geometry);
          matchingGeometries.count += 1;
        }
      }
    }
  });
  return matchingGeometries;
}

function parseConeEccentricConeCylinder(geometry, group, filterOptions) {
  var _a, _b, _c, _d, _e, _f, _g, _h;

  var added = false; // @ts-ignore

  var primitiveInfo = geometry.primitiveInfo[getPrimitiveType(geometry.primitiveInfo)];
  var nodeId = parsePrimitiveNodeId(geometry);
  var treeIndex = parsePrimitiveTreeIndex(geometry);
  color$1.setHex(parsePrimitiveColor(geometry));
  var _j = primitiveInfo.centerA,
      _k = _j.x,
      x = _k === void 0 ? 0 : _k,
      _l = _j.y,
      y = _l === void 0 ? 0 : _l,
      _m = _j.z,
      z = _m === void 0 ? 0 : _m;
  centerA.set(x, y, z);
  _a = primitiveInfo.centerB, _b = _a.x, x = _b === void 0 ? 0 : _b, _c = _a.y, y = _c === void 0 ? 0 : _c, _d = _a.z, z = _d === void 0 ? 0 : _d;
  centerB.set(x, y, z); // @ts-ignore

  if (geometry.type === 'cylinder') {
    var _o = primitiveInfo.radius,
        radius = _o === void 0 ? 0 : _o;
    var size = 2 * radius;
    normal$1.copy(centerA).sub(centerB).normalize();
    added = group.add(nodeId, treeIndex, size, centerA, normal$1, radius, filterOptions);
    added = group.add(nodeId, treeIndex, size, centerB, normal$1, radius, filterOptions) || added; // @ts-ignore
  } else if (geometry.type === 'cone') {
    var _p = primitiveInfo.radiusA,
        radiusA = _p === void 0 ? 0 : _p,
        _q = primitiveInfo.radiusB,
        radiusB = _q === void 0 ? 0 : _q;
    var sizeA = 2 * radiusA;
    var sizeB = 2 * radiusB;
    normal$1.copy(centerA).sub(centerB).normalize();
    added = group.add(nodeId, treeIndex, sizeA, centerA, normal$1, radiusA, filterOptions);
    added = group.add(nodeId, treeIndex, sizeB, centerB, normal$1, radiusB, filterOptions) || added; // @ts-ignore
  } else if (geometry.type === 'eccentricCone') {
    var radiusA = primitiveInfo.radiusA,
        radiusB = primitiveInfo.radiusB;
    var sizeA = 2 * radiusA;
    var sizeB = 2 * radiusB;
    _e = primitiveInfo.normalA, _f = _e.x, x = _f === void 0 ? 0 : _f, _g = _e.y, y = _g === void 0 ? 0 : _g, _h = _e.z, z = _h === void 0 ? 0 : _h;
    normal$1.set(x, y, z);
    var dotProduct = normal$1.dot(vector.copy(centerA).sub(centerB));

    if (dotProduct > 0) {
      normal$1.negate();
    }

    added = group.add(nodeId, treeIndex, sizeA, centerA, normal$1, radiusA, filterOptions);
    added = group.add(nodeId, treeIndex, sizeB, centerB, normal$1, radiusB, filterOptions) || added;
  }

  return added;
}

function parse$1(args) {
  var geometries = args.geometries,
      filterOptions = args.filterOptions,
      treeIndexNodeIdMap = args.treeIndexNodeIdMap,
      colorMap = args.colorMap;
  var matchingGeometries = findMatchingGeometries$1(geometries);
  var group = new CircleGroup(matchingGeometries.count);
  matchingGeometries.geometries.forEach(function (geometry) {
    var _a, _b, _c, _d;

    var primitiveInfo = geometry.primitiveInfo[getPrimitiveType(geometry.primitiveInfo)];
    var nodeId = parsePrimitiveNodeId(geometry);
    var treeIndex = parsePrimitiveTreeIndex(geometry);
    color$1.setHex(parsePrimitiveColor(geometry));
    var added = false;

    if (['cylinder', 'cone', 'eccentricCone'].indexOf(geometry.type) !== -1) {
      added = parseConeEccentricConeCylinder(geometry, group, filterOptions);
    } else {
      var _e = primitiveInfo.normal,
          _f = _e.x,
          x = _f === void 0 ? 0 : _f,
          _g = _e.y,
          y = _g === void 0 ? 0 : _g,
          _h = _e.z,
          z = _h === void 0 ? 0 : _h;
      normal$1.set(x, y, z);
      _a = primitiveInfo.center, _b = _a.x, x = _b === void 0 ? 0 : _b, _c = _a.y, y = _c === void 0 ? 0 : _c, _d = _a.z, z = _d === void 0 ? 0 : _d;
      center$1.set(x, y, z);

      if (geometry.type === 'sphericalSegment') {
        var radius = primitiveInfo.radius,
            height = primitiveInfo.height;
        var circleRadius = Math.sqrt(height * (2 * radius - height));
        var size = 2 * circleRadius;
        center$1.add(vector.copy(normal$1).multiplyScalar(radius - height));
        added = group.add(nodeId, treeIndex, size, center$1, normal$1, circleRadius, filterOptions);
      } else if (geometry.type === 'ellipsoidSegment') {
        var verticalRadius = primitiveInfo.verticalRadius,
            horizontalRadius = primitiveInfo.horizontalRadius,
            height = primitiveInfo.height;
        var length_1 = verticalRadius - height;
        var circleRadius = Math.sqrt(verticalRadius * verticalRadius - length_1 * length_1) * horizontalRadius / verticalRadius;
        var size = 2 * circleRadius;
        center$1.add(vector.copy(normal$1).normalize().multiplyScalar(length_1));
        added = group.add(nodeId, treeIndex, size, center$1, normal$1, circleRadius, filterOptions);
      } else {
        // Regular circles
        var radius = primitiveInfo.radius;
        var size = 2 * radius;
        added = group.add(nodeId, treeIndex, size, center$1, normal$1, radius, filterOptions);
      }
    }

    if (added) {
      treeIndexNodeIdMap[treeIndex] = nodeId;
      colorMap[treeIndex] = color$1.clone();
    }
  });
  return group;
} // Copyright 2019 Cognite AS
// reusable variables


var vector1 = new Vector3();
var vector2 = new Vector3();
var center$2 = new Vector3();
var normal$2 = new Vector3();
var normalMatrix = new Matrix3();
var reusableBox = new Box3();
var localXAxis = new Vector3();
var rotation = new Quaternion();

var ConeGroup =
/** @class */
function (_super) {
  __extends(ConeGroup, _super);

  function ConeGroup(capacity) {
    var _this = _super.call(this, capacity) || this;

    _this.type = 'Cone';
    _this.hasCustomTransformAttributes = true;
    _this.data = new PrimitiveGroupData('Cone', capacity);
    return _this;
  }

  ConeGroup.prototype.add = function (nodeId, treeIndex, size, centerA, centerB, radiusA, radiusB, angle, arcAngle, filterOptions) {
    this.setTreeIndex(treeIndex, this.data.count);
    normal$2.subVectors(centerA, centerB).normalize();
    rotation.setFromUnitVectors(zAxis, normal$2);
    localXAxis.copy(xAxis).applyQuaternion(rotation);
    this.data.add({
      size: size,
      centerA: centerA,
      centerB: centerB,
      radiusA: radiusA,
      radiusB: radiusB,
      angle: angle,
      arcAngle: arcAngle,
      localXAxis: localXAxis
    });
    return this.filterLastObject(nodeId, filterOptions);
  };

  ConeGroup.prototype.computeModelMatrix = function (outputMatrix, index) {
    return outputMatrix.identity();
  };

  ConeGroup.prototype.computeBoundingBox = function (matrix, box, index) {
    normalMatrix.setFromMatrix4(matrix);
    var scaling = matrix.getMaxScaleOnAxis();
    normal$2.subVectors(this.data.getVector3('centerA', vector1, index), this.data.getVector3('centerB', vector2, index)).applyMatrix3(normalMatrix).normalize();
    box.makeEmpty(); // A

    center$2.copy(this.data.getVector3('centerA', vector1, index)).applyMatrix4(matrix);
    var radius = scaling * this.data.getNumber('radiusA', index);
    box.union(computeCircleBoundingBox(center$2, normal$2, radius, reusableBox)); // B

    center$2.copy(this.data.getVector3('centerB', vector2, index)).applyMatrix4(matrix);
    radius = scaling * this.data.getNumber('radiusB', index);
    box.union(computeCircleBoundingBox(center$2, normal$2, radius, reusableBox));
    return box;
  };

  return ConeGroup;
}(PrimitiveGroup); // Copyright 2019 Cognite AS


var globalColor = new Color();
var globalCenterA = new Vector3();
var globalCenterB = new Vector3();
var vector$1 = new Vector3();

function findMatchingGeometries$2(geometries) {
  var matchingGeometries = {
    count: 0,
    geometries: []
  };
  geometries.forEach(function (geometry) {
    if (!isPrimitive(geometry)) {
      return;
    }

    var treeIndex = parsePrimitiveTreeIndex(geometry);
    var primitiveInfo = geometry.primitiveInfo[getPrimitiveType(geometry.primitiveInfo)];
    var _a = primitiveInfo.thickness,
        thickness = _a === void 0 ? 0 : _a,
        radiusA = primitiveInfo.radiusA,
        radiusB = primitiveInfo.radiusB;

    if (geometry.type === 'cone' || geometry.type === 'generalCylinder' && radiusA !== radiusB) {
      matchingGeometries.geometries.push(geometry);

      if (thickness > 0) {
        matchingGeometries.count += 2;
      } else {
        matchingGeometries.count += 1;
      }
    } else if (geometry.type === 'cylinder') {
      matchingGeometries.geometries.push(geometry);
      matchingGeometries.count += 1;
    } else if (geometry.type === 'extrudedRing' || geometry.type === 'extrudedRingSegment') {
      matchingGeometries.geometries.push(geometry);
      matchingGeometries.count += 2;
    }
  });
  return matchingGeometries;
}

function parse$2(args) {
  var geometries = args.geometries,
      filterOptions = args.filterOptions,
      treeIndexNodeIdMap = args.treeIndexNodeIdMap,
      colorMap = args.colorMap;
  var matchingGeometries = findMatchingGeometries$2(geometries);
  var group = new ConeGroup(matchingGeometries.count);
  matchingGeometries.geometries.forEach(function (geometry) {
    var _a, _b, _c, _d;

    var added = false;
    var primitiveInfo = geometry.primitiveInfo[getPrimitiveType(geometry.primitiveInfo)];
    var nodeId = parsePrimitiveNodeId(geometry);
    var treeIndex = parsePrimitiveTreeIndex(geometry);
    globalColor.setHex(parsePrimitiveColor(geometry));
    var _e = primitiveInfo.centerA,
        _f = _e.x,
        x = _f === void 0 ? 0 : _f,
        _g = _e.y,
        y = _g === void 0 ? 0 : _g,
        _h = _e.z,
        z = _h === void 0 ? 0 : _h;
    globalCenterA.set(x, y, z);
    _a = primitiveInfo.centerB, _b = _a.x, x = _b === void 0 ? 0 : _b, _c = _a.y, y = _c === void 0 ? 0 : _c, _d = _a.z, z = _d === void 0 ? 0 : _d;
    globalCenterB.set(x, y, z);

    if (geometry.type === 'cylinder') {
      var radius = primitiveInfo.radius;
      var size = Math.sqrt(Math.pow(2 * radius, 2) + Math.pow(globalCenterA.distanceTo(globalCenterB), 2));
      added = group.add(nodeId, treeIndex, size, globalCenterA, globalCenterB, radius, radius, 0, 2 * Math.PI, filterOptions);
    } else if (geometry.type === 'cone' || geometry.type === 'generalCylinder') {
      var radiusA = primitiveInfo.radiusA,
          radiusB = primitiveInfo.radiusB;
      var _j = primitiveInfo.angle,
          angle = _j === void 0 ? 0 : _j,
          _k = primitiveInfo.arcAngle,
          arcAngle = _k === void 0 ? 2.0 * Math.PI : _k,
          _l = primitiveInfo.thickness,
          thickness = _l === void 0 ? 0 : _l;
      var radius = Math.max(radiusA, radiusB);
      var size = Math.sqrt(Math.pow(2 * radius, 2) + Math.pow(globalCenterA.distanceTo(globalCenterB), 2));
      added = group.add(nodeId, treeIndex, size, globalCenterA, globalCenterB, radiusA, radiusB, angle, arcAngle, filterOptions);

      if (thickness > 0) {
        // Create the inner cone if it has a thickness
        radiusA -= thickness;
        radiusB -= thickness;
        added = group.add(nodeId, treeIndex, size, globalCenterA, globalCenterB, radiusA, radiusB, angle, arcAngle, filterOptions) || added;
      }
    } else if (geometry.type === 'extrudedRing' || geometry.type === 'extrudedRingSegment') {
      var innerRadius = primitiveInfo.innerRadius,
          outerRadius = primitiveInfo.outerRadius,
          _m = primitiveInfo.angle,
          angle = _m === void 0 ? 0 : _m,
          _o = primitiveInfo.arcAngle,
          arcAngle = _o === void 0 ? 2.0 * Math.PI : _o;
      var size = Math.sqrt(Math.pow(2 * outerRadius, 2) + Math.pow(globalCenterA.distanceTo(globalCenterB), 2));
      added = group.add(nodeId, treeIndex, size, globalCenterA, globalCenterB, innerRadius, innerRadius, angle, arcAngle, filterOptions);
      added = group.add(nodeId, treeIndex, size, globalCenterA, globalCenterB, outerRadius, outerRadius, angle, arcAngle, filterOptions) || added;
    }

    if (added) {
      treeIndexNodeIdMap[treeIndex] = nodeId;
      colorMap[treeIndex] = globalColor.clone();
    }
  });
  return group;
} // Copyright 2019 Cognite AS
// reusable variables


var globalNormalMatrix$1 = new Matrix3();
var globalReusableBox = new Box3();
var globalCenter$2 = new Vector3();
var globalNormal$2 = new Vector3();
var globalCenterA$1 = new Vector3();
var globalCenterB$1 = new Vector3();

var EccentricConeGroup =
/** @class */
function (_super) {
  __extends(EccentricConeGroup, _super);

  function EccentricConeGroup(capacity) {
    var _this = _super.call(this, capacity) || this;

    _this.type = 'EccentricCone';
    _this.hasCustomTransformAttributes = true;
    _this.data = new PrimitiveGroupData('EccentricCone', capacity);
    return _this;
  }

  EccentricConeGroup.prototype.add = function (nodeId, treeIndex, size, centerA, centerB, radiusA, radiusB, normal, filterOptions) {
    this.setTreeIndex(treeIndex, this.data.count);
    this.data.add({
      size: size,
      centerA: centerA,
      centerB: centerB,
      radiusA: radiusA,
      radiusB: radiusB,
      normal: normal
    });
    return this.filterLastObject(nodeId, filterOptions);
  };

  EccentricConeGroup.prototype.computeModelMatrix = function (outputMatrix, index) {
    return outputMatrix.identity();
  };

  EccentricConeGroup.prototype.computeBoundingBox = function (matrix, box, index) {
    globalNormalMatrix$1.setFromMatrix4(matrix);
    var scaling = matrix.getMaxScaleOnAxis();
    box.makeEmpty();
    globalNormal$2.copy(this.data.getVector3('normal', globalNormal$2, index)).applyMatrix3(globalNormalMatrix$1).normalize(); // A

    globalCenter$2.copy(this.data.getVector3('centerA', globalCenterA$1, index)).applyMatrix4(matrix);
    var radius = scaling * this.data.getNumber('radiusA', index);
    box.union(computeCircleBoundingBox(globalCenter$2, globalNormal$2, radius, globalReusableBox)); // B

    globalCenter$2.copy(this.data.getVector3('centerB', globalCenterB$1, index)).applyMatrix4(matrix);
    radius = scaling * this.data.getNumber('radiusB', index);
    box.union(computeCircleBoundingBox(globalCenter$2, globalNormal$2, radius, globalReusableBox));
    return box;
  };

  return EccentricConeGroup;
}(PrimitiveGroup); // Copyright 2019 Cognite AS


var color$2 = new Color();
var centerA$1 = new Vector3();
var centerB$1 = new Vector3();
var normal$3 = new Vector3();
var vector$2 = new Vector3();

function findMatchingGeometries$3(geometries) {
  var matchingGeometries = {
    count: 0,
    geometries: []
  };
  geometries.forEach(function (geometry) {
    if (geometry.type === 'eccentricCone') {
      matchingGeometries.geometries.push(geometry);
      matchingGeometries.count += 1;
    }
  });
  return matchingGeometries;
}

function parse$3(args) {
  var geometries = args.geometries,
      filterOptions = args.filterOptions,
      treeIndexNodeIdMap = args.treeIndexNodeIdMap,
      colorMap = args.colorMap;
  var matchingGeometries = findMatchingGeometries$3(geometries);
  var group = new EccentricConeGroup(matchingGeometries.count);
  matchingGeometries.geometries.forEach(function (geometry) {
    var _a, _b, _c, _d, _e, _f, _g, _h;

    var primitiveInfo = geometry.primitiveInfo[getPrimitiveType(geometry.primitiveInfo)];
    var nodeId = parsePrimitiveNodeId(geometry);
    var treeIndex = parsePrimitiveTreeIndex(geometry);
    color$2.setHex(parsePrimitiveColor(geometry));
    var _j = primitiveInfo.centerA,
        _k = _j.x,
        x = _k === void 0 ? 0 : _k,
        _l = _j.y,
        y = _l === void 0 ? 0 : _l,
        _m = _j.z,
        z = _m === void 0 ? 0 : _m;
    centerA$1.set(x, y, z);
    _a = primitiveInfo.centerB, _b = _a.x, x = _b === void 0 ? 0 : _b, _c = _a.y, y = _c === void 0 ? 0 : _c, _d = _a.z, z = _d === void 0 ? 0 : _d;
    centerB$1.set(x, y, z);
    var radiusA = primitiveInfo.radiusA,
        radiusB = primitiveInfo.radiusB;
    _e = primitiveInfo.normalA, _f = _e.x, x = _f === void 0 ? 0 : _f, _g = _e.y, y = _g === void 0 ? 0 : _g, _h = _e.z, z = _h === void 0 ? 0 : _h;
    normal$3.set(x, y, z);
    var dotProduct = normal$3.dot(vector$2.copy(centerA$1).sub(centerB$1));

    if (dotProduct < 0) {
      normal$3.negate();
    }

    var radius = Math.max(radiusA, radiusB);
    var size = Math.sqrt(Math.pow(2 * radius, 2) + Math.pow(centerA$1.distanceTo(centerB$1), 2));
    var added = group.add(nodeId, treeIndex, size, centerA$1, centerB$1, radiusA, radiusB, normal$3, filterOptions);

    if (added) {
      treeIndexNodeIdMap[treeIndex] = nodeId;
      colorMap[treeIndex] = color$2.clone();
    }
  });
  return group;
} // Copyright 2019 Cognite AS
// reusable variables


var rotation$1 = new Quaternion();
var scale = new Vector3();
var SI = new Matrix4();
var M = new Matrix4();
var MT = new Matrix4();
var boundingBoxCenter = new Vector3();
var sizeVector = new Vector3();
var arr = new Array(16); // reusable variables

var globalNormalMatrix$2 = new Matrix3();
var globalTransformedCenter$1 = new Vector3();
var globalTransformedNormal$1 = new Vector3();
var globalCircleCenter = new Vector3();
var globalReusableBox$1 = new Box3();
var globalCenter$3 = new Vector3();
var globalNormal$3 = new Vector3(); // (haowei.guo) I found this ellipsoid bounding box algorithm from stackoverflow
// https://stackoverflow.com/questions/4368961/calculating-an-aabb-for-a-transformed-sphere/4369956#4369956

function computeEllipsoidBoundingBox(center, normal, xRadius, yRadius, zRadius, matrix, box) {
  // Always setting this because angular optimizations by mistake optimizes out this line
  // if placed outside the function call.
  SI.set(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, -1);
  rotation$1.setFromUnitVectors(zAxis, normal);
  scale.set(2 * xRadius, 2 * yRadius, 2 * zRadius);
  M.compose(center, rotation$1, scale).premultiply(matrix);
  MT.copy(M).transpose();
  M.multiply(SI);
  M.multiply(MT); // @ts-ignore

  M.toArray(arr);
  var r11 = arr[0];
  var r14 = arr[3];
  var r22 = arr[5];
  var r24 = arr[7];
  var r33 = arr[10];
  var r34 = arr[11];
  var r44 = arr[15];
  boundingBoxCenter.set(r14 / r44, r24 / r44, r34 / r44);
  sizeVector.set(Math.abs(Math.sqrt(r14 * r14 - r44 * r11) / r44), Math.abs(Math.sqrt(r24 * r24 - r44 * r22) / r44), Math.abs(Math.sqrt(r34 * r34 - r44 * r33) / r44));
  box.setFromCenterAndSize(boundingBoxCenter, sizeVector);
  return box;
}

var EllipsoidSegmentGroup =
/** @class */
function (_super) {
  __extends(EllipsoidSegmentGroup, _super);

  function EllipsoidSegmentGroup(capacity) {
    var _this = _super.call(this, capacity) || this;

    _this.type = 'EllipsoidSegment';
    _this.hasCustomTransformAttributes = true;
    _this.data = new PrimitiveGroupData('EllipsoidSegment', capacity);
    return _this;
  }

  EllipsoidSegmentGroup.prototype.add = function (nodeId, treeIndex, size, center, normal, horizontalRadius, verticalRadius, height, filterOptions) {
    this.setTreeIndex(treeIndex, this.data.count);
    this.data.add({
      size: size,
      center: center,
      normal: normal,
      hRadius: horizontalRadius,
      vRadius: verticalRadius,
      height: height
    });
    return this.filterLastObject(nodeId, filterOptions);
  };

  EllipsoidSegmentGroup.prototype.computeModelMatrix = function (outputMatrix, index) {
    return outputMatrix.identity();
  };

  EllipsoidSegmentGroup.prototype.computeBoundingBox = function (matrix, box, index) {
    box.makeEmpty();
    globalNormalMatrix$2.setFromMatrix4(matrix);
    globalTransformedCenter$1.copy(this.data.getVector3('center', globalCenter$3, index)).applyMatrix4(matrix);
    globalTransformedNormal$1.copy(this.data.getVector3('normal', globalNormal$3, index)).applyMatrix3(globalNormalMatrix$2).normalize();
    var height = this.data.getNumber('height', index);
    var hRadius = this.data.getNumber('hRadius', index);
    var vRadius = this.data.getNumber('vRadius', index);
    var segments = 16;
    var step = hRadius / segments;

    for (var z = vRadius - height; z < vRadius; z += step) {
      var circleRadius = Math.sqrt(vRadius * vRadius - z * z) * hRadius / vRadius;
      globalCircleCenter.copy(globalTransformedNormal$1).multiplyScalar(z).add(globalTransformedCenter$1);
      box.union(computeCircleBoundingBox(globalCircleCenter, globalTransformedNormal$1, circleRadius, globalReusableBox$1));
    } // union the point which maximizes z


    box.expandByPoint(globalCircleCenter.copy(globalTransformedNormal$1).multiplyScalar(vRadius).add(globalTransformedCenter$1));
    return box;
  };

  return EllipsoidSegmentGroup;
}(PrimitiveGroup); // Copyright 2019 Cognite AS


var color$3 = new Color();
var center$3 = new Vector3();
var normal$4 = new Vector3();

function findMatchingGeometries$4(geometries) {
  var matchingGeometries = {
    count: 0,
    geometries: []
  };
  geometries.forEach(function (geometry) {
    if (geometry.type === 'ellipsoid' || geometry.type === 'ellipsoidSegment') {
      matchingGeometries.geometries.push(geometry);
      matchingGeometries.count += 1;
    }
  });
  return matchingGeometries;
}

function parse$4(args) {
  var geometries = args.geometries,
      filterOptions = args.filterOptions,
      treeIndexNodeIdMap = args.treeIndexNodeIdMap,
      colorMap = args.colorMap;
  var matchingGeometries = findMatchingGeometries$4(geometries);
  var group = new EllipsoidSegmentGroup(matchingGeometries.count);
  matchingGeometries.geometries.forEach(function (geometry) {
    var _a, _b, _c, _d;

    var primitiveInfo = geometry.primitiveInfo[getPrimitiveType(geometry.primitiveInfo)];
    var nodeId = parsePrimitiveNodeId(geometry);
    var treeIndex = parsePrimitiveTreeIndex(geometry);
    color$3.setHex(parsePrimitiveColor(geometry));
    var _e = primitiveInfo.center,
        _f = _e.x,
        x = _f === void 0 ? 0 : _f,
        _g = _e.y,
        y = _g === void 0 ? 0 : _g,
        _h = _e.z,
        z = _h === void 0 ? 0 : _h;
    center$3.set(x, y, z);
    _a = primitiveInfo.normal, _b = _a.x, x = _b === void 0 ? 0 : _b, _c = _a.y, y = _c === void 0 ? 0 : _c, _d = _a.z, z = _d === void 0 ? 0 : _d;
    normal$4.set(x, y, z);
    var horizontalRadius = primitiveInfo.horizontalRadius,
        verticalRadius = primitiveInfo.verticalRadius;
    var height = 2 * verticalRadius; // Default value for ellipsoids

    if (geometry.type === 'ellipsoidSegment') {
      height = primitiveInfo.height;
    }

    var size = Math.sqrt(Math.pow(2 * horizontalRadius, 2) + Math.pow(height, 2));
    var added = group.add(nodeId, treeIndex, size, center$3, normal$4, horizontalRadius, verticalRadius, height, filterOptions);

    if (added) {
      treeIndexNodeIdMap[treeIndex] = nodeId;
      colorMap[treeIndex] = color$3.clone();
    }
  });
  return group;
} // Copyright 2019 Cognite AS


var globalBox$3 = new Box3();
var normal$5 = new Vector3();
var ringCenterA = new Vector3();
var ringCenterB = new Vector3();
var extA = new Vector3();
var extB = new Vector3();
var planeA = new Vector4();
var planeB = new Vector4();
var capNormalA = new Vector3();
var capNormalB = new Vector3();
var localXAxis$1 = new Vector3();
var globalRotation = new Quaternion();
var globalSlicingPlaneNormal = new Vector3();

var GeneralCylinderGroup =
/** @class */
function (_super) {
  __extends(GeneralCylinderGroup, _super);

  function GeneralCylinderGroup(capacity) {
    var _this = _super.call(this, capacity) || this;

    _this.type = 'GeneralCylinder';
    _this.hasCustomTransformAttributes = true;
    _this.data = new PrimitiveGroupData('GeneralCylinder', capacity);
    return _this;
  }

  GeneralCylinderGroup.slicingPlane = function (target, slope, zAngle, height, invertNormal) {
    globalSlicingPlaneNormal.copy(zAxis).applyAxisAngle(yAxis, slope).applyAxisAngle(zAxis, zAngle);

    if (invertNormal) {
      globalSlicingPlaneNormal.negate();
    }

    target.set(globalSlicingPlaneNormal.x, globalSlicingPlaneNormal.y, globalSlicingPlaneNormal.z, height);
  };

  GeneralCylinderGroup.prototype.add = function (nodeId, treeIndex, size, centerA, centerB, radius, heightA, heightB, slopeA, slopeB, zAngleA, zAngleB, angle, arcAngle, filterOptions) {
    if (angle === void 0) {
      angle = 0;
    }

    if (arcAngle === void 0) {
      arcAngle = Math.PI * 2.0;
    }

    normal$5.subVectors(centerA, centerB).normalize();
    globalRotation.setFromUnitVectors(zAxis, normal$5); // Calculate global plane (also used to calculate normal A and B)

    GeneralCylinderGroup.slicingPlane(planeA, slopeA, zAngleA, heightA, false);
    capNormalA.set(planeA.x, planeA.y, planeA.z).applyQuaternion(globalRotation);
    GeneralCylinderGroup.slicingPlane(planeB, slopeB, zAngleB, heightB, true);
    capNormalB.set(planeB.x, planeB.y, planeB.z).applyQuaternion(globalRotation);
    localXAxis$1.copy(xAxis).applyQuaternion(globalRotation);
    this.setTreeIndex(treeIndex, this.data.count);
    this.data.add({
      size: size,
      centerA: centerA,
      centerB: centerB,
      radiusA: radius,
      heightA: heightA,
      heightB: heightB,
      slopeA: slopeA,
      slopeB: slopeB,
      zAngleA: zAngleA,
      zAngleB: zAngleB,
      angle: angle,
      planeA: planeA,
      planeB: planeB,
      arcAngle: arcAngle,
      capNormalA: capNormalA,
      capNormalB: capNormalB,
      localXAxis: localXAxis$1
    });
    return this.filterLastObject(nodeId, filterOptions);
  };

  GeneralCylinderGroup.prototype.computeModelMatrix = function (outputMatrix, index) {
    return outputMatrix;
  };

  GeneralCylinderGroup.prototype.computeBoundingBox = function (matrix, box, index) {
    box.makeEmpty();
    globalBox$3.makeEmpty();
    this.data.getVector3('centerA', extA, index);
    this.data.getVector3('centerB', extB, index);
    normal$5.copy(extA).sub(extB).normalize();
    var distFromAToExtA = this.data.getNumber('radiusA', index) * Math.tan(this.data.getNumber('slopeA', index));
    var distFromBToExtB = this.data.getNumber('radiusA', index) * Math.tan(this.data.getNumber('slopeB', index));
    ringCenterA.copy(normal$5).multiplyScalar(-distFromAToExtA).add(extA);
    ringCenterB.copy(normal$5).multiplyScalar(distFromBToExtB).add(extB);
    computeEllipsoidBoundingBox(ringCenterA, this.data.getVector3('capNormalA', capNormalA, index), this.data.getNumber('radiusA', index), this.data.getNumber('radiusA', index) / Math.abs(Math.cos(this.data.getNumber('slopeA', index))), 0, matrix, globalBox$3);
    box.union(globalBox$3);
    globalBox$3.makeEmpty();
    computeEllipsoidBoundingBox(ringCenterB, this.data.getVector3('capNormalB', capNormalB, index), this.data.getNumber('radiusA', index), this.data.getNumber('radiusA', index) / Math.abs(Math.cos(this.data.getNumber('slopeB', index))), 0, matrix, globalBox$3);
    box.union(globalBox$3);
    return box;
  };

  return GeneralCylinderGroup;
}(PrimitiveGroup); // Copyright 2019 Cognite AS
// reusable variables


var color$4 = new Color();
var centerA$2 = new Vector3();
var centerB$2 = new Vector3();
var extA$1 = new Vector3();
var extB$1 = new Vector3();
var globalRotation$1 = new Quaternion();
var slicingPlane = new Vector4();
var globalAxis = new Vector3();
var vertex = new Vector3();
var planes = [new Plane(), new Plane()];
var line = new Line3();
var lineStart = new Vector3();
var lineEnd = new Vector3();

function findMatchingGeometries$5(geometries) {
  var matchingGeometries = {
    count: 0,
    geometries: []
  };
  geometries.forEach(function (geometry) {
    if (!isPrimitive(geometry)) {
      return;
    }

    var primitiveInfo = geometry.primitiveInfo[getPrimitiveType(geometry.primitiveInfo)];
    var _a = primitiveInfo.thickness,
        thickness = _a === void 0 ? 0 : _a,
        radiusA = primitiveInfo.radiusA,
        radiusB = primitiveInfo.radiusB;

    if (geometry.type === 'generalCylinder' && radiusA === radiusB) {
      // A cone is produced if radii are different
      matchingGeometries.geometries.push(geometry);
      matchingGeometries.count += 1;

      if (thickness > 0) {
        matchingGeometries.count += 1;
      }
    }
  });
  return matchingGeometries;
}

function parse$5(args) {
  var geometries = args.geometries,
      filterOptions = args.filterOptions,
      treeIndexNodeIdMap = args.treeIndexNodeIdMap,
      colorMap = args.colorMap;
  var matchingGeometries = findMatchingGeometries$5(geometries);
  var group = new GeneralCylinderGroup(matchingGeometries.count);
  matchingGeometries.geometries.forEach(function (geometry) {
    var _a, _b, _c, _d;

    var added = false;
    var primitiveInfo = geometry.primitiveInfo[getPrimitiveType(geometry.primitiveInfo)];
    var nodeId = parsePrimitiveNodeId(geometry);
    var treeIndex = parsePrimitiveTreeIndex(geometry);
    color$4.setHex(parsePrimitiveColor(geometry));
    var _e = primitiveInfo.centerA,
        _f = _e.x,
        x = _f === void 0 ? 0 : _f,
        _g = _e.y,
        y = _g === void 0 ? 0 : _g,
        _h = _e.z,
        z = _h === void 0 ? 0 : _h;
    centerA$2.set(x, y, z);
    _a = primitiveInfo.centerB, _b = _a.x, x = _b === void 0 ? 0 : _b, _c = _a.y, y = _c === void 0 ? 0 : _c, _d = _a.z, z = _d === void 0 ? 0 : _d;
    centerB$2.set(x, y, z);
    var radiusA = primitiveInfo.radiusA,
        radiusB = primitiveInfo.radiusB,
        _j = primitiveInfo.arcAngle,
        arcAngle = _j === void 0 ? 2.0 * Math.PI : _j,
        _k = primitiveInfo.slopeA,
        slopeA = _k === void 0 ? 0 : _k,
        _l = primitiveInfo.slopeB,
        slopeB = _l === void 0 ? 0 : _l,
        _m = primitiveInfo.zAngleA,
        zAngleA = _m === void 0 ? 0 : _m,
        _o = primitiveInfo.zAngleB,
        zAngleB = _o === void 0 ? 0 : _o,
        _p = primitiveInfo.isClosed,
        isClosed = _p === void 0 ? false : _p;
    var _q = primitiveInfo.angle,
        angle = _q === void 0 ? 0 : _q;
    angle = normalizeRadians(angle);
    var thickness = primitiveInfo.thickness || (isClosed ? radiusA : 0);
    globalAxis.subVectors(centerA$2, centerB$2);
    var distFromBToA = globalAxis.length();
    globalRotation$1.setFromUnitVectors(zAxis, globalAxis.normalize());
    var distFromAToExtA = radiusA * Math.tan(slopeA);
    var distFromBToExtB = radiusA * Math.tan(slopeB);
    var heightA = distFromBToExtB + distFromBToA;
    var heightB = distFromBToExtB;
    extA$1.copy(globalAxis).multiplyScalar(distFromAToExtA).add(centerA$2);
    extB$1.copy(globalAxis).multiplyScalar(-distFromBToExtB).add(centerB$2);
    var size = Math.sqrt(Math.pow(2 * radiusA, 2) + Math.pow(centerA$2.distanceTo(centerB$2), 2));
    added = group.add(nodeId, treeIndex, size, extA$1, extB$1, radiusA, heightA, heightB, slopeA, slopeB, zAngleA, zAngleB, angle, arcAngle, filterOptions);

    if (thickness > 0) {
      if (thickness !== radiusA) {
        added = group.add(nodeId, treeIndex, size, extA$1, extB$1, radiusA - thickness, heightA, heightB, slopeA, slopeB, zAngleA, zAngleB, angle, arcAngle, filterOptions) || added;
      }
    }

    if (added) {
      treeIndexNodeIdMap[treeIndex] = nodeId;
      colorMap[treeIndex] = color$4.clone();
    }
  });
  return group;
} // Copyright 2019 Cognite AS
// reusable variables


var rotation$2 = new Quaternion();
var scale$1 = new Vector3();
var rotationMatrix = new Matrix4();
var localYAxis = new Vector3();
var globalNormal$4 = new Vector3();
var globalLocalXAxis = new Vector3();
var globalCenter$4 = new Vector3();

var GeneralRingGroup =
/** @class */
function (_super) {
  __extends(GeneralRingGroup, _super);

  function GeneralRingGroup(capacity) {
    var _this = _super.call(this, capacity) || this;

    _this.type = 'GeneralRing';
    _this.hasCustomTransformAttributes = false;
    _this.data = new PrimitiveGroupData('GeneralRing', capacity);
    return _this;
  }

  GeneralRingGroup.prototype.add = function (nodeId, treeIndex, size, center, normal, localXAxis, xRadius, yRadius, thickness, angle, arcAngle, filterOptions) {
    this.setTreeIndex(treeIndex, this.data.count);
    this.data.add({
      size: size,
      center: center,
      normal: normal,
      localXAxis: localXAxis,
      radiusA: xRadius,
      radiusB: yRadius,
      thickness: thickness / yRadius,
      angle: angle,
      arcAngle: arcAngle
    });
    return this.filterLastObject(nodeId, filterOptions);
  };

  GeneralRingGroup.prototype.computeModelMatrix = function (outputMatrix, index) {
    this.data.getVector3('normal', globalNormal$4, index);
    this.data.getVector3('localXAxis', globalLocalXAxis, index);
    localYAxis.crossVectors(this.data.getVector3('normal', globalNormal$4, index), this.data.getVector3('localXAxis', globalLocalXAxis, index));
    rotationMatrix.set(globalLocalXAxis.x, localYAxis.x, globalNormal$4.x, 0, globalLocalXAxis.y, localYAxis.y, globalNormal$4.y, 0, globalLocalXAxis.z, localYAxis.z, globalNormal$4.z, 0, 0, 0, 0, 1);
    rotation$2.setFromRotationMatrix(rotationMatrix);
    scale$1.set(2 * this.data.getNumber('radiusA', index), 2 * this.data.getNumber('radiusB', index), 1);
    return outputMatrix.compose(this.data.getVector3('center', globalCenter$4, index), rotation$2, scale$1);
  };

  GeneralRingGroup.prototype.computeBoundingBox = function (matrix, box, index) {
    return computeEllipsoidBoundingBox(this.data.getVector3('center', globalCenter$4, index), this.data.getVector3('normal', globalNormal$4, index), this.data.getNumber('radiusA', index), this.data.getNumber('radiusB', index), 0, matrix, box);
  };

  return GeneralRingGroup;
}(PrimitiveGroup); // Copyright 2019 Cognite AS


var globalColor$1 = new Color();
var globalCenter$5 = new Vector3();
var globalCenterA$2 = new Vector3();
var globalCenterB$2 = new Vector3();
var globalCapZAxis = new Vector3();
var globalCapXAxis = new Vector3();
var globalNormal$5 = new Vector3();
var globalLocalXAxis$1 = new Vector3();
var globalSlicingPlane = new Vector4();
var globalAxis$1 = new Vector3();
var globalVertex = new Vector3();
var globalRotation$2 = new Quaternion();
var globalPlanes = [new Plane(), new Plane()];
var globalExtA = new Vector3();
var globalExtB = new Vector3();
var globalLine = new Line3();
var globalLineStart = new Vector3();
var globalLineEnd = new Vector3();

function findMatchingGeometries$6(geometries) {
  var matchingGeometries = {
    count: 0,
    geometries: []
  };
  geometries.forEach(function (geometry) {
    if (!isPrimitive(geometry)) {
      return;
    }

    var treeIndex = parsePrimitiveTreeIndex(geometry);
    var primitiveInfo = geometry.primitiveInfo[getPrimitiveType(geometry.primitiveInfo)];
    var _a = primitiveInfo.thickness,
        thickness = _a === void 0 ? 0 : _a;

    if (geometry.type === 'ring') {
      matchingGeometries.geometries.push(geometry);
      matchingGeometries.count += 1;
    } else if (geometry.type === 'extrudedRing' || geometry.type === 'extrudedRingSegment' || geometry.type === 'generalCylinder' || geometry.type === 'cone' && thickness > 0) {
      matchingGeometries.geometries.push(geometry);
      matchingGeometries.count += 2;
    }
  });
  return matchingGeometries;
}

function parseRing(primitiveInfo, nodeId, treeIndex, group, filterOptions) {
  var _a, _b, _c, _d;

  var _e = primitiveInfo.center,
      _f = _e.x,
      x = _f === void 0 ? 0 : _f,
      _g = _e.y,
      y = _g === void 0 ? 0 : _g,
      _h = _e.z,
      z = _h === void 0 ? 0 : _h;
  globalCenter$5.set(x, y, z);
  _a = primitiveInfo.normal, _b = _a.x, x = _b === void 0 ? 0 : _b, _c = _a.y, y = _c === void 0 ? 0 : _c, _d = _a.z, z = _d === void 0 ? 0 : _d;
  globalNormal$5.set(x, y, z);
  var innerRadius = primitiveInfo.innerRadius,
      outerRadius = primitiveInfo.outerRadius;
  globalLocalXAxis$1.copy(xAxis).applyQuaternion(globalRotation$2.setFromUnitVectors(zAxis, globalNormal$5));
  var size = Math.sqrt(Math.pow(2 * outerRadius, 2) + Math.pow(globalCenterA$2.distanceTo(globalCenterB$2), 2));
  return group.add(nodeId, treeIndex, size, globalCenter$5, globalNormal$5, globalLocalXAxis$1, outerRadius, outerRadius, outerRadius - innerRadius, 0, 2 * Math.PI, filterOptions);
}

function parseCone(primitiveInfo, nodeId, treeIndex, group, filterOptions) {
  var _a, _b, _c, _d;

  var _e = primitiveInfo.centerA,
      _f = _e.x,
      x = _f === void 0 ? 0 : _f,
      _g = _e.y,
      y = _g === void 0 ? 0 : _g,
      _h = _e.z,
      z = _h === void 0 ? 0 : _h;
  globalCenterA$2.set(x, y, z);
  _a = primitiveInfo.centerB, _b = _a.x, x = _b === void 0 ? 0 : _b, _c = _a.y, y = _c === void 0 ? 0 : _c, _d = _a.z, z = _d === void 0 ? 0 : _d;
  globalCenterB$2.set(x, y, z);
  globalCapZAxis.copy(globalCenterA$2).sub(globalCenterB$2);
  globalRotation$2.setFromUnitVectors(zAxis, globalCapZAxis.normalize());
  globalCapXAxis.copy(xAxis).applyQuaternion(globalRotation$2);
  var _j = primitiveInfo.angle,
      angle = _j === void 0 ? 0 : _j,
      _k = primitiveInfo.arcAngle,
      arcAngle = _k === void 0 ? 2 * Math.PI : _k,
      radiusA = primitiveInfo.radiusA,
      radiusB = primitiveInfo.radiusB,
      _l = primitiveInfo.thickness,
      thickness = _l === void 0 ? 0 : _l;
  var radius = Math.max(radiusA, radiusB);
  var size = Math.sqrt(Math.pow(2 * radius, 2) + Math.pow(globalCenterA$2.distanceTo(globalCenterB$2), 2));
  var added = group.add(nodeId, treeIndex, size, globalCenterA$2, globalCapZAxis, globalCapXAxis, radiusA, radiusA, thickness, angle, arcAngle, filterOptions);
  added = group.add(nodeId, treeIndex, size, globalCenterB$2, globalCapZAxis, globalCapXAxis, radiusB, radiusB, thickness, angle, arcAngle, filterOptions) || added;
  return added;
}

function parseExtrudedRing(primitiveInfo, nodeId, treeIndex, group, filterOptions) {
  var _a, _b, _c, _d;

  var _e = primitiveInfo.angle,
      angle = _e === void 0 ? 0 : _e,
      _f = primitiveInfo.arcAngle,
      arcAngle = _f === void 0 ? 2 * Math.PI : _f,
      innerRadius = primitiveInfo.innerRadius,
      outerRadius = primitiveInfo.outerRadius;
  var _g = primitiveInfo.centerA,
      _h = _g.x,
      x = _h === void 0 ? 0 : _h,
      _j = _g.y,
      y = _j === void 0 ? 0 : _j,
      _k = _g.z,
      z = _k === void 0 ? 0 : _k;
  globalCenterA$2.set(x, y, z);
  _a = primitiveInfo.centerB, _b = _a.x, x = _b === void 0 ? 0 : _b, _c = _a.y, y = _c === void 0 ? 0 : _c, _d = _a.z, z = _d === void 0 ? 0 : _d;
  globalCenterB$2.set(x, y, z);
  globalNormal$5.copy(globalCenterA$2).sub(globalCenterB$2).normalize();
  globalRotation$2.setFromUnitVectors(zAxis, globalNormal$5);
  globalCapXAxis.copy(xAxis).applyQuaternion(globalRotation$2);
  var size = Math.sqrt(Math.pow(2 * outerRadius, 2) + Math.pow(globalCenterA$2.distanceTo(globalCenterB$2), 2));
  var added = group.add(nodeId, treeIndex, size, globalCenterA$2, globalNormal$5, globalCapXAxis, outerRadius, outerRadius, outerRadius - innerRadius, angle, arcAngle, filterOptions);
  added = group.add(nodeId, treeIndex, size, globalCenterB$2, globalNormal$5, globalCapXAxis, outerRadius, outerRadius, outerRadius - innerRadius, angle, arcAngle, filterOptions) || added;
  return added;
}

function parseGeneralCylinder(primitiveInfo, nodeId, treeIndex, group, filterOptions) {
  var _a, _b, _c, _d; //


  var radiusA = primitiveInfo.radiusA,
      radiusB = primitiveInfo.radiusB,
      _e = primitiveInfo.angle,
      angle = _e === void 0 ? 0 : _e,
      _f = primitiveInfo.arcAngle,
      arcAngle = _f === void 0 ? 2.0 * Math.PI : _f,
      _g = primitiveInfo.slopeA,
      slopeA = _g === void 0 ? 0 : _g,
      _h = primitiveInfo.slopeB,
      slopeB = _h === void 0 ? 0 : _h,
      _j = primitiveInfo.zAngleA,
      zAngleA = _j === void 0 ? 0 : _j,
      _k = primitiveInfo.zAngleB,
      zAngleB = _k === void 0 ? 0 : _k,
      _l = primitiveInfo.isClosed,
      isClosed = _l === void 0 ? false : _l;
  var thickness = primitiveInfo.thickness || (isClosed ? radiusA : 0);
  var added = false;
  var _m = primitiveInfo.centerA,
      _o = _m.x,
      x = _o === void 0 ? 0 : _o,
      _p = _m.y,
      y = _p === void 0 ? 0 : _p,
      _q = _m.z,
      z = _q === void 0 ? 0 : _q;
  globalCenterA$2.set(x, y, z);
  _a = primitiveInfo.centerB, _b = _a.x, x = _b === void 0 ? 0 : _b, _c = _a.y, y = _c === void 0 ? 0 : _c, _d = _a.z, z = _d === void 0 ? 0 : _d;
  globalCenterB$2.set(x, y, z);
  globalAxis$1.subVectors(globalCenterA$2, globalCenterB$2);
  var distFromBToA = globalAxis$1.length();
  globalRotation$2.setFromUnitVectors(zAxis, globalAxis$1.normalize());
  var distFromAToExtA = radiusA * Math.tan(slopeA);
  var distFromBToExtB = radiusA * Math.tan(slopeB);
  var heightA = distFromBToExtB + distFromBToA;
  var heightB = distFromBToExtB;
  globalExtA.copy(globalAxis$1).multiplyScalar(distFromAToExtA).add(globalCenterA$2);
  globalExtB.copy(globalAxis$1).multiplyScalar(-distFromBToExtB).add(globalCenterB$2);
  [true, false].forEach(function (isA) {
    var center = isA ? globalCenterA$2 : globalCenterB$2;
    var slope = isA ? slopeA : slopeB;
    var zAngle = isA ? zAngleA : zAngleB;
    var height = isA ? heightA : heightB;
    var radius = isA ? radiusA : radiusB;
    var invertNormal = !isA;
    GeneralCylinderGroup.slicingPlane(globalSlicingPlane, slope, zAngle, height, invertNormal);

    if (invertNormal) {
      globalSlicingPlane.negate();
    }

    var normal = new Vector3(globalSlicingPlane.x, globalSlicingPlane.y, globalSlicingPlane.z).applyQuaternion(globalRotation$2);
    var plane = globalPlanes[Number(Boolean(isA))];
    plane.setFromNormalAndCoplanarPoint(normal, center);
    var capXAxis = xAxis.clone().applyAxisAngle(yAxis, slope).applyAxisAngle(zAxis, zAngle).applyQuaternion(globalRotation$2).normalize();
    globalVertex.set(Math.cos(angle), Math.sin(angle), 0).applyQuaternion(globalRotation$2).normalize();
    globalLineStart.copy(globalVertex).multiplyScalar(radiusA).add(globalExtB).sub(globalAxis$1);
    globalLineEnd.copy(globalVertex).multiplyScalar(radiusA).add(globalExtA).add(globalAxis$1);
    globalLine.set(globalLineStart, globalLineEnd);
    plane.intersectLine(globalLine, globalVertex);
    var capAngleAxis = globalVertex.sub(center).normalize();
    var capAngle = angleBetweenVector3s(capAngleAxis, capXAxis, normal);
    var size = Math.sqrt(Math.pow(2 * radius, 2) + Math.pow(globalCenterA$2.distanceTo(globalCenterB$2), 2));

    if (thickness > 0) {
      added = group.add(nodeId, treeIndex, size, center, normal, capXAxis, radius / Math.abs(Math.cos(slope)), radius, thickness, normalizeRadians(capAngle), arcAngle, filterOptions) || added;
    }
  });
  return added;
}

function parse$6(args) {
  var geometries = args.geometries,
      filterOptions = args.filterOptions,
      treeIndexNodeIdMap = args.treeIndexNodeIdMap,
      colorMap = args.colorMap;
  var matchingGeometries = findMatchingGeometries$6(geometries);
  var group = new GeneralRingGroup(matchingGeometries.count);
  matchingGeometries.geometries.forEach(function (geometry) {
    var added = false;
    var primitiveInfo = geometry.primitiveInfo[getPrimitiveType(geometry.primitiveInfo)];
    var nodeId = parsePrimitiveNodeId(geometry);
    var treeIndex = parsePrimitiveTreeIndex(geometry);
    globalColor$1.setHex(parsePrimitiveColor(geometry));

    if (geometry.type === 'ring') {
      added = parseRing(primitiveInfo, nodeId, treeIndex, group, filterOptions);
    } else if (geometry.type === 'cone') {
      added = parseCone(primitiveInfo, nodeId, treeIndex, group, filterOptions);
    } else if (geometry.type === 'extrudedRing' || geometry.type === 'extrudedRingSegment') {
      added = parseExtrudedRing(primitiveInfo, nodeId, treeIndex, group, filterOptions);
    } else if (geometry.type === 'generalCylinder') {
      added = parseGeneralCylinder(primitiveInfo, nodeId, treeIndex, group, filterOptions);
    }

    if (added) {
      treeIndexNodeIdMap[treeIndex] = nodeId;
      colorMap[treeIndex] = globalColor$1.clone();
    }
  });
  return group;
} // Copyright 2019 Cognite AS
// reusable variables


var firstRotation$1 = new Quaternion();
var secondRotation$1 = new Quaternion();
var fullMatrix$1 = new Matrix4();
var globalNormal$6 = new Vector3();
var globalScale$1 = new Vector3();
var globalCenter$6 = new Vector3();
var globalCenterA$3 = new Vector3();
var globalCenterB$3 = new Vector3();
var globalPoint$1 = new Vector3();

var NutGroup =
/** @class */
function (_super) {
  __extends(NutGroup, _super);

  function NutGroup(capacity) {
    var _this = _super.call(this, capacity) || this;

    _this.type = 'Nut';
    _this.data = new PrimitiveGroupData('Nut', capacity);
    return _this;
  }

  NutGroup.prototype.add = function (nodeId, treeIndex, size, centerA, centerB, radius, rotationAngle, filterOptions) {
    this.setTreeIndex(treeIndex, this.data.count);
    this.data.add({
      size: size,
      centerA: centerA,
      centerB: centerB,
      radiusA: radius,
      rotationAngle: rotationAngle
    });
    return this.filterLastObject(nodeId, filterOptions);
  };

  NutGroup.prototype.computeModelMatrix = function (outputMatrix, index) {
    this.data.getVector3('centerA', globalCenterA$3, index);
    this.data.getVector3('centerB', globalCenterB$3, index);
    globalCenter$6.addVectors(globalCenterA$3, globalCenterB$3).multiplyScalar(0.5);
    globalNormal$6.subVectors(globalCenterA$3, globalCenterB$3);
    var height = globalNormal$6.length();
    firstRotation$1.setFromAxisAngle(zAxis, this.data.getNumber('rotationAngle', index));
    secondRotation$1.setFromUnitVectors(zAxis, globalNormal$6.normalize());
    var diameter = 2 * this.data.getNumber('radiusA', index);
    globalScale$1.set(diameter, diameter, height);
    return outputMatrix.compose(globalCenter$6, secondRotation$1.multiply(firstRotation$1), globalScale$1);
  };

  NutGroup.prototype.computeBoundingBox = function (matrix, box, index) {
    box.makeEmpty();
    this.computeModelMatrix(fullMatrix$1, index).premultiply(matrix);
    var angle = this.data.getNumber('rotationAngle', index) + Math.PI / 6;

    for (var i = 0; i < 6; i++, angle += Math.PI / 3) {
      var sin = 0.5 * Math.sin(angle);
      var cos = 0.5 * Math.cos(angle);
      globalPoint$1.set(sin, cos, 0.5).applyMatrix4(fullMatrix$1);
      box.expandByPoint(globalPoint$1);
      globalPoint$1.set(sin, cos, -0.5).applyMatrix4(fullMatrix$1);
      box.expandByPoint(globalPoint$1);
    }

    return box;
  };

  return NutGroup;
}(PrimitiveGroup); // Copyright 2019 Cognite AS


var color$5 = new Color();
var centerA$3 = new Vector3();
var centerB$3 = new Vector3();

function findMatchingGeometries$7(geometries) {
  var matchingGeometries = {
    count: 0,
    geometries: []
  };
  geometries.forEach(function (geometry) {
    if (geometry.type === 'nut') {
      matchingGeometries.geometries.push(geometry);
      matchingGeometries.count += 1;
    }
  });
  return matchingGeometries;
}

function parse$7(args) {
  var geometries = args.geometries,
      filterOptions = args.filterOptions,
      treeIndexNodeIdMap = args.treeIndexNodeIdMap,
      colorMap = args.colorMap;
  var matchingGeometries = findMatchingGeometries$7(geometries);
  var group = new NutGroup(matchingGeometries.count);
  matchingGeometries.geometries.forEach(function (geometry) {
    var _a, _b, _c, _d;

    var primitiveInfo = geometry.primitiveInfo[getPrimitiveType(geometry.primitiveInfo)];
    var nodeId = parsePrimitiveNodeId(geometry);
    var treeIndex = parsePrimitiveTreeIndex(geometry);
    color$5.setHex(parsePrimitiveColor(geometry));
    var _e = primitiveInfo.centerA,
        _f = _e.x,
        x = _f === void 0 ? 0 : _f,
        _g = _e.y,
        y = _g === void 0 ? 0 : _g,
        _h = _e.z,
        z = _h === void 0 ? 0 : _h;
    centerA$3.set(x, y, z);
    _a = primitiveInfo.centerB, _b = _a.x, x = _b === void 0 ? 0 : _b, _c = _a.y, y = _c === void 0 ? 0 : _c, _d = _a.z, z = _d === void 0 ? 0 : _d;
    centerB$3.set(x, y, z);
    var _j = primitiveInfo.radius,
        radius = _j === void 0 ? 0 : _j,
        _k = primitiveInfo.rotationAngle,
        rotationAngle = _k === void 0 ? 0 : _k;
    var size = Math.sqrt(Math.pow(2 * radius, 2) + Math.pow(centerA$3.distanceTo(centerB$3), 2));
    var added = group.add(nodeId, treeIndex, size, centerA$3, centerB$3, radius, rotationAngle, filterOptions);

    if (added) {
      treeIndexNodeIdMap[treeIndex] = nodeId;
      colorMap[treeIndex] = color$5.clone();
    }
  });
  return group;
} // Copyright 2019 Cognite AS
// reusable variables


var basis = new Matrix4();
var rotation$3 = new Quaternion();
var scale$2 = new Vector3();
var center$4 = new Vector3();
var normal$6 = new Vector3();
var side1 = new Vector3();
var side2 = new Vector3();
var globalVertex1 = new Vector3();
var globalVertex2 = new Vector3();
var globalVertex3 = new Vector3();
var globalVertex4 = new Vector3();
var point = new Vector3();

var QuadGroup =
/** @class */
function (_super) {
  __extends(QuadGroup, _super);

  function QuadGroup(capacity) {
    var _this = _super.call(this, capacity) || this;

    _this.type = 'Quad';
    _this.data = new PrimitiveGroupData('Quad', capacity);
    return _this;
  }

  QuadGroup.prototype.add = function (nodeId, treeIndex, size, vertex1, vertex2, vertex3, filterOptions) {
    this.setTreeIndex(treeIndex, this.data.count);
    this.data.add({
      size: size,
      vertex1: vertex1,
      vertex2: vertex2,
      vertex3: vertex3
    });
    return this.filterLastObject(nodeId, filterOptions);
  };

  QuadGroup.prototype.computeModelMatrix = function (outputMatrix, index) {
    this.data.getVector3('vertex1', globalVertex1, index);
    this.data.getVector3('vertex2', globalVertex2, index);
    this.data.getVector3('vertex3', globalVertex3, index);
    side1.subVectors(globalVertex3, globalVertex1);
    side2.subVectors(globalVertex3, globalVertex2);
    scale$2.set(side2.length(), side1.length(), 1);
    normal$6.crossVectors(side1, side2).normalize();
    side1.normalize();
    side2.normalize(); // tslint:disable:prettier

    basis.set(side2.x, side1.x, normal$6.x, 0, side2.y, side1.y, normal$6.y, 0, side2.z, side1.z, normal$6.z, 0, 0, 0, 0, 1); // tslint:enable:prettier

    outputMatrix = outputMatrix.identity().compose(center$4.set(0, 0, 0), rotation$3, scale$2);
    outputMatrix.premultiply(basis);
    center$4.addVectors(globalVertex1, globalVertex2).multiplyScalar(0.5); // tslint:disable:prettier

    basis.set(1, 0, 0, center$4.x, 0, 1, 0, center$4.y, 0, 0, 1, center$4.z, 0, 0, 0, 1); // tslint:enable:prettier

    outputMatrix.premultiply(basis);
    return outputMatrix;
  };

  QuadGroup.prototype.computeBoundingBox = function (matrix, box, index) {
    this.data.getVector3('vertex1', globalVertex1, index);
    this.data.getVector3('vertex2', globalVertex2, index);
    this.data.getVector3('vertex3', globalVertex3, index);
    box.makeEmpty();
    globalVertex4.subVectors(globalVertex1, globalVertex3).add(globalVertex2);
    var vertices = [globalVertex1, globalVertex2, globalVertex3, globalVertex4];
    vertices.forEach(function (vertex) {
      box.expandByPoint(point.copy(vertex).applyMatrix4(matrix));
    });
    return box;
  };

  return QuadGroup;
}(PrimitiveGroup); // Copyright 2019 Cognite AS


var globalColor$2 = new Color();
var vertex$1 = new Vector3();
var vertex1 = new Vector3();
var vertex2 = new Vector3();
var vertex3 = new Vector3();
var centerA$4 = new Vector3();
var centerB$4 = new Vector3();
var normal$7 = new Vector3();
var axisRotation = new Quaternion();

function findMatchingGeometries$8(geometries) {
  var matchingGeometries = {
    count: 0,
    geometries: []
  };
  geometries.forEach(function (geometry) {
    if (!isPrimitive(geometry)) {
      return;
    }

    var primitiveInfo = geometry.primitiveInfo[getPrimitiveType(geometry.primitiveInfo)];
    var _a = primitiveInfo.arcAngle,
        arcAngle = _a === void 0 ? 0 : _a,
        _b = primitiveInfo.isClosed,
        isClosed = _b === void 0 ? false : _b;

    if ((geometry.type === 'extrudedRing' || geometry.type === 'extrudedRingSegment') && arcAngle < 2 * Math.PI && isClosed) {
      matchingGeometries.geometries.push(geometry);
      matchingGeometries.count += 2;
    }
  });
  return matchingGeometries;
}

function parse$8(args) {
  var geometries = args.geometries,
      filterOptions = args.filterOptions,
      treeIndexNodeIdMap = args.treeIndexNodeIdMap,
      colorMap = args.colorMap;
  var matchingGeometries = findMatchingGeometries$8(geometries);
  var group = new QuadGroup(matchingGeometries.count);
  matchingGeometries.geometries.forEach(function (geometry) {
    var _a, _b, _c, _d;

    var added = false; // Only extruded rings will produce quads

    var primitiveInfo = geometry.primitiveInfo[getPrimitiveType(geometry.primitiveInfo)];
    var nodeId = parsePrimitiveNodeId(geometry);
    var treeIndex = parsePrimitiveTreeIndex(geometry);
    globalColor$2.setHex(parsePrimitiveColor(geometry));
    var _e = primitiveInfo.angle,
        angle = _e === void 0 ? 0 : _e,
        innerRadius = primitiveInfo.innerRadius,
        outerRadius = primitiveInfo.outerRadius,
        _f = primitiveInfo.arcAngle,
        arcAngle = _f === void 0 ? 2 * Math.PI : _f;
    var _g = primitiveInfo.centerA,
        _h = _g.x,
        x = _h === void 0 ? 0 : _h,
        _j = _g.y,
        y = _j === void 0 ? 0 : _j,
        _k = _g.z,
        z = _k === void 0 ? 0 : _k;
    centerA$4.set(x, y, z);
    _a = primitiveInfo.centerB, _b = _a.x, x = _b === void 0 ? 0 : _b, _c = _a.y, y = _c === void 0 ? 0 : _c, _d = _a.z, z = _d === void 0 ? 0 : _d;
    centerB$4.set(x, y, z);
    normal$7.copy(centerA$4).sub(centerB$4).normalize();
    axisRotation.setFromUnitVectors(zAxis, normal$7);
    [false, true].forEach(function (isSecondQuad) {
      var finalAngle = angle + Number(isSecondQuad) * arcAngle;
      vertex$1.set(Math.cos(finalAngle), Math.sin(finalAngle), 0).applyQuaternion(axisRotation).normalize();
      vertex1.copy(vertex$1).multiplyScalar(innerRadius).add(centerA$4);
      vertex2.copy(vertex$1).multiplyScalar(outerRadius).add(centerB$4);
      vertex3.copy(vertex$1).multiplyScalar(innerRadius).add(centerB$4);
      var size = vertex1.distanceTo(vertex2);

      if (isSecondQuad) {
        // swap the order of vertex1 and vertex2 to flip the normal
        added = group.add(nodeId, treeIndex, size, vertex2, vertex1, vertex3, filterOptions) || added;
      } else {
        added = group.add(nodeId, treeIndex, size, vertex1, vertex2, vertex3, filterOptions) || added;
      }
    });

    if (added) {
      treeIndexNodeIdMap[treeIndex] = nodeId;
      colorMap[treeIndex] = globalColor$2.clone();
    }
  });
  return group;
} // Copyright 2019 Cognite AS


var points = [[1, 0, 0], [-1, 0, 0], [0, 1, 0], [0, -1, 0], [0, 0, 1], [0, 0, -1]]; // reusable variables

var transformedCenter = new Vector3();
var transformedNormal = new Vector3();
var normalMatrix$1 = new Matrix3();
var point$1 = new Vector3();
var direction = new Vector3();
var sphereCenter = new Vector3();
var globalCenter$7 = new Vector3();
var globalNormal$7 = new Vector3();

var SphericalSegmentGroup =
/** @class */
function (_super) {
  __extends(SphericalSegmentGroup, _super);

  function SphericalSegmentGroup(capacity) {
    var _this = _super.call(this, capacity) || this;

    _this.type = 'SphericalSegment';
    _this.hasCustomTransformAttributes = true;
    _this.data = new PrimitiveGroupData('SphericalSegment', capacity);

    _this.attributes.push({
      name: 'a_vRadius',
      array: _this.data.arrays.hRadius,
      itemSize: 1
    });

    return _this;
  }

  SphericalSegmentGroup.prototype.add = function (nodeId, treeIndex, size, center, normal, radius, height, filterOptions) {
    this.setTreeIndex(treeIndex, this.data.count);
    this.data.add({
      size: size,
      center: center,
      normal: normal,
      hRadius: radius,
      height: height
    });
    return this.filterLastObject(nodeId, filterOptions);
  };

  SphericalSegmentGroup.prototype.computeModelMatrix = function (outputMatrix, index) {
    return outputMatrix.identity();
  };

  SphericalSegmentGroup.prototype.computeBoundingBox = function (matrix, box, index) {
    box.makeEmpty();
    normalMatrix$1.setFromMatrix4(matrix);
    transformedNormal.copy(this.data.getVector3('normal', globalNormal$7, index)).applyMatrix3(normalMatrix$1).normalize();
    var scaling = matrix.getMaxScaleOnAxis();
    var radius = scaling * this.data.getNumber('hRadius', index);
    var height = scaling * this.data.getNumber('height', index);
    sphereCenter.copy(this.data.getVector3('center', globalCenter$7, index)).applyMatrix4(matrix);
    transformedCenter.copy(sphereCenter).add(direction.copy(transformedNormal).multiplyScalar(radius - height));
    box = computeCircleBoundingBox(transformedCenter, transformedNormal, Math.sqrt(radius * radius - (radius - height) * (radius - height)), box);
    points.forEach(function (p) {
      var dot = point$1.set(p[0], p[1], p[2]).multiplyScalar(radius).add(sphereCenter).sub(transformedCenter).dot(transformedNormal);
      var EPS = 1e-6;

      if (dot >= -EPS) {
        box.expandByPoint(point$1.set(p[0], p[1], p[2]).multiplyScalar(radius).add(sphereCenter));
      }
    });
    return box;
  };

  return SphericalSegmentGroup;
}(PrimitiveGroup); // Copyright 2019 Cognite AS


var color$6 = new Color();
var center$5 = new Vector3();
var normal$8 = new Vector3();

function findMatchingGeometries$9(geometries) {
  var matchingGeometries = {
    count: 0,
    geometries: []
  };
  geometries.forEach(function (geometry) {
    if (geometry.type === 'sphere' || geometry.type === 'sphericalSegment') {
      matchingGeometries.geometries.push(geometry);
      matchingGeometries.count += 1;
    }
  });
  return matchingGeometries;
}

function parse$9(args) {
  var geometries = args.geometries,
      filterOptions = args.filterOptions,
      treeIndexNodeIdMap = args.treeIndexNodeIdMap,
      colorMap = args.colorMap;
  var matchingGeometries = findMatchingGeometries$9(geometries);
  var group = new SphericalSegmentGroup(matchingGeometries.count);
  matchingGeometries.geometries.forEach(function (geometry) {
    var _a, _b, _c, _d;

    var primitiveInfo = geometry.primitiveInfo[getPrimitiveType(geometry.primitiveInfo)];
    var nodeId = parsePrimitiveNodeId(geometry);
    var treeIndex = parsePrimitiveTreeIndex(geometry);
    color$6.setHex(parsePrimitiveColor(geometry));
    var _e = primitiveInfo.center,
        _f = _e.x,
        x = _f === void 0 ? 0 : _f,
        _g = _e.y,
        y = _g === void 0 ? 0 : _g,
        _h = _e.z,
        z = _h === void 0 ? 0 : _h;
    center$5.set(x, y, z);
    var radius = primitiveInfo.radius;
    var height = 2 * radius; // Default value for sphere

    if (geometry.type === 'sphericalSegment') {
      _a = primitiveInfo.normal, _b = _a.x, x = _b === void 0 ? 0 : _b, _c = _a.y, y = _c === void 0 ? 0 : _c, _d = _a.z, z = _d === void 0 ? 0 : _d;
      normal$8.set(x, y, z);
      height = primitiveInfo.height;
    } else {
      normal$8.set(0, -1, 0);
    }

    var size = Math.sqrt(Math.pow(2 * radius, 2) + Math.pow(height, 2));
    var added = group.add(nodeId, treeIndex, size, center$5, normal$8, radius, height, filterOptions);

    if (added) {
      treeIndexNodeIdMap[treeIndex] = nodeId;
      colorMap[treeIndex] = color$6.clone();
    }
  });
  return group;
} // Copyright 2019 Cognite AS
// reusable variables


var firstRotation$2 = new Quaternion();
var secondRotation$2 = new Quaternion();
var scale$3 = new Vector3();
var tubeCenter = new Vector3();
var tubeNormal = new Vector3();
var reusableBox$1 = new Box3();
var normalMatrix$2 = new Matrix3();
var vector1$1 = new Vector3();
var vector2$1 = new Vector3();

var TorusSegmentGroup =
/** @class */
function (_super) {
  __extends(TorusSegmentGroup, _super);

  function TorusSegmentGroup(capacity) {
    var _this = _super.call(this, capacity) || this;

    _this.type = 'TorusSegment';
    _this.data = new PrimitiveGroupData('TorusSegment', capacity);
    return _this;
  }

  TorusSegmentGroup.prototype.add = function (nodeId, treeIndex, size, center, normal, radius, tubeRadius, angle, arcAngle, filterOptions) {
    this.setTreeIndex(treeIndex, this.data.count);
    this.data.add({
      size: size,
      center: center,
      normal: normal,
      radius: radius,
      tubeRadius: tubeRadius,
      angle: angle,
      arcAngle: arcAngle
    });
    return this.filterLastObject(nodeId, filterOptions);
  };

  TorusSegmentGroup.prototype.computeModelMatrix = function (outputMatrix, index) {
    firstRotation$2.setFromAxisAngle(zAxis, this.data.getNumber('angle', index));
    secondRotation$2.setFromUnitVectors(zAxis, this.data.getVector3('normal', vector1$1, index));
    scale$3.set(1, 1, 1);
    return outputMatrix.compose(this.data.getVector3('center', vector2$1, index), secondRotation$2.multiply(firstRotation$2), // A.multiply(B) === A*B
    scale$3);
  };

  TorusSegmentGroup.prototype.computeBoundingBox = function (matrix, box, index) {
    box.makeEmpty();
    normalMatrix$2.setFromMatrix4(matrix);
    secondRotation$2.setFromUnitVectors(zAxis, this.data.getVector3('normal', vector1$1, index));
    var radialSegmentAngle = twoPI / 24;
    var angle = this.data.getNumber('angle', index);
    var arcAngle = this.data.getNumber('arcAngle', index);
    var radius = this.data.getNumber('radius', index);
    var iterations = Math.ceil(arcAngle / radialSegmentAngle) + 1;

    for (var i = 0; i < iterations; ++i) {
      var zAngle = Math.min(angle + i * radialSegmentAngle, angle + arcAngle);
      var x = Math.cos(zAngle);
      var y = Math.sin(zAngle);
      tubeCenter.set(x * radius, y * radius, 0).applyQuaternion(secondRotation$2).add(this.data.getVector3('center', vector2$1, index)).applyMatrix4(matrix);
      tubeNormal.set(y, -x, 0).applyQuaternion(secondRotation$2).applyMatrix3(normalMatrix$2);
      box.union(computeCircleBoundingBox(tubeCenter, tubeNormal, this.data.getNumber('tubeRadius', index), reusableBox$1));
    }

    return box;
  };

  return TorusSegmentGroup;
}(PrimitiveGroup); // Copyright 2019 Cognite AS


var globalColor$3 = new Color();
var center$6 = new Vector3();
var normal$9 = new Vector3();

function findMatchingGeometries$a(geometries) {
  var matchingGeometries = {
    count: 0,
    geometries: []
  };
  geometries.forEach(function (geometry) {
    if (geometry.type === 'torus' || geometry.type === 'torusSegment') {
      matchingGeometries.geometries.push(geometry);
      matchingGeometries.count += 1;
    }
  });
  return matchingGeometries;
}

function parse$a(args) {
  var geometries = args.geometries,
      filterOptions = args.filterOptions,
      treeIndexNodeIdMap = args.treeIndexNodeIdMap,
      colorMap = args.colorMap;
  var matchingGeometries = findMatchingGeometries$a(geometries);
  var group = new TorusSegmentGroup(matchingGeometries.count);
  matchingGeometries.geometries.forEach(function (geometry) {
    var _a, _b, _c, _d;

    var primitiveInfo = geometry.primitiveInfo[getPrimitiveType(geometry.primitiveInfo)];
    var nodeId = parsePrimitiveNodeId(geometry);
    var treeIndex = parsePrimitiveTreeIndex(geometry);
    globalColor$3.setHex(parsePrimitiveColor(geometry));
    var _e = primitiveInfo.center,
        _f = _e.x,
        x = _f === void 0 ? 0 : _f,
        _g = _e.y,
        y = _g === void 0 ? 0 : _g,
        _h = _e.z,
        z = _h === void 0 ? 0 : _h;
    center$6.set(x, y, z);
    _a = primitiveInfo.normal, _b = _a.x, x = _b === void 0 ? 0 : _b, _c = _a.y, y = _c === void 0 ? 0 : _c, _d = _a.z, z = _d === void 0 ? 0 : _d;
    normal$9.set(x, y, z);
    var radius = primitiveInfo.radius,
        tubeRadius = primitiveInfo.tubeRadius,
        _j = primitiveInfo.angle,
        angle = _j === void 0 ? 0.0 : _j,
        _k = primitiveInfo.arcAngle,
        arcAngle = _k === void 0 ? 2 * Math.PI : _k;
    var size = Math.sqrt(Math.pow(2 * radius, 2) + Math.pow(2 * tubeRadius, 2));
    var added = group.add(nodeId, treeIndex, size, center$6, normal$9, radius, tubeRadius, angle, arcAngle, filterOptions);

    if (added) {
      treeIndexNodeIdMap[treeIndex] = nodeId;
      colorMap[treeIndex] = globalColor$3.clone();
    }
  });
  return group;
} // Copyright 2019 Cognite AS
// reusable variables


var point$2 = new Vector3();
var vertex$2 = new Vector3();

var TrapeziumGroup =
/** @class */
function (_super) {
  __extends(TrapeziumGroup, _super);

  function TrapeziumGroup(capacity) {
    var _this = _super.call(this, capacity) || this;

    _this.type = 'Trapezium';
    _this.hasCustomTransformAttributes = true;
    _this.data = new PrimitiveGroupData('Trapezium', capacity);
    return _this;
  }

  TrapeziumGroup.prototype.add = function (nodeId, treeIndex, size, vertex1, vertex2, vertex3, vertex4, filterOptions) {
    this.setTreeIndex(treeIndex, this.data.count);
    this.data.add({
      size: size,
      vertex1: vertex1,
      vertex2: vertex2,
      vertex3: vertex3,
      vertex4: vertex4
    });
    return this.filterLastObject(nodeId, filterOptions);
  };

  TrapeziumGroup.prototype.computeModelMatrix = function (outputMatrix, index) {
    return outputMatrix;
  };

  TrapeziumGroup.prototype.computeBoundingBox = function (matrix, box, index) {
    box.makeEmpty();
    box.expandByPoint(this.data.getVector3('vertex1', vertex$2, index).applyMatrix4(matrix));
    box.expandByPoint(this.data.getVector3('vertex2', vertex$2, index).applyMatrix4(matrix));
    box.expandByPoint(this.data.getVector3('vertex3', vertex$2, index).applyMatrix4(matrix));
    box.expandByPoint(this.data.getVector3('vertex4', vertex$2, index).applyMatrix4(matrix));
    return box;
  };

  return TrapeziumGroup;
}(PrimitiveGroup); // Copyright 2019 Cognite AS


var globalColor$4 = new Color();
var globalCenterA$4 = new Vector3();
var globalCenterB$4 = new Vector3();
var globalCapZAxis$1 = new Vector3();
var globalCapXAxis$1 = new Vector3();
var globalVertex$1 = new Vector3();
var globalSlicingPlane$1 = new Vector4();
var globalAxis$2 = new Vector3();
var globalNormal$8 = new Vector3();
var globalLocalXAxis$2 = new Vector3();
var globalRotation$3 = new Quaternion();
var globalLine$1 = new Line3();
var globalLineStart$1 = new Vector3();
var globalLineEnd$1 = new Vector3();
var globalExtA$1 = new Vector3();
var globalExtB$1 = new Vector3();
var globalPlanes$1 = [new Plane(), new Plane()];
var globalVertices = [new Vector3(), new Vector3(), new Vector3(), new Vector3()];

function findMatchingGeometries$b(geometries) {
  var matchingGeometries = {
    count: 0,
    geometries: []
  };
  geometries.forEach(function (geometry) {
    if (!isPrimitive(geometry)) {
      return;
    }

    var _a = geometry.primitiveInfo[getPrimitiveType(geometry.primitiveInfo)],
        _b = _a.thickness,
        thickness = _b === void 0 ? 0 : _b,
        _c = _a.arcAngle,
        arcAngle = _c === void 0 ? 2 * Math.PI : _c,
        _d = _a.isClosed,
        isClosed = _d === void 0 ? false : _d;
    var treeIndex = parsePrimitiveTreeIndex(geometry);

    if ((geometry.type === 'cone' || geometry.type === 'generalCylinder') && thickness > 0 && arcAngle < 2 * Math.PI && isClosed) {
      matchingGeometries.geometries.push(geometry);
      matchingGeometries.count += 2;
    }
  });
  return matchingGeometries;
}

function parseCone$1(primitiveInfo, nodeId, treeIndex, group, filterOptions) {
  var _a, _b, _c, _d;

  var added = false;
  var _e = primitiveInfo.centerA,
      _f = _e.x,
      x = _f === void 0 ? 0 : _f,
      _g = _e.y,
      y = _g === void 0 ? 0 : _g,
      _h = _e.z,
      z = _h === void 0 ? 0 : _h;
  globalCenterA$4.set(x, y, z);
  _a = primitiveInfo.centerB, _b = _a.x, x = _b === void 0 ? 0 : _b, _c = _a.y, y = _c === void 0 ? 0 : _c, _d = _a.z, z = _d === void 0 ? 0 : _d;
  globalCenterB$4.set(x, y, z);
  globalCapZAxis$1.copy(globalCenterA$4).sub(globalCenterB$4);
  globalRotation$3.setFromUnitVectors(zAxis, globalCapZAxis$1.normalize());
  globalCapXAxis$1.copy(xAxis).applyQuaternion(globalRotation$3);
  var _j = primitiveInfo.angle,
      angle = _j === void 0 ? 0 : _j,
      arcAngle = primitiveInfo.arcAngle,
      radiusA = primitiveInfo.radiusA,
      radiusB = primitiveInfo.radiusB,
      _k = primitiveInfo.thickness,
      thickness = _k === void 0 ? 0 : _k;
  [false, true].forEach(function (isSecondQuad) {
    var finalAngle = angle + Number(isSecondQuad) * arcAngle;
    globalVertex$1.set(Math.cos(finalAngle), Math.sin(finalAngle), 0).applyQuaternion(globalRotation$3).normalize();
    var vertices = [];
    var offsets = [0, -thickness];
    [true, false].forEach(function (isA) {
      if (isSecondQuad) {
        isA = !isA;
      }

      var radius = isA ? radiusA : radiusB;
      var center = isA ? globalCenterA$4 : globalCenterB$4;
      offsets.forEach(function (offset) {
        vertices.push(globalVertex$1.clone().multiplyScalar(radius + offset).add(center));
      });
    });
    var size = (vertices[0].distanceTo(vertices[2]) + vertices[1].distanceTo(vertices[3])) / 2;
    added = group.add(nodeId, treeIndex, size, vertices[0], vertices[1], vertices[2], vertices[3], filterOptions) || added;
  });
  return added;
}

function parseGeneralCylinder$1(primitiveInfo, nodeId, treeIndex, group, filterOptions) {
  var _a, _b, _c, _d;

  var added = false; //

  var radiusA = primitiveInfo.radiusA,
      radiusB = primitiveInfo.radiusB,
      _e = primitiveInfo.angle,
      angle = _e === void 0 ? 0 : _e,
      _f = primitiveInfo.thickness,
      thickness = _f === void 0 ? 0 : _f,
      _g = primitiveInfo.slopeA,
      slopeA = _g === void 0 ? 0 : _g,
      _h = primitiveInfo.slopeB,
      slopeB = _h === void 0 ? 0 : _h,
      _j = primitiveInfo.zAngleA,
      zAngleA = _j === void 0 ? 0 : _j,
      _k = primitiveInfo.zAngleB,
      zAngleB = _k === void 0 ? 0 : _k,
      _l = primitiveInfo.arcAngle,
      arcAngle = _l === void 0 ? 2 * Math.PI : _l,
      _m = primitiveInfo.isClosed;
  var _o = primitiveInfo.centerA,
      _p = _o.x,
      x = _p === void 0 ? 0 : _p,
      _q = _o.y,
      y = _q === void 0 ? 0 : _q,
      _r = _o.z,
      z = _r === void 0 ? 0 : _r;
  globalCenterA$4.set(x, y, z);
  _a = primitiveInfo.centerB, _b = _a.x, x = _b === void 0 ? 0 : _b, _c = _a.y, y = _c === void 0 ? 0 : _c, _d = _a.z, z = _d === void 0 ? 0 : _d;
  globalCenterB$4.set(x, y, z);
  globalAxis$2.subVectors(globalCenterA$4, globalCenterB$4);
  var distFromBToA = globalAxis$2.length();
  globalRotation$3.setFromUnitVectors(zAxis, globalAxis$2.normalize());
  var distFromAToExtA = radiusA * Math.tan(slopeA);
  var distFromBToExtB = radiusA * Math.tan(slopeB);
  var heightA = distFromBToExtB + distFromBToA;
  var heightB = distFromBToExtB;
  globalExtA$1.copy(globalAxis$2).multiplyScalar(distFromAToExtA).add(globalCenterA$4);
  globalExtB$1.copy(globalAxis$2).multiplyScalar(-distFromBToExtB).add(globalCenterB$4);
  [true, false].forEach(function (isA) {
    var center = isA ? globalCenterA$4 : globalCenterB$4;
    var slope = isA ? slopeA : slopeB;
    var zAngle = isA ? zAngleA : zAngleB;
    var height = isA ? heightA : heightB;
    var invertNormal = !isA;
    GeneralCylinderGroup.slicingPlane(globalSlicingPlane$1, slope, zAngle, height, invertNormal);

    if (invertNormal) {
      globalSlicingPlane$1.negate();
    }

    globalNormal$8.set(globalSlicingPlane$1.x, globalSlicingPlane$1.y, globalSlicingPlane$1.z).applyQuaternion(globalRotation$3);
    var plane = globalPlanes$1[Number(Boolean(isA))];
    plane.setFromNormalAndCoplanarPoint(globalNormal$8, center);
  });
  [false, true].forEach(function (isSecondQuad) {
    var vertexIndex = 0;
    var finalAngle = angle + Number(isSecondQuad) * arcAngle;
    var radii = !isSecondQuad ? [radiusA, radiusA - thickness] : [radiusA - thickness, radiusA];
    globalVertex$1.set(Math.cos(finalAngle), Math.sin(finalAngle), 0).applyQuaternion(globalRotation$3).normalize();
    radii.forEach(function (radius) {
      globalLineStart$1.copy(globalVertex$1).multiplyScalar(radius).add(globalExtB$1).sub(globalAxis$2);
      globalLineEnd$1.copy(globalVertex$1).multiplyScalar(radius).add(globalExtA$1).add(globalAxis$2);
      globalLine$1.set(globalLineStart$1, globalLineEnd$1);
      globalPlanes$1.forEach(function (plane) {
        plane.intersectLine(globalLine$1, globalVertices[vertexIndex]);
        vertexIndex++;
      });
    });
    var size = (globalVertices[0].distanceTo(globalVertices[2]) + globalVertices[1].distanceTo(globalVertices[3])) / 2;
    added = group.add(nodeId, treeIndex, size, globalVertices[0], globalVertices[1], globalVertices[2], globalVertices[3], filterOptions) || added;
  });
  return added;
}

function parse$b(args) {
  var geometries = args.geometries,
      filterOptions = args.filterOptions,
      treeIndexNodeIdMap = args.treeIndexNodeIdMap,
      colorMap = args.colorMap;
  var matchingGeometries = findMatchingGeometries$b(geometries);
  var group = new TrapeziumGroup(matchingGeometries.count);
  matchingGeometries.geometries.forEach(function (geometry) {
    var added = false;
    var primitiveInfo = geometry.primitiveInfo[getPrimitiveType(geometry.primitiveInfo)];
    var nodeId = parsePrimitiveNodeId(geometry);
    var treeIndex = parsePrimitiveTreeIndex(geometry);
    globalColor$4.setHex(parsePrimitiveColor(geometry));

    if (geometry.type === 'cone') {
      added = parseCone$1(primitiveInfo, nodeId, treeIndex, group, filterOptions);
    } else if (geometry.type === 'generalCylinder') {
      var radiusA = primitiveInfo.radiusA,
          radiusB = primitiveInfo.radiusB;

      if (radiusA !== radiusB) {
        added = parseCone$1(primitiveInfo, nodeId, treeIndex, group, filterOptions);
      } else {
        added = parseGeneralCylinder$1(primitiveInfo, nodeId, treeIndex, group, filterOptions);
      }
    }

    if (added) {
      treeIndexNodeIdMap[treeIndex] = nodeId;
      colorMap[treeIndex] = globalColor$4.clone();
    }
  });
  return group;
} // Copyright 2019 Cognite AS


var globalColor$5 = new Color();
var hasWarnedAboutMissingColor$1 = false;

function findMatchingGeometries$c(geometries) {
  var matchingGeometries = {
    count: 0,
    geometries: []
  };
  geometries.forEach(function (geometry) {
    if (geometry.type === 'triangleMesh' && !geometry.isInstanced) {
      matchingGeometries.geometries.push(geometry);
      matchingGeometries.count += 1;
    }
  });
  return matchingGeometries;
}

function parse$c(data) {
  var matchingGeometries = findMatchingGeometries$c(data.geometries);
  var group = new MergedMeshGroup();
  matchingGeometries.geometries.forEach(function (geometry) {
    var fileId = geometry.file[0].fileId;
    var nodes = geometry.nodes;
    var mergedMesh = new MergedMesh(nodes.length, fileId);
    var triangleOffset = 0;
    nodes.forEach(function (node) {
      var nodeId = Number(node.properties[0].nodeId);
      var treeIndex = node.properties[0].treeIndex;

      if (node.properties[0].color == null && !hasWarnedAboutMissingColor$1) {
        hasWarnedAboutMissingColor$1 = true; // tslint:disable-next-line:no-console

        console.warn('3d-web-parser encountered node with missing color while loading', '(using #ff00ff to highlight objects with missing color).');
      }

      var color = node.properties[0].color != null ? node.properties[0].color : {
        rgb: 0xff00ff
      };
      var triangleCount = node.triangleCount;
      globalColor$5.setHex(color.rgb); // size is calculated later

      mergedMesh.mappings.add(triangleOffset, triangleCount, treeIndex, 0);
      triangleOffset += triangleCount;
      data.treeIndexNodeIdMap[treeIndex] = nodeId;
      data.colorMap[treeIndex] = globalColor$5.clone();
    });
    data.sceneStats.geometryCount.MergedMesh += 1;
    group.addMesh(mergedMesh);
  });
  return group;
} // Copyright 2019 Cognite AS


var globalColor$6 = new Color();
var globalMatrix$1 = new Matrix4();
var hasWarnedAboutMissingColor$2 = false;

function findMatchingGeometries$d(geometries) {
  var matchingGeometries = {
    count: 0,
    geometries: []
  };
  geometries.forEach(function (geometry) {
    if (geometry.type === 'triangleMesh' && geometry.isInstanced) {
      matchingGeometries.geometries.push(geometry);
      matchingGeometries.count += 1;
    }
  });
  return matchingGeometries;
}

function createCollection(node, data) {
  var triangleCount = node.triangleCount,
      triangleOffset = node.triangleOffset;
  var collection = new InstancedMeshCollection(triangleOffset, triangleCount, node.properties.length); // @ts-ignore

  node.properties.forEach(function (property) {
    var nodeId = Number(property.nodeId);
    var treeIndex = property.treeIndex,
        transformMatrix = property.transformMatrix;

    if (property.color == null && !hasWarnedAboutMissingColor$2) {
      hasWarnedAboutMissingColor$2 = true; // tslint:disable-next-line:no-console

      console.warn('3d-web-parser encountered node with missing color while loading', '(using #ff00ff to highlight objects with missing color).');
    }

    var color = property.color != null ? property.color : {
      rgb: 0xff00ff
    };
    globalColor$6.setHex(color.rgb);
    parseInstancedMeshTransformMatrix(globalMatrix$1, transformMatrix); // size is calculated later

    collection.addMapping(nodeId, treeIndex, 0, globalMatrix$1);
    data.treeIndexNodeIdMap[treeIndex] = nodeId;
    data.colorMap[treeIndex] = globalColor$6.clone();
  });
  return collection;
}

function parse$d(data) {
  var matchingGeometries = findMatchingGeometries$d(data.geometries);
  var group = new InstancedMeshGroup();
  matchingGeometries.geometries.forEach(function (geometry) {
    var fileId = geometry.file[0].fileId;
    var nodes = geometry.nodes;
    var instancedMesh = new InstancedMesh(fileId);
    nodes.forEach(function (node) {
      var newCollection = createCollection(node, data);

      if (newCollection.triangleCount > 0) {
        instancedMesh.addCollection(newCollection);
      }
    }); // Only add it to the group if we created a new one. If we didn't,
    // the instanced mesh is on another sector.

    if (instancedMesh.collections.length > 0) {
      data.sceneStats.geometryCount.InstancedMesh += 1;
      group.addMesh(instancedMesh);
    }
  });
  return group;
} // Copyright 2019 Cognite AS
// Copyright 2019 Cognite AS


function createSceneStats() {
  return {
    numNodes: 0,
    numSectors: 0,
    geometryCount: {
      InstancedMesh: 0,
      MergedMesh: 0,
      Box: 0,
      Circle: 0,
      Cone: 0,
      EccentricCone: 0,
      EllipsoidSegment: 0,
      GeneralCylinder: 0,
      GeneralRing: 0,
      Nut: 0,
      Quad: 0,
      SphericalSegment: 0,
      TorusSegment: 0,
      Trapezium: 0
    }
  };
} // Copyright 2019 Cognite AS


var globalMatrix$2 = new Matrix4();
var TRIANGLE_COUNT_LIMIT = 10000;

function mergeInstancedMeshes(rootSector, sceneStats) {
  var e_1, _a;

  var _loop_1 = function _loop_1(sector) {
    // for each instanced mesh object with a given fileId
    sector.instancedMeshGroup.meshes.forEach(function (instancedMesh) {
      // Get all small instanced mesh collections, sorted by size
      var smallCollections = instancedMesh.collections.filter(function (collection) {
        return collection.mappings.count * collection.triangleCount <= TRIANGLE_COUNT_LIMIT;
      });
      var mappingsSortedBySize = [];
      smallCollections.forEach(function (collection, collectionIndex) {
        for (var mappingIndex = 0; mappingIndex < collection.mappings.count; mappingIndex++) {
          mappingsSortedBySize.push({
            collectionIndex: collectionIndex,
            mappingIndex: mappingIndex,
            size: collection.mappings.getSize(mappingIndex)
          });
        }
      });
      mappingsSortedBySize.sort(function (a, b) {
        return b.size - a.size;
      }); // Create a new merged mesh

      var smallCollectionsTriangleCount = smallCollections.reduce(function (acc, collection) {
        return acc + collection.mappings.count;
      }, 0);
      var mergedMesh = new MergedMesh(smallCollectionsTriangleCount, instancedMesh.fileId, true); // Move the instanced meshes into one merged mesh, sorted by size

      mappingsSortedBySize.forEach(function (mappingInfo) {
        var collectionIndex = mappingInfo.collectionIndex,
            mappingIndex = mappingInfo.mappingIndex;
        var collection = smallCollections[collectionIndex];
        var treeIndex = collection.mappings.getTreeIndex(mappingIndex);
        var size = collection.mappings.getSize(mappingIndex);
        collection.mappings.getTransformMatrix(globalMatrix$2, mappingIndex);
        mergedMesh.mappings.add(collection.triangleOffset, collection.triangleCount, treeIndex, size, globalMatrix$2);
      });
      smallCollections.forEach(function (collection) {
        instancedMesh.collections.splice(instancedMesh.collections.indexOf(collection), 1);
      });
      sceneStats.geometryCount.MergedMesh += 1;
      sector.mergedMeshGroup.addMesh(mergedMesh);
    });

    for (var i = sector.instancedMeshGroup.meshes.length - 1; i >= 0; i--) {
      if (sector.instancedMeshGroup.meshes[i].collections.length === 0) {
        sector.instancedMeshGroup.meshes.splice(i, 1);
      }
    }
  };

  try {
    for (var _b = __values(rootSector.traverseSectorsBreadthFirst()), _c = _b.next(); !_c.done; _c = _b.next()) {
      var sector = _c.value;

      _loop_1(sector);
    }
  } catch (e_1_1) {
    e_1 = {
      error: e_1_1
    };
  } finally {
    try {
      if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
    } finally {
      if (e_1) throw e_1.error;
    }
  }
} // Copyright 2019 Cognite AS


var primitiveParsers = [{
  type: 'Box',
  parser: parse
}, {
  type: 'Circle',
  parser: parse$1
}, {
  type: 'Cone',
  parser: parse$2
}, {
  type: 'EccentricCone',
  parser: parse$3
}, {
  type: 'EllipsoidSegment',
  parser: parse$4
}, {
  type: 'GeneralCylinder',
  parser: parse$5
}, {
  type: 'GeneralRing',
  parser: parse$6
}, {
  type: 'Nut',
  parser: parse$7
}, {
  type: 'Quad',
  parser: parse$8
}, {
  type: 'SphericalSegment',
  parser: parse$9
}, {
  type: 'TorusSegment',
  parser: parse$a
}, {
  type: 'Trapezium',
  parser: parse$b
}];

function parseGeometries(data) {
  var primitiveGroups = [];
  primitiveParsers.forEach(function (_a) {
    var type = _a.type,
        parser = _a.parser;
    var group = parser(data);

    if (group.capacity > 0) {
      primitiveGroups.push(group);
    }
  });
  var mergedMeshGroup = parse$c(data);
  var instancedMeshGroup = parse$d(data);
  return {
    primitiveGroups: primitiveGroups,
    mergedMeshGroup: mergedMeshGroup,
    instancedMeshGroup: instancedMeshGroup
  };
}

function parseProtobuf(protobufData, filterOptions) {
  return __awaiter(this, void 0, void 0, function () {
    var e_1, _a, e_2, _b, e_3, _c, e_4, _d, protobufDecoder, sectors, instancedMeshMap, sceneStats, treeIndexNodeIdMap, colorMap, count, handleSector, protobufData_1, protobufData_1_1, data, webNode, e_1_1, _e, _f, webNode, e_2_1, rootSector, _g, _h, primitiveGroup, e_3_1, _j, _k, sector, e_4_1, nodeIdTreeIndexMap, treeIndex, nodeId;

    var _this = this;

    return __generator(this, function (_l) {
      switch (_l.label) {
        case 0:
          protobufDecoder = new ProtobufDecoder();
          sectors = {};
          instancedMeshMap = {};
          sceneStats = createSceneStats();
          treeIndexNodeIdMap = [];
          colorMap = [];
          count = 0;

          handleSector = function handleSector(rawSector) {
            return __awaiter(_this, void 0, void 0, function () {
              var boundingBox, path, id, boundingBoxMin, boundingBoxMax, sector, _a, primitiveGroups, mergedMeshGroup, instancedMeshGroup, parentPath;

              return __generator(this, function (_b) {
                switch (_b.label) {
                  case 0:
                    boundingBox = rawSector.boundingBox, path = rawSector.path, id = rawSector.id;
                    boundingBoxMin = new Vector3(boundingBox.min.x, boundingBox.min.y, boundingBox.min.z);
                    boundingBoxMax = new Vector3(boundingBox.max.x, boundingBox.max.y, boundingBox.max.z);
                    sector = new Sector(id, boundingBoxMin, boundingBoxMax);
                    sectors[path] = sector;
                    _a = parseGeometries({
                      geometries: rawSector.geometries,
                      instancedMeshMap: instancedMeshMap,
                      sceneStats: sceneStats,
                      treeIndexNodeIdMap: treeIndexNodeIdMap,
                      colorMap: colorMap,
                      filterOptions: filterOptions
                    }), primitiveGroups = _a.primitiveGroups, mergedMeshGroup = _a.mergedMeshGroup, instancedMeshGroup = _a.instancedMeshGroup;
                    sector.primitiveGroups = primitiveGroups;
                    sector.mergedMeshGroup = mergedMeshGroup;
                    sector.instancedMeshGroup = instancedMeshGroup;
                    parentPath = getParentPath(path);

                    if (parentPath !== undefined) {
                      sectors[parentPath].addChild(sector);
                      sectors[parentPath].object3d.add(sector.object3d);
                    }

                    if (!(++count % 10 === 0)) return [3
                    /*break*/
                    , 2];
                    return [4
                    /*yield*/
                    , sleep(1)];

                  case 1:
                    _b.sent();

                    _b.label = 2;

                  case 2:
                    return [2
                    /*return*/
                    ];
                }
              });
            });
          };

          if (!(protobufData instanceof Array)) return [3
          /*break*/
          , 9];
          _l.label = 1;

        case 1:
          _l.trys.push([1, 6, 7, 8]);

          protobufData_1 = __values(protobufData), protobufData_1_1 = protobufData_1.next();
          _l.label = 2;

        case 2:
          if (!!protobufData_1_1.done) return [3
          /*break*/
          , 5];
          data = protobufData_1_1.value;
          webNode = protobufDecoder.decode(ProtobufDecoder.Types.WEB_NODE, data);
          return [4
          /*yield*/
          , handleSector(webNode)];

        case 3:
          _l.sent();

          _l.label = 4;

        case 4:
          protobufData_1_1 = protobufData_1.next();
          return [3
          /*break*/
          , 2];

        case 5:
          return [3
          /*break*/
          , 8];

        case 6:
          e_1_1 = _l.sent();
          e_1 = {
            error: e_1_1
          };
          return [3
          /*break*/
          , 8];

        case 7:
          try {
            if (protobufData_1_1 && !protobufData_1_1.done && (_a = protobufData_1.return)) _a.call(protobufData_1);
          } finally {
            if (e_1) throw e_1.error;
          }

          return [7
          /*endfinally*/
          ];

        case 8:
          return [3
          /*break*/
          , 16];

        case 9:
          _l.trys.push([9, 14, 15, 16]);

          _e = __values(protobufDecoder.decodeWebScene(protobufData)), _f = _e.next();
          _l.label = 10;

        case 10:
          if (!!_f.done) return [3
          /*break*/
          , 13];
          webNode = _f.value;
          return [4
          /*yield*/
          , handleSector(webNode)];

        case 11:
          _l.sent();

          _l.label = 12;

        case 12:
          _f = _e.next();
          return [3
          /*break*/
          , 10];

        case 13:
          return [3
          /*break*/
          , 16];

        case 14:
          e_2_1 = _l.sent();
          e_2 = {
            error: e_2_1
          };
          return [3
          /*break*/
          , 16];

        case 15:
          try {
            if (_f && !_f.done && (_b = _e.return)) _b.call(_e);
          } finally {
            if (e_2) throw e_2.error;
          }

          return [7
          /*endfinally*/
          ];

        case 16:
          rootSector = sectors['0/'];
          _l.label = 17;

        case 17:
          _l.trys.push([17, 22, 23, 24]);

          _g = __values(rootSector.traversePrimitiveGroups()), _h = _g.next();
          _l.label = 18;

        case 18:
          if (!!_h.done) return [3
          /*break*/
          , 21];
          primitiveGroup = _h.value;
          primitiveGroup.sort();
          if (!(++count % 10 === 0)) return [3
          /*break*/
          , 20];
          return [4
          /*yield*/
          , sleep(1)];

        case 19:
          _l.sent();

          _l.label = 20;

        case 20:
          _h = _g.next();
          return [3
          /*break*/
          , 18];

        case 21:
          return [3
          /*break*/
          , 24];

        case 22:
          e_3_1 = _l.sent();
          e_3 = {
            error: e_3_1
          };
          return [3
          /*break*/
          , 24];

        case 23:
          try {
            if (_h && !_h.done && (_c = _g.return)) _c.call(_g);
          } finally {
            if (e_3) throw e_3.error;
          }

          return [7
          /*endfinally*/
          ];

        case 24:
          mergeInstancedMeshes(rootSector, sceneStats);
          _l.label = 25;

        case 25:
          _l.trys.push([25, 30, 31, 32]);

          _j = __values(rootSector.traverseSectors()), _k = _j.next();
          _l.label = 26;

        case 26:
          if (!!_k.done) return [3
          /*break*/
          , 29];
          sector = _k.value;
          sector.mergedMeshGroup.createTreeIndexMap();
          sector.instancedMeshGroup.createTreeIndexMap();
          sceneStats.numSectors++;
          sector.primitiveGroups.forEach(function (primitiveGroup) {
            sceneStats.geometryCount[primitiveGroup.type] += primitiveGroup.data.count;
          });
          if (!(++count % 10 === 0)) return [3
          /*break*/
          , 28];
          return [4
          /*yield*/
          , sleep(1)];

        case 27:
          _l.sent();

          _l.label = 28;

        case 28:
          _k = _j.next();
          return [3
          /*break*/
          , 26];

        case 29:
          return [3
          /*break*/
          , 32];

        case 30:
          e_4_1 = _l.sent();
          e_4 = {
            error: e_4_1
          };
          return [3
          /*break*/
          , 32];

        case 31:
          try {
            if (_k && !_k.done && (_d = _j.return)) _d.call(_j);
          } finally {
            if (e_4) throw e_4.error;
          }

          return [7
          /*endfinally*/
          ];

        case 32:
          sceneStats.numNodes = treeIndexNodeIdMap.length;
          nodeIdTreeIndexMap = new Map();

          for (treeIndex = 0; treeIndex < treeIndexNodeIdMap.length; treeIndex++) {
            nodeId = treeIndexNodeIdMap[treeIndex];
            nodeIdTreeIndexMap.set(nodeId, treeIndex);
          }

          return [2
          /*return*/
          , {
            rootSector: rootSector,
            sceneStats: sceneStats,
            maps: {
              colorMap: colorMap,
              treeIndexNodeIdMap: treeIndexNodeIdMap,
              nodeIdTreeIndexMap: nodeIdTreeIndexMap,
              sectors: sectors
            }
          }];
      }
    });
  });
} // Copyright 2019 Cognite AS
// Copyright 2019 Cognite AS


var globalCenterA$5 = new Vector3();
var globalCenterB$5 = new Vector3();
var globalXAxis = new Vector3();
var globalAxisRotation = new Quaternion();

function addBox(groups, data, filterOptions) {
  groups.Box.add(data.nodeId, data.treeIndex, data.size, data.center, data.normal, data.rotationAngle, data.delta, filterOptions);
}

function addCircle(groups, data, filterOptions) {
  groups.Circle.add(data.nodeId, data.treeIndex, data.size, data.center, data.normal, data.radiusA, filterOptions);
}

function addNut(groups, data, filterOptions) {
  globalCenterA$5.copy(data.normal).multiplyScalar(data.height / 2).add(data.center);
  globalCenterB$5.copy(data.normal).multiplyScalar(-data.height / 2).add(data.center);
  groups.Nut.add(data.nodeId, data.treeIndex, data.size, globalCenterA$5, globalCenterB$5, data.radiusA, data.rotationAngle, filterOptions);
}

function addRing(groups, data, filterOptions) {
  globalXAxis.copy(xAxis).applyQuaternion(globalAxisRotation.setFromUnitVectors(zAxis, data.normal));
  groups.GeneralRing.add(data.nodeId, data.treeIndex, data.size, data.center, data.normal, globalXAxis, data.radiusB, data.radiusB, data.radiusB - data.radiusA, 0, 2 * Math.PI, filterOptions);
}

function addSphere(groups, data, filterOptions) {
  groups.SphericalSegment.add(data.nodeId, data.treeIndex, data.size, data.center, zAxis, data.radiusA, 2 * data.radiusA, filterOptions);
} // Copyright 2019 Cognite AS


var globalCenterA$6 = new Vector3();
var globalCenterB$6 = new Vector3();
var globalAxisRotation$1 = new Quaternion();
var globalXAxis$1 = new Vector3();
var globalVertex$2 = new Vector3();
var globalRotation$4 = new Quaternion();
var globalCapZAxis$2 = new Vector3();
var globalCapXAxis$2 = new Vector3();

function addOpenCone(groups, data, filterOptions) {
  globalCenterA$6.copy(data.normal).multiplyScalar(data.height / 2).add(data.center);
  globalCenterB$6.copy(data.normal).multiplyScalar(-data.height / 2).add(data.center);
  groups.Cone.add(data.nodeId, data.treeIndex, data.size, globalCenterA$6, globalCenterB$6, data.radiusA, data.radiusB, 0, Math.PI * 2, filterOptions);
}

function addOpenEccentricCone(groups, data, filterOptions) {
  globalCenterA$6.copy(data.normal).multiplyScalar(data.height / 2).add(data.center);
  globalCenterB$6.copy(data.normal).multiplyScalar(-data.height / 2).add(data.center);
  groups.EccentricCone.add(data.nodeId, data.treeIndex, data.size, globalCenterA$6, globalCenterB$6, data.radiusA, data.radiusB, data.normal, filterOptions);
}

function addClosedCone(groups, data, filterOptions) {
  addOpenCone(groups, data);
  groups.Circle.add(data.nodeId, data.treeIndex, data.size, globalCenterA$6, data.normal, data.radiusA, filterOptions);
  groups.Circle.add(data.nodeId, data.treeIndex, data.size, globalCenterB$6, data.normal, data.radiusB, filterOptions);
}

function addClosedEccentricCone(groups, data, filterOptions) {
  addOpenEccentricCone(groups, data);
  groups.Circle.add(data.nodeId, data.treeIndex, data.size, globalCenterA$6, data.normal, data.radiusA, filterOptions);
  groups.Circle.add(data.nodeId, data.treeIndex, data.size, globalCenterB$6, data.normal, data.radiusB, filterOptions);
}

function addOpenGeneralCone(groups, data, filterOptions) {
  globalCenterA$6.copy(data.normal).multiplyScalar(data.height / 2).add(data.center);
  globalCenterB$6.copy(data.normal).multiplyScalar(-data.height / 2).add(data.center);
  groups.Cone.add(data.nodeId, data.treeIndex, data.size, globalCenterA$6, globalCenterB$6, data.radiusA, data.radiusB, data.rotationAngle, data.arcAngle, filterOptions);
}

function addClosedGeneralCone(groups, data, filterOptions) {
  addOpenGeneralCone(groups, data, filterOptions);
  globalXAxis$1.copy(xAxis).applyQuaternion(globalAxisRotation$1.setFromUnitVectors(zAxis, data.normal));
  groups.GeneralRing.add(data.nodeId, data.treeIndex, data.size, globalCenterA$6, data.normal, globalXAxis$1, data.radiusA, data.radiusA, data.thickness, data.rotationAngle, data.arcAngle, filterOptions);
  groups.GeneralRing.add(data.nodeId, data.treeIndex, data.size, globalCenterB$6, data.normal, globalXAxis$1, data.radiusB, data.radiusB, data.thickness, data.rotationAngle, data.arcAngle, filterOptions);
}

function addSolidOpenGeneralCone(groups, data, filterOptions) {
  addClosedGeneralCone(groups, data, filterOptions);
  groups.Cone.add(data.nodeId, data.treeIndex, data.size, globalCenterA$6, globalCenterB$6, data.radiusA - data.thickness, data.radiusB - data.thickness, data.rotationAngle, data.arcAngle, filterOptions);
}

function addSolidClosedGeneralCone(groups, data, filterOptions) {
  addSolidOpenGeneralCone(groups, data, filterOptions);
  globalCapZAxis$2.copy(globalCenterA$6).sub(globalCenterB$6);
  globalRotation$4.setFromUnitVectors(zAxis, globalCapZAxis$2.normalize());
  globalCapXAxis$2.copy(xAxis).applyQuaternion(globalRotation$4);
  [false, true].forEach(function (isSecondQuad) {
    var finalAngle = data.rotationAngle + Number(isSecondQuad) * data.arcAngle;
    globalVertex$2.set(Math.cos(finalAngle), Math.sin(finalAngle), 0).applyQuaternion(globalRotation$4).normalize();
    var vertices = [];
    var offsets = [0, -data.thickness];
    [true, false].forEach(function (isA) {
      if (isSecondQuad) {
        isA = !isA;
      }

      var radius = isA ? data.radiusA : data.radiusB;
      var center = isA ? globalCenterA$6 : globalCenterB$6;
      offsets.forEach(function (offset) {
        vertices.push(globalVertex$2.clone().multiplyScalar(radius + offset).add(center));
      });
    });
    groups.Trapezium.add(data.nodeId, data.treeIndex, data.size, vertices[0], vertices[1], vertices[2], vertices[3], filterOptions);
  });
} // Copyright 2019 Cognite AS


var globalCenterA$7 = new Vector3();
var globalCenterB$7 = new Vector3();
var globalVertex$3 = new Vector3();
var globalVertex1$1 = new Vector3();
var globalVertex2$1 = new Vector3();
var globalVertex3$1 = new Vector3();
var globalQuadNorm = new Vector3();
var globalAxisRotation$2 = new Quaternion();
var globalXAxis$2 = new Vector3();

function addOpenExtrudedRingSegment(groups, data, filterOptions) {
  globalCenterA$7.copy(data.normal).multiplyScalar(data.height / 2).add(data.center);
  globalCenterB$7.copy(data.normal).multiplyScalar(-data.height / 2).add(data.center);
  globalXAxis$2.copy(xAxis).applyQuaternion(globalAxisRotation$2.setFromUnitVectors(zAxis, data.normal));
  groups.GeneralRing.add(data.nodeId, data.treeIndex, data.size, globalCenterA$7, data.normal, globalXAxis$2, data.radiusB, data.radiusB, data.radiusB - data.radiusA, data.rotationAngle, data.arcAngle, filterOptions);
  groups.GeneralRing.add(data.nodeId, data.treeIndex, data.size, globalCenterB$7, data.normal, globalXAxis$2, data.radiusB, data.radiusB, data.radiusB - data.radiusA, data.rotationAngle, data.arcAngle, filterOptions);
  groups.Cone.add(data.nodeId, data.treeIndex, data.size, globalCenterA$7, globalCenterB$7, data.radiusA, data.radiusA, data.rotationAngle, data.arcAngle, filterOptions);
  groups.Cone.add(data.nodeId, data.treeIndex, data.size, globalCenterA$7, globalCenterB$7, data.radiusB, data.radiusB, data.rotationAngle, data.arcAngle, filterOptions);
}

function addClosedExtrudedRingSegment(groups, data, filterOptions) {
  addOpenExtrudedRingSegment(groups, data); // quad 1

  globalQuadNorm.copy(globalCenterA$7).sub(globalCenterB$7).normalize();
  globalAxisRotation$2.setFromUnitVectors(zAxis, globalQuadNorm);
  var quadOneAngle = data.rotationAngle;
  globalVertex$3.set(Math.cos(quadOneAngle), Math.sin(quadOneAngle), 0).applyQuaternion(globalAxisRotation$2).normalize();
  globalVertex1$1.copy(globalVertex$3).multiplyScalar(data.radiusB).add(globalCenterA$7);
  globalVertex2$1.copy(globalVertex$3).multiplyScalar(data.radiusA).add(globalCenterB$7);
  globalVertex3$1.copy(globalVertex$3).multiplyScalar(data.radiusB).add(globalCenterB$7);
  groups.Quad.add(data.nodeId, data.treeIndex, data.size, globalVertex2$1, globalVertex1$1, globalVertex3$1, filterOptions); // quad 2

  globalQuadNorm.copy(globalCenterA$7).sub(globalCenterB$7).normalize();
  globalAxisRotation$2.setFromUnitVectors(zAxis, globalQuadNorm);
  var quadTwoAngle = data.rotationAngle + data.arcAngle;
  globalVertex$3.set(Math.cos(quadTwoAngle), Math.sin(quadTwoAngle), 0).applyQuaternion(globalAxisRotation$2).normalize();
  globalVertex1$1.copy(globalVertex$3).multiplyScalar(data.radiusB).add(globalCenterA$7);
  globalVertex2$1.copy(globalVertex$3).multiplyScalar(data.radiusA).add(globalCenterB$7);
  globalVertex3$1.copy(globalVertex$3).multiplyScalar(data.radiusB).add(globalCenterB$7); // Note that globalVertexes 2 and 1 are flipped

  groups.Quad.add(data.nodeId, data.treeIndex, data.size, globalVertex1$1, globalVertex2$1, globalVertex3$1, filterOptions);
}

function addExtrudedRing(groups, data, filterOptions) {
  data.rotationAngle = 0;
  data.arcAngle = Math.PI * 2; // Don't need the quads, so call addOpenExtrudedRingSegment

  addOpenExtrudedRingSegment(groups, data, filterOptions);
} // Copyright 2019 Cognite AS


var globalCenterA$8 = new Vector3();
var globalCenterB$8 = new Vector3();
var globalExtA$2 = new Vector3();
var globalExtB$2 = new Vector3();
var globalSlicingPlaneNormal$1 = new Vector3();
var globalVertex$4 = new Vector3();
var globalRotation$5 = new Quaternion();
var globalPlanes$2 = [new Plane(), new Plane()];
var globalLine$2 = new Line3();
var globalLineStart$2 = new Vector3();
var globalLineEnd$2 = new Vector3();
var globalVector$2 = new Vector3();
var globalVertices$1 = [new Vector3(), new Vector3(), new Vector3(), new Vector3()];

function addClosedCylinder(groups, data, filterOptions) {
  globalCenterA$8.copy(data.normal).multiplyScalar(data.height / 2).add(data.center);
  globalCenterB$8.copy(data.normal).multiplyScalar(-data.height / 2).add(data.center);
  groups.Cone.add(data.nodeId, data.treeIndex, data.size, globalCenterA$8, globalCenterB$8, data.radiusA, data.radiusA, 0, 2 * Math.PI, filterOptions);
  groups.Circle.add(data.nodeId, data.treeIndex, data.size, globalCenterA$8, data.normal, data.radiusA, filterOptions);
  groups.Circle.add(data.nodeId, data.treeIndex, data.size, globalCenterB$8, data.normal, data.radiusA, filterOptions);
}

function addOpenCylinder(groups, data, filterOptions) {
  globalCenterA$8.copy(data.normal).multiplyScalar(data.height / 2).add(data.center);
  globalCenterB$8.copy(data.normal).multiplyScalar(-data.height / 2).add(data.center);
  groups.Cone.add(data.nodeId, data.treeIndex, data.size, globalCenterA$8, globalCenterB$8, data.radiusA, data.radiusA, 0, 2 * Math.PI, filterOptions);
}

function angleBetweenVector3s$1(v1, v2, up) {
  var angle = v1.angleTo(v2);
  var right = globalVector$2.copy(v1).cross(up);
  var moreThanPi = right.dot(v2) < 0;
  return normalizeRadians$1(moreThanPi ? 2 * Math.PI - angle : angle);
}

function normalizeRadians$1(angle, lowerBound, upperBound) {
  if (lowerBound === void 0) {
    lowerBound = -Math.PI;
  }

  if (upperBound === void 0) {
    upperBound = Math.PI;
  }

  while (angle < lowerBound) {
    angle += 2 * Math.PI;
  }

  while (angle > upperBound) {
    angle -= 2 * Math.PI;
  }

  return angle;
}

function addOpenGeneralCylinder(groups, data, filterOptions) {
  globalCenterA$8.copy(data.normal).multiplyScalar(data.height / 2).add(data.center);
  globalCenterB$8.copy(data.normal).multiplyScalar(-data.height / 2).add(data.center);
  var distFromAToExtA = data.radiusA * Math.tan(data.slopeA);
  var distFromBToExtB = data.radiusA * Math.tan(data.slopeB);
  var heightA = distFromBToExtB + data.height;
  var heightB = distFromBToExtB;
  globalExtA$2.copy(data.normal).multiplyScalar(distFromAToExtA).add(globalCenterA$8);
  globalExtB$2.copy(data.normal).multiplyScalar(-distFromBToExtB).add(globalCenterB$8);
  groups.GeneralCylinder.add(data.nodeId, data.treeIndex, data.size, globalExtA$2, globalExtB$2, data.radiusA, heightA, heightB, data.slopeA, data.slopeB, data.zAngleA, data.zAngleB, data.rotationAngle, data.arcAngle, filterOptions);
}

function addClosedGeneralCylinder(groups, data, filterOptions) {
  addOpenGeneralCylinder(groups, data, filterOptions);
  [true, false].forEach(function (isA) {
    var center = isA ? globalCenterA$8 : globalCenterB$8;
    var slope = isA ? data.slopeA : data.slopeB;
    var zAngle = isA ? data.zAngleA : data.zAngleB;
    var radius = isA ? data.radiusA : data.radiusB;
    globalRotation$5.setFromUnitVectors(zAxis, data.normal);
    globalSlicingPlaneNormal$1.copy(zAxis).applyAxisAngle(yAxis, slope).applyAxisAngle(zAxis, zAngle).applyQuaternion(globalRotation$5);
    var plane = globalPlanes$2[Number(Boolean(isA))];
    plane.setFromNormalAndCoplanarPoint(globalSlicingPlaneNormal$1, center);
    var capXAxis = xAxis.clone().applyAxisAngle(yAxis, slope).applyAxisAngle(zAxis, zAngle).applyQuaternion(globalRotation$5).normalize();
    globalVertex$4.set(Math.cos(data.rotationAngle), Math.sin(data.rotationAngle), 0).applyQuaternion(globalRotation$5).normalize();
    globalLineStart$2.copy(globalVertex$4).multiplyScalar(data.radiusA).add(globalExtB$2).sub(data.normal);
    globalLineEnd$2.copy(globalVertex$4).multiplyScalar(data.radiusA).add(globalExtA$2).add(data.normal);
    globalLine$2.set(globalLineStart$2, globalLineEnd$2);
    plane.intersectLine(globalLine$2, globalVertex$4);
    var capAngleAxis = globalVertex$4.sub(center).normalize();
    var capAngle = angleBetweenVector3s$1(capAngleAxis, capXAxis, globalSlicingPlaneNormal$1);
    groups.GeneralRing.add(data.nodeId, data.treeIndex, data.size, center, globalSlicingPlaneNormal$1, capXAxis, radius / Math.abs(Math.cos(slope)), radius, data.thickness, capAngle, data.arcAngle, filterOptions);
  });
}

function addSolidOpenGeneralCylinder(groups, data, filterOptions) {
  addClosedGeneralCylinder(groups, data, filterOptions);
  var distFromBToExtB = data.radiusA * Math.tan(data.slopeB);
  var heightA = distFromBToExtB + data.height;
  var heightB = distFromBToExtB;
  groups.GeneralCylinder.add(data.nodeId, data.treeIndex, data.size, globalExtA$2, globalExtB$2, data.radiusA - data.thickness, heightA, heightB, data.slopeA, data.slopeB, data.zAngleA, data.zAngleB, data.rotationAngle, data.arcAngle, filterOptions);
}

function addSolidClosedGeneralCylinder(groups, data, filterOptions) {
  addSolidOpenGeneralCylinder(groups, data, filterOptions);
  [false, true].forEach(function (isSecondQuad) {
    var vertexIndex = 0;
    var finalAngle = data.rotationAngle + Number(isSecondQuad) * data.arcAngle;
    var radii = !isSecondQuad ? [data.radiusA, data.radiusA - data.thickness] : [data.radiusA - data.thickness, data.radiusA];
    globalVertex$4.set(Math.cos(finalAngle), Math.sin(finalAngle), 0).applyQuaternion(globalRotation$5).normalize();
    radii.forEach(function (r) {
      globalLineStart$2.copy(globalVertex$4).multiplyScalar(r).add(globalExtB$2).sub(data.normal);
      globalLineEnd$2.copy(globalVertex$4).multiplyScalar(r).add(globalExtA$2).add(data.normal);
      globalLine$2.set(globalLineStart$2, globalLineEnd$2);
      globalPlanes$2.forEach(function (p) {
        p.intersectLine(globalLine$2, globalVertices$1[vertexIndex]);
        vertexIndex++;
      });
    });
    groups.Trapezium.add(data.nodeId, data.treeIndex, data.size, globalVertices$1[0], globalVertices$1[1], globalVertices$1[2], globalVertices$1[3], filterOptions);
  });
} // Copyright 2019 Cognite AS


var globalCenterA$9 = new Vector3();

function addOpenEllipsoidSegment(groups, data, filterOptions) {
  groups.EllipsoidSegment.add(data.nodeId, data.treeIndex, data.size, data.center, data.normal, data.radiusA, data.radiusB, data.radiusB * 2, filterOptions);
}

function addClosedEllipsoidSegment(groups, data, filterOptions) {
  addOpenEllipsoidSegment(groups, data, filterOptions);
  var length = data.radiusB - data.height;
  var circleRadius = Math.sqrt(Math.pow(data.radiusB, 2) - Math.pow(length, 2)) * data.radiusA / data.radiusB;
  globalCenterA$9.copy(data.normal).normalize().multiplyScalar(length).add(data.center);
  groups.Circle.add(data.nodeId, data.treeIndex, data.size, globalCenterA$9, data.normal, circleRadius, filterOptions);
}

function addEllipsoid(groups, data, filterOptions) {
  data.height = 2 * data.radiusB;
  addOpenEllipsoidSegment(groups, data, filterOptions);
} // Copyright 2019 Cognite AS


function addOpenTorusSegment(groups, data, filterOptions) {
  groups.TorusSegment.add(data.nodeId, data.treeIndex, data.size, data.center, data.normal, data.radiusA, data.radiusB, data.rotationAngle, data.arcAngle, filterOptions);
}

function addClosedTorusSegment(groups, data, filterOptions) {
  addOpenTorusSegment(groups, data, filterOptions); // groups.circle.add
  // groups.circle.add
}

function addTorus(groups, data, filterOptions) {
  groups.TorusSegment.add(data.nodeId, data.treeIndex, data.size, data.center, data.normal, data.radiusA, data.radiusB, 0, Math.PI * 2, filterOptions);
} // Copyright 2019 Cognite AS


var globalCenterA$a = new Vector3();

function addOpenSphericalSegment(groups, data, filterOptions) {
  groups.SphericalSegment.add(data.nodeId, data.treeIndex, data.size, data.center, data.normal, data.radiusA, data.height, filterOptions);
}

function addClosedSphericalSegment(groups, data, filterOptions) {
  addOpenSphericalSegment(groups, data, filterOptions);
  var length = data.radiusA - data.height;
  var circleRadius = Math.sqrt(Math.pow(data.radiusA, 2) - Math.pow(length, 2));
  globalCenterA$a.copy(data.normal).normalize().multiplyScalar(length).add(data.center);
  groups.Circle.add(data.nodeId, data.treeIndex, data.size, globalCenterA$a, data.normal, circleRadius, filterOptions);
} // Copyright 2019 Cognite AS


var FilePrimitiveNames = ['Box', 'Circle', 'ClosedCone', 'ClosedCylinder', 'ClosedEccentricCone', 'ClosedEllipsoidSegment', 'ClosedExtrudedRingSegment', 'ClosedGeneralCylinder', 'ClosedSphericalSegment', 'ClosedTorusSegment', 'Ellipsoid', 'ExtrudedRing', 'Nut', 'OpenCone', 'OpenCylinder', 'OpenEccentricCone', 'OpenEllipsoidSegment', 'OpenExtrudedRingSegment', 'OpenGeneralCylinder', 'OpenSphericalSegment', 'OpenTorusSegment', 'Ring', 'Sphere', 'Torus', 'SolidOpenGeneralCylinder', 'SolidClosedGeneralCylinder', 'OpenGeneralCone', 'ClosedGeneralCone', 'SolidOpenGeneralCone', 'SolidClosedGeneralCone'];
var IdToFileGeometryName = {
  1: 'Box',
  2: 'Circle',
  3: 'ClosedCone',
  4: 'ClosedCylinder',
  5: 'ClosedEccentricCone',
  6: 'ClosedEllipsoidSegment',
  7: 'ClosedExtrudedRingSegment',
  9: 'ClosedSphericalSegment',
  10: 'ClosedTorusSegment',
  11: 'Ellipsoid',
  12: 'ExtrudedRing',
  13: 'Nut',
  14: 'OpenCone',
  15: 'OpenCylinder',
  16: 'OpenEccentricCone',
  17: 'OpenEllipsoidSegment',
  18: 'OpenExtrudedRingSegment',
  20: 'OpenSphericalSegment',
  21: 'OpenTorusSegment',
  22: 'Ring',
  23: 'Sphere',
  24: 'Torus',
  30: 'OpenGeneralCylinder',
  31: 'ClosedGeneralCylinder',
  32: 'SolidOpenGeneralCylinder',
  33: 'SolidClosedGeneralCylinder',
  34: 'OpenGeneralCone',
  35: 'ClosedGeneralCone',
  36: 'SolidOpenGeneralCone',
  37: 'SolidClosedGeneralCone',
  100: 'MergedMesh',
  101: 'InstancedMesh'
};
var BYTES_PER_NODE_ID = 7;
var DEFAULT_COLOR = new Color(0, 0, 100);
var FilePropertyArrayNames = ['color', 'size', 'centerX', 'centerY', 'centerZ', 'normal', 'delta', 'height', 'radius', 'angle', 'translationX', 'translationY', 'translationZ', 'scaleX', 'scaleY', 'scaleZ', 'fileId']; // If adding new parameters, also update PropergeometryNameType

var fileGeometryProperties = {
  Box: ['treeIndex', 'color', 'size', 'center', 'normal', 'delta', 'rotationAngle'],
  Circle: ['treeIndex', 'color', 'size', 'center', 'normal', 'radiusA'],
  ClosedCone: ['treeIndex', 'color', 'size', 'center', 'normal', 'height', 'radiusA', 'radiusB'],
  ClosedCylinder: ['treeIndex', 'color', 'size', 'center', 'normal', 'height', 'radiusA'],
  ClosedEccentricCone: ['treeIndex', 'color', 'size', 'center', 'normal', 'height', 'radiusA', 'radiusB', 'capNormal'],
  ClosedEllipsoidSegment: ['treeIndex', 'color', 'size', 'center', 'normal', 'height', 'radiusA', 'radiusB'],
  ClosedExtrudedRingSegment: ['treeIndex', 'color', 'size', 'center', 'normal', 'height', 'radiusA', 'radiusB', 'rotationAngle', 'arcAngle'],
  ClosedSphericalSegment: ['treeIndex', 'color', 'size', 'center', 'normal', 'height', 'radiusA'],
  ClosedTorusSegment: ['treeIndex', 'color', 'size', 'center', 'normal', 'radiusA', 'radiusB', 'rotationAngle', 'arcAngle'],
  Ellipsoid: ['treeIndex', 'color', 'size', 'center', 'normal', 'radiusA', 'radiusB'],
  ExtrudedRing: ['treeIndex', 'color', 'size', 'center', 'normal', 'height', 'radiusA', 'radiusB'],
  Nut: ['treeIndex', 'color', 'size', 'center', 'normal', 'height', 'radiusA', 'rotationAngle'],
  OpenCone: ['treeIndex', 'color', 'size', 'center', 'normal', 'height', 'radiusA', 'radiusB'],
  OpenCylinder: ['treeIndex', 'color', 'size', 'center', 'normal', 'height', 'radiusA'],
  OpenEccentricCone: ['treeIndex', 'color', 'size', 'center', 'normal', 'height', 'radiusA', 'radiusB', 'capNormal'],
  OpenEllipsoidSegment: ['treeIndex', 'color', 'size', 'center', 'normal', 'height', 'radiusA', 'radiusB'],
  OpenExtrudedRingSegment: ['treeIndex', 'color', 'size', 'center', 'normal', 'height', 'radiusA', 'radiusB', 'rotationAngle', 'arcAngle'],
  OpenSphericalSegment: ['treeIndex', 'color', 'size', 'center', 'normal', 'height', 'radiusA'],
  OpenTorusSegment: ['treeIndex', 'color', 'size', 'center', 'normal', 'radiusA', 'radiusB', 'rotationAngle', 'arcAngle'],
  Ring: ['treeIndex', 'color', 'size', 'center', 'normal', 'radiusA', 'radiusB'],
  Sphere: ['treeIndex', 'color', 'size', 'center', 'radiusA'],
  Torus: ['treeIndex', 'color', 'size', 'center', 'normal', 'radiusA', 'radiusB'],
  MergedMesh: ['treeIndex', 'fileId', 'triangleCount', 'color', 'size'],
  InstancedMesh: ['treeIndex', 'fileId', 'triangleOffset', 'triangleCount', 'color', 'size', 'translation', 'rotation3', 'scale'],
  OpenGeneralCylinder: ['treeIndex', 'color', 'size', 'center', 'normal', 'height', 'radiusA', 'rotationAngle', 'arcAngle', 'slopeA', 'slopeB', 'zAngleA', 'zAngleB'],
  ClosedGeneralCylinder: ['treeIndex', 'color', 'size', 'center', 'normal', 'height', 'radiusA', 'rotationAngle', 'arcAngle', 'slopeA', 'slopeB', 'zAngleA', 'zAngleB'],
  SolidOpenGeneralCylinder: ['treeIndex', 'color', 'size', 'center', 'normal', 'height', 'radiusA', 'thickness', 'rotationAngle', 'arcAngle', 'slopeA', 'slopeB', 'zAngleA', 'zAngleB'],
  SolidClosedGeneralCylinder: ['treeIndex', 'color', 'size', 'center', 'normal', 'height', 'radiusA', 'thickness', 'rotationAngle', 'arcAngle', 'slopeA', 'slopeB', 'zAngleA', 'zAngleB'],
  OpenGeneralCone: ['treeIndex', 'color', 'size', 'center', 'normal', 'height', 'radiusA', 'radiusB', 'rotationAngle', 'arcAngle', 'slopeA', 'slopeB', 'zAngleA', 'zAngleB'],
  ClosedGeneralCone: ['treeIndex', 'color', 'size', 'center', 'normal', 'height', 'radiusA', 'radiusB', 'rotationAngle', 'arcAngle', 'slopeA', 'slopeB', 'zAngleA', 'zAngleB'],
  SolidOpenGeneralCone: ['treeIndex', 'color', 'size', 'center', 'normal', 'height', 'radiusA', 'radiusB', 'thickness', 'rotationAngle', 'arcAngle', 'slopeA', 'slopeB', 'zAngleA', 'zAngleB'],
  SolidClosedGeneralCone: ['treeIndex', 'color', 'size', 'center', 'normal', 'height', 'radiusA', 'radiusB', 'thickness', 'rotationAngle', 'arcAngle', 'slopeA', 'slopeB', 'zAngleA', 'zAngleB']
};
var renderedPrimitiveToAddFunction = {
  Box: addBox,
  Circle: addCircle,
  ClosedCone: addClosedCone,
  ClosedCylinder: addClosedCylinder,
  ClosedEccentricCone: addClosedEccentricCone,
  ClosedEllipsoidSegment: addClosedEllipsoidSegment,
  ClosedExtrudedRingSegment: addClosedExtrudedRingSegment,
  ClosedSphericalSegment: addClosedSphericalSegment,
  ClosedTorusSegment: addClosedTorusSegment,
  Ellipsoid: addEllipsoid,
  ExtrudedRing: addExtrudedRing,
  Nut: addNut,
  OpenCone: addOpenCone,
  OpenCylinder: addOpenCylinder,
  OpenEccentricCone: addOpenEccentricCone,
  OpenEllipsoidSegment: addOpenEllipsoidSegment,
  OpenExtrudedRingSegment: addOpenExtrudedRingSegment,
  OpenSphericalSegment: addOpenSphericalSegment,
  OpenTorusSegment: addOpenTorusSegment,
  Ring: addRing,
  Sphere: addSphere,
  Torus: addTorus,
  ClosedGeneralCylinder: addClosedGeneralCylinder,
  OpenGeneralCylinder: addOpenGeneralCylinder,
  SolidOpenGeneralCylinder: addSolidOpenGeneralCylinder,
  SolidClosedGeneralCylinder: addSolidClosedGeneralCylinder,
  ClosedGeneralCone: addClosedGeneralCone,
  OpenGeneralCone: addOpenGeneralCone,
  SolidOpenGeneralCone: addSolidOpenGeneralCone,
  SolidClosedGeneralCone: addSolidClosedGeneralCone
};
var renderedPrimitivesPerFilePrimitive = {
  Box: [{
    name: 'Box',
    count: 1
  }],
  Circle: [{
    name: 'Circle',
    count: 1
  }],
  ClosedCone: [{
    name: 'Circle',
    count: 2
  }, {
    name: 'Cone',
    count: 1
  }],
  ClosedCylinder: [{
    name: 'Circle',
    count: 2
  }, {
    name: 'Cone',
    count: 1
  }],
  ClosedEccentricCone: [{
    name: 'Circle',
    count: 2
  }, {
    name: 'EccentricCone',
    count: 1
  }],
  ClosedEllipsoidSegment: [{
    name: 'EllipsoidSegment',
    count: 1
  }, {
    name: 'Circle',
    count: 1
  }],
  ClosedExtrudedRingSegment: [{
    name: 'Cone',
    count: 2
  }, {
    name: 'GeneralRing',
    count: 2
  }, {
    name: 'Quad',
    count: 2
  }],
  ClosedSphericalSegment: [{
    name: 'Circle',
    count: 1
  }, {
    name: 'SphericalSegment',
    count: 1
  }],
  ClosedTorusSegment: [{
    name: 'TorusSegment',
    count: 1
  }],
  Ellipsoid: [{
    name: 'EllipsoidSegment',
    count: 1
  }],
  ExtrudedRing: [{
    name: 'Cone',
    count: 2
  }, {
    name: 'GeneralRing',
    count: 2
  }],
  Nut: [{
    name: 'Nut',
    count: 1
  }],
  OpenCone: [{
    name: 'Cone',
    count: 1
  }],
  OpenCylinder: [{
    name: 'Cone',
    count: 1
  }],
  OpenEccentricCone: [{
    name: 'EccentricCone',
    count: 1
  }],
  OpenEllipsoidSegment: [{
    name: 'EllipsoidSegment',
    count: 1
  }],
  OpenExtrudedRingSegment: [{
    name: 'Cone',
    count: 2
  }, {
    name: 'GeneralRing',
    count: 2
  }],
  OpenSphericalSegment: [{
    name: 'SphericalSegment',
    count: 1
  }],
  OpenTorusSegment: [{
    name: 'TorusSegment',
    count: 1
  }],
  Ring: [{
    name: 'GeneralRing',
    count: 1
  }],
  Sphere: [{
    name: 'SphericalSegment',
    count: 1
  }],
  Torus: [{
    name: 'TorusSegment',
    count: 1
  }],
  ClosedGeneralCylinder: [{
    name: 'GeneralCylinder',
    count: 1
  }, {
    name: 'GeneralRing',
    count: 2
  }],
  OpenGeneralCylinder: [{
    name: 'GeneralCylinder',
    count: 1
  }],
  SolidOpenGeneralCylinder: [{
    name: 'GeneralCylinder',
    count: 2
  }, {
    name: 'GeneralRing',
    count: 2
  }],
  SolidClosedGeneralCylinder: [{
    name: 'GeneralCylinder',
    count: 2
  }, {
    name: 'GeneralRing',
    count: 2
  }, {
    name: 'Trapezium',
    count: 2
  }],
  ClosedGeneralCone: [{
    name: 'Cone',
    count: 1
  }, {
    name: 'GeneralRing',
    count: 2
  }],
  OpenGeneralCone: [{
    name: 'Cone',
    count: 1
  }],
  SolidOpenGeneralCone: [{
    name: 'Cone',
    count: 2
  }, {
    name: 'GeneralRing',
    count: 2
  }],
  SolidClosedGeneralCone: [{
    name: 'Cone',
    count: 2
  }, {
    name: 'GeneralRing',
    count: 2
  }, {
    name: 'Trapezium',
    count: 2
  }]
};
var renderedPrimitiveToGroup = {
  Box: BoxGroup,
  Circle: CircleGroup,
  Cone: ConeGroup,
  EccentricCone: EccentricConeGroup,
  EllipsoidSegment: EllipsoidSegmentGroup,
  GeneralCylinder: GeneralCylinderGroup,
  GeneralRing: GeneralRingGroup,
  Nut: NutGroup,
  Quad: QuadGroup,
  SphericalSegment: SphericalSegmentGroup,
  TorusSegment: TorusSegmentGroup,
  Trapezium: TrapeziumGroup
}; // Copyright 2019 Cognite AS

var PropertyLoader =
/** @class */
function () {
  function PropertyLoader(uncompressedValues) {
    var _this = this;

    this.nodeId = 0;
    this.treeIndex = 0;
    this.color = new Color();
    this.size = 0;
    this.center = new Vector3();
    this.normal = new Vector3();
    this.delta = new Vector3();
    this.height = 0;
    this.radiusA = 0;
    this.radiusB = 0;
    this.capNormal = new Vector3();
    this.rotationAngle = 0;
    this.arcAngle = 0; // unique to general cylinder

    this.thickness = 0;
    this.slopeA = 0;
    this.slopeB = 0;
    this.zAngleA = 0;
    this.zAngleB = 0; // unique to triangle and instanced mesh

    this.fileId = 0;
    this.triangleOffset = 0;
    this.triangleCount = 0;
    this.translation = new Vector3();
    this.rotation3 = new Vector3();
    this.scale = new Vector3();
    this.parameterToDataLoadingFunction = {
      // tslint:disable:prettier
      treeIndex: function treeIndex(indices) {
        _this.treeIndex = indices.nextValue();
      },
      color: function color(indices) {
        var index = indices.nextValue();

        if (index === 0) {
          _this.color = DEFAULT_COLOR;
        } else {
          _this.color = _this.values.color[index - 1];
        }
      },
      center: function center(indices) {
        var centerX = _this.values.centerX[indices.nextValue()];

        var centerY = _this.values.centerY[indices.nextValue()];

        var centerZ = _this.values.centerZ[indices.nextValue()];

        _this.center.set(centerX, centerY, centerZ);
      },
      normal: function normal(indices) {
        _this.normal = _this.values.normal[indices.nextValue()];
      },
      delta: function delta(indices) {
        var deltaX = _this.values.delta[indices.nextValue()];

        var deltaY = _this.values.delta[indices.nextValue()];

        var deltaZ = _this.values.delta[indices.nextValue()];

        _this.delta.set(deltaX, deltaY, deltaZ);
      },
      height: function height(indices) {
        _this.height = _this.values.height[indices.nextValue()];
      },
      radiusA: function radiusA(indices) {
        _this.radiusA = _this.values.radius[indices.nextValue()];
      },
      radiusB: function radiusB(indices) {
        _this.radiusB = _this.values.radius[indices.nextValue()];
      },
      capNormal: function capNormal(indices) {
        _this.capNormal = _this.values.normal[indices.nextValue()];
      },
      arcAngle: function arcAngle(indices) {
        _this.arcAngle = _this.values.angle[indices.nextValue()];
      },
      rotationAngle: function rotationAngle(indices) {
        _this.rotationAngle = _this.values.angle[indices.nextValue()];
      },
      slopeA: function slopeA(indices) {
        _this.slopeA = _this.values.angle[indices.nextValue()];
      },
      slopeB: function slopeB(indices) {
        _this.slopeB = _this.values.angle[indices.nextValue()];
      },
      zAngleA: function zAngleA(indices) {
        _this.zAngleA = _this.values.angle[indices.nextValue()];
      },
      zAngleB: function zAngleB(indices) {
        _this.zAngleB = _this.values.angle[indices.nextValue()];
      },
      rotation3: function rotation3(indices) {
        var rotationX = _this.values.angle[indices.nextValue()];

        var rotationY = _this.values.angle[indices.nextValue()];

        var rotationZ = _this.values.angle[indices.nextValue()];

        _this.rotation3.set(rotationX, rotationY, rotationZ);
      },
      translation: function translation(indices) {
        var translationX = _this.values.translationX[indices.nextValue()];

        var translationY = _this.values.translationY[indices.nextValue()];

        var translationZ = _this.values.translationZ[indices.nextValue()];

        _this.translation.set(translationX, translationY, translationZ);
      },
      scale: function scale(indices) {
        var scaleX = _this.values.scaleX[indices.nextValue()];

        var scaleY = _this.values.scaleY[indices.nextValue()];

        var scaleZ = _this.values.scaleZ[indices.nextValue()];

        _this.scale.set(scaleX, scaleY, scaleZ);
      },
      triangleOffset: function triangleOffset(indices) {
        _this.triangleOffset = indices.nextValue();
      },
      triangleCount: function triangleCount(indices) {
        _this.triangleCount = indices.nextValue();
      },
      thickness: function thickness(indices) {
        _this.thickness = _this.values.radius[indices.nextValue()];
      },
      fileId: function fileId(indices) {
        _this.fileId = _this.values.fileId[indices.nextValue()];
      },
      size: function size(indices) {
        _this.size = _this.values.size[indices.nextValue()];
      }
    };
    this.values = uncompressedValues;
  }

  PropertyLoader.prototype.loadData = function (geometryInfo) {
    var _this = this;

    this.nodeId = geometryInfo.nodeIds.nextNodeId();
    fileGeometryProperties[geometryInfo.type].forEach(function (property) {
      _this.parameterToDataLoadingFunction[property].call(_this, geometryInfo.indices);
    });
  };

  return PropertyLoader;
}(); // Copyright 2019 Cognite AS


var matrix$1 = new Matrix4();
var rotation$4 = new Matrix4();

function unpackInstancedMeshes(rootSector, uncompressedValues, compressedData, maps, sceneStats) {
  var e_1, _a;

  var data = new PropertyLoader(uncompressedValues);

  var _loop_1 = function _loop_1(sector) {
    sector.instancedMeshGroup = new InstancedMeshGroup();
    var meshCounts = {}; // Count meshes per file id and triangle offset

    var geometryInfo = compressedData[sector.path].instancedMesh;

    if (geometryInfo !== undefined) {
      for (var i = 0; i < geometryInfo.count; i++) {
        data.loadData(geometryInfo);
        meshCounts[data.fileId] = meshCounts[data.fileId] ? meshCounts[data.fileId] : {};
        meshCounts[data.fileId][data.triangleOffset] = meshCounts[data.fileId][data.triangleOffset] ? meshCounts[data.fileId][data.triangleOffset] : {
          count: 0,
          triangleCount: data.triangleCount
        };
        meshCounts[data.fileId][data.triangleOffset].count++;
      }

      geometryInfo.indices.rewind();
      geometryInfo.nodeIds.rewind();
    } // Create mesh collections for each file Id and triangle offset


    var collections = {};
    Object.keys(meshCounts).forEach(function (fileId) {
      collections[fileId] = collections[fileId] !== undefined ? collections[fileId] : {};
      Object.keys(meshCounts[fileId]).forEach(function (triangleOffset) {
        var _a = meshCounts[fileId][triangleOffset],
            count = _a.count,
            triangleCount = _a.triangleCount;
        collections[fileId][triangleOffset] = new InstancedMeshCollection(parseInt(triangleOffset, 10), triangleCount, count);
      });
    }); // Fill mesh collections with matrix data

    if (geometryInfo !== undefined) {
      for (var i = 0; i < geometryInfo.count; i++) {
        data.loadData(geometryInfo);
        maps.treeIndexNodeIdMap[data.treeIndex] = data.nodeId;
        maps.colorMap[data.treeIndex] = data.color;
        matrix$1.identity().setPosition(data.translation);
        matrix$1.multiply(rotation$4.makeRotationAxis(zAxis, data.rotation3.z));
        matrix$1.multiply(rotation$4.makeRotationAxis(yAxis, data.rotation3.y));
        matrix$1.multiply(rotation$4.makeRotationAxis(xAxis, data.rotation3.x));
        matrix$1.scale(data.scale);
        collections[data.fileId][data.triangleOffset].addMapping(data.nodeId, data.treeIndex, data.size, matrix$1);
      }
    } // Add collections to sector group


    Object.keys(collections).forEach(function (fileId) {
      var instancedMesh = new InstancedMesh(parseInt(fileId, 10));
      Object.keys(collections[fileId]).forEach(function (triangleOffset) {
        instancedMesh.addCollection(collections[fileId][triangleOffset]);
      });
      sector.instancedMeshGroup.addMesh(instancedMesh);
      sceneStats.geometryCount.InstancedMesh += 1;
    });
  };

  try {
    for (var _b = __values(rootSector.traverseSectors()), _c = _b.next(); !_c.done; _c = _b.next()) {
      var sector = _c.value;

      _loop_1(sector);
    }
  } catch (e_1_1) {
    e_1 = {
      error: e_1_1
    };
  } finally {
    try {
      if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
    } finally {
      if (e_1) throw e_1.error;
    }
  }
} // Copyright 2019 Cognite AS


function unpackMergedMeshes(rootSector, uncompressedValues, compressedData, maps, sceneStats) {
  var e_1, _a;

  var data = new PropertyLoader(uncompressedValues);

  var _loop_1 = function _loop_1(sector) {
    sector.mergedMeshGroup = new MergedMeshGroup();
    var geometryInfo = compressedData[sector.path].mergedMesh;

    if (geometryInfo !== undefined) {
      // count meshes per file Id
      var meshCounts_1 = {};

      for (var i = 0; i < geometryInfo.count; i++) {
        data.loadData(geometryInfo);
        meshCounts_1[data.fileId] = meshCounts_1[data.fileId] ? meshCounts_1[data.fileId] : 0;
        meshCounts_1[data.fileId]++;
      }

      geometryInfo.indices.rewind();
      geometryInfo.nodeIds.rewind(); // create merged meshes

      var mergedMeshes_1 = {};
      Object.keys(meshCounts_1).forEach(function (fileId) {
        if (meshCounts_1[fileId] !== 0) {
          mergedMeshes_1[fileId] = new MergedMesh(meshCounts_1[fileId], parseInt(fileId, 10));
        }
      }); // create mappings while calculating running triangle offsets

      var triangleOffsets = {};

      for (var i = 0; i < geometryInfo.count; i++) {
        data.loadData(geometryInfo);
        maps.treeIndexNodeIdMap[data.treeIndex] = data.nodeId;
        maps.colorMap[data.treeIndex] = data.color;
        triangleOffsets[data.fileId] = triangleOffsets[data.fileId] ? triangleOffsets[data.fileId] : 0;
        mergedMeshes_1[data.fileId].mappings.add(triangleOffsets[data.fileId], data.triangleCount, data.treeIndex, data.size);
        triangleOffsets[data.fileId] += data.triangleCount;
      } // add meshes to groups


      Object.keys(mergedMeshes_1).forEach(function (fileId) {
        sector.mergedMeshGroup.addMesh(mergedMeshes_1[fileId]);
        sceneStats.geometryCount.MergedMesh += 1;
      });
    }
  };

  try {
    for (var _b = __values(rootSector.traverseSectors()), _c = _b.next(); !_c.done; _c = _b.next()) {
      var sector = _c.value;

      _loop_1(sector);
    }
  } catch (e_1_1) {
    e_1 = {
      error: e_1_1
    };
  } finally {
    try {
      if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
    } finally {
      if (e_1) throw e_1.error;
    }
  }
} // Copyright 2019 Cognite AS


function unpackPrimitives(rootSector, uncompressedValues, compressedData, maps, filterOptions) {
  var e_1, _a, e_2, _b;

  var numberOfPrimitivesPerSector = countRenderedNumberOfPrimitivesPerSector(rootSector, compressedData);

  var _loop_1 = function _loop_1(sector) {
    compressedData[sector.path].primitives.forEach(function (primitiveCompressedData) {
      unpackFilePrimitive(sector, primitiveCompressedData, uncompressedValues, maps, numberOfPrimitivesPerSector, filterOptions);
    });
  };

  try {
    for (var _c = __values(rootSector.traverseSectors()), _d = _c.next(); !_d.done; _d = _c.next()) {
      var sector = _d.value;

      _loop_1(sector);
    }
  } catch (e_1_1) {
    e_1 = {
      error: e_1_1
    };
  } finally {
    try {
      if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
    } finally {
      if (e_1) throw e_1.error;
    }
  }

  try {
    for (var _e = __values(rootSector.traversePrimitiveGroups()), _f = _e.next(); !_f.done; _f = _e.next()) {
      var primitiveGroup = _f.value;
      primitiveGroup.sort();
    }
  } catch (e_2_1) {
    e_2 = {
      error: e_2_1
    };
  } finally {
    try {
      if (_f && !_f.done && (_b = _e.return)) _b.call(_e);
    } finally {
      if (e_2) throw e_2.error;
    }
  }
}

function countRenderedNumberOfPrimitivesPerSector(rootSector, compressedData) {
  var e_3, _a;

  var numberOfPrimitivesPerSector = {};

  var _loop_2 = function _loop_2(sector) {
    numberOfPrimitivesPerSector[sector.path] = {};
    RenderedPrimitiveNames.forEach(function (renderedPrimitive) {
      numberOfPrimitivesPerSector[sector.path][renderedPrimitive] = 0;
    });
    compressedData[sector.path].primitives.forEach(function (fileGeometryData) {
      renderedPrimitivesPerFilePrimitive[fileGeometryData.type].forEach(function (renderedPrimitiveInfo) {
        numberOfPrimitivesPerSector[sector.path][renderedPrimitiveInfo.name] += renderedPrimitiveInfo.count * fileGeometryData.count;
      });
    });
  };

  try {
    for (var _b = __values(rootSector.traverseSectors()), _c = _b.next(); !_c.done; _c = _b.next()) {
      var sector = _c.value;

      _loop_2(sector);
    }
  } catch (e_3_1) {
    e_3 = {
      error: e_3_1
    };
  } finally {
    try {
      if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
    } finally {
      if (e_3) throw e_3.error;
    }
  }

  return numberOfPrimitivesPerSector;
}

function unpackFilePrimitive(currentSector, primitiveCompressedData, uncompressedValues, maps, numberOfPrimitivesPerSector, filterOptions) {
  var destinationPrimitiveGroups = {};
  var data = new PropertyLoader(uncompressedValues);

  for (var j = 0; j < primitiveCompressedData.count; j++) {
    updateDestinationGroups(destinationPrimitiveGroups, currentSector, primitiveCompressedData, j, numberOfPrimitivesPerSector);
    data.loadData(primitiveCompressedData);
    maps.treeIndexNodeIdMap[data.treeIndex] = data.nodeId;
    maps.colorMap[data.treeIndex] = data.color; // @ts-ignore

    renderedPrimitiveToAddFunction[primitiveCompressedData.type].call( // @ts-ignore
    this, destinationPrimitiveGroups, data, filterOptions);
  }
}

function updateDestinationGroups(destinationPrimitiveGroups, currentSector, primitiveCompressedData, numberOfGeometriesAlreadyRendered, numberOfPrimitivesPerSector) {
  renderedPrimitivesPerFilePrimitive[primitiveCompressedData.type].forEach(function (renderedPrimitiveInfo) {
    var destinationGroup = destinationPrimitiveGroups[renderedPrimitiveInfo.name];

    if (destinationGroup === undefined || destinationGroup.capacity < destinationGroup.data.count + renderedPrimitiveInfo.count) {
      destinationPrimitiveGroups[renderedPrimitiveInfo.name] = findOrCreateDestinationGroup(currentSector, renderedPrimitiveInfo, numberOfGeometriesAlreadyRendered, numberOfPrimitivesPerSector);
    }
  });
}

function findOrCreateDestinationGroup(originalSector, renderedPrimitiveInfo, numberOfGeometriesAlreadyRendered, numberOfPrimitivesPerSector) {
  var e_4, _a;

  var searchSector = originalSector;
  var destinationGroup;

  while (searchSector !== undefined && destinationGroup === undefined) {
    searchSector.primitiveGroups.forEach(function (primitiveGroup) {
      if (primitiveGroup.type === renderedPrimitiveInfo.name) {
        if (primitiveGroup.capacity >= primitiveGroup.data.count + renderedPrimitiveInfo.count) {
          destinationGroup = primitiveGroup;
        }
      }
    });
    searchSector = searchSector.parent;
  }

  if (destinationGroup !== undefined) {
    return destinationGroup;
  } else if (renderedPrimitiveInfo.name === 'TorusSegment') {
    var capacity = numberOfPrimitivesPerSector[originalSector.path].TorusSegment; // @ts-ignore

    var createdGroup = new renderedPrimitiveToGroup.TorusSegment(capacity);
    originalSector.primitiveGroups.push(createdGroup);
    return createdGroup;
  } else {
    var numberOfPrimitivesPerSectorAndChildren = 0;

    try {
      for (var _b = __values(originalSector.traverseSectors()), _c = _b.next(); !_c.done; _c = _b.next()) {
        var sector = _c.value;
        numberOfPrimitivesPerSectorAndChildren += numberOfPrimitivesPerSector[sector.path][renderedPrimitiveInfo.name];
      }
    } catch (e_4_1) {
      e_4 = {
        error: e_4_1
      };
    } finally {
      try {
        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
      } finally {
        if (e_4) throw e_4.error;
      }
    }

    var capacity = Math.min(5000, numberOfPrimitivesPerSectorAndChildren - numberOfGeometriesAlreadyRendered * renderedPrimitiveInfo.count); // @ts-ignore

    var createdGroup = new renderedPrimitiveToGroup[renderedPrimitiveInfo.name](capacity);
    originalSector.primitiveGroups.push(createdGroup);
    return createdGroup;
  }
} // Copyright 2019 Cognite AS


var MAGIC_BYTES = 0x46443349;

function loadSectorMetadata(fileReader) {
  var magicBytes = fileReader.readUint32();

  if (magicBytes !== MAGIC_BYTES) {
    throw Error('Start of sector file is incorrect.Expected ' + MAGIC_BYTES.toString(16) + ', got ' + magicBytes.toString(16));
  }

  var formatVersion = fileReader.readUint32();
  var optimizerVersion = fileReader.readUint32();
  var sectorId = fileReader.readUint64();
  var parentSectorId = fileReader.readUint64();
  var sectorBBoxMin = new Vector3(fileReader.readFloat32(), fileReader.readFloat32(), fileReader.readFloat32());
  var sectorBBoxMax = new Vector3(fileReader.readFloat32(), fileReader.readFloat32(), fileReader.readFloat32());
  var arrayCount = fileReader.readUint32();
  var sectorMetadata = {
    magicBytes: magicBytes,
    formatVersion: formatVersion,
    optimizerVersion: optimizerVersion,
    sectorId: sectorId,
    parentSectorId: parentSectorId,
    sectorBBoxMin: sectorBBoxMin,
    sectorBBoxMax: sectorBBoxMax,
    arrayCount: arrayCount
  };
  return sectorMetadata;
} // Copyright 2019 Cognite AS
// Debugging note: This function should never be called on a sector with arrayCount == 0.


function loadUncompressedValues(fileReader) {
  var uncompressedValues = {};
  FilePropertyArrayNames.forEach(function (property) {
    uncompressedValues[property] = [];
    var clusterCount = fileReader.readUint32();
    var bytesForOneValue = fileReader.readUint8();

    switch (property) {
      case 'color':
        if (bytesForOneValue !== 4) {
          throw Error('Reading incorrect number of bytes for color');
        }

        var colorValues = fileReader.readUint8Array(clusterCount * 4);

        for (var j = 0; j < clusterCount; j++) {
          var r = colorValues[j * 4] / 255;
          var g = colorValues[j * 4 + 1] / 255;
          var b = colorValues[j * 4 + 2] / 255; // ignoring a, it's not used by PrimitiveGroup.

          uncompressedValues.color.push(new Color(r, g, b));
        }

        break;

      case 'normal':
        if (bytesForOneValue !== 12) {
          throw Error('Reading incorrect number of bytes for normal');
        }

        for (var j = 0; j < clusterCount; j++) {
          var newNormal = new Vector3(fileReader.readFloat32(), fileReader.readFloat32(), fileReader.readFloat32());
          uncompressedValues.normal.push(newNormal);
        }

        break;

      case 'fileId':
        if (bytesForOneValue !== 8) {
          throw Error('Reading incorrect number of bytes for fileId');
        }

        for (var j = 0; j < clusterCount; j++) {
          uncompressedValues.fileId.push(fileReader.readUint64());
        }

        break;

      default:
        if (bytesForOneValue !== 4) {
          throw Error('Reading incorrect number of bytes for ' + property);
        }

        uncompressedValues[property] = fileReader.readFloat32Array(clusterCount);
        break;
    }
  });
  return uncompressedValues;
} // Copyright 2019 Cognite AS


function loadGeometryIndices(file, sectorEndLocation) {
  var geometryIndices = [];

  while (file.location < sectorEndLocation) {
    var typeId = file.readUint8();
    var type = IdToFileGeometryName[typeId];

    if (type === undefined) {
      // This will happen if file type 4 is used
      // tslint:disable-next-line:no-console
      console.warn('Unknown typeId ', typeId);
    }

    var count = file.readUint32();
    var attributeCount = file.readUint8();
    var byteCount = file.readUint32();
    var nodeIds = file.getNodeIdReader(count);
    var indices = file.getFibonacciDecoder(byteCount, count * attributeCount);
    var newGeometry = {
      type: type,
      nodeIds: nodeIds,
      indices: indices,
      count: count,
      byteCount: byteCount,
      attributeCount: attributeCount
    };
    geometryIndices.push(newGeometry);
  }

  return geometryIndices;
} // Copyright 2019 Cognite AS
// tslint:disable:no-bitwise


var FIBONACCI_MAX_LENGTH = 77; // Any 53 bit integer will take at most 77 bits in a fibonacci encoding.

var fibonacciLookup = [1, 2];

for (var i = 2; i <= FIBONACCI_MAX_LENGTH; i++) {
  fibonacciLookup.push(fibonacciLookup[i - 1] + fibonacciLookup[i - 2]);
}

var FibonacciDecoder =
/** @class */
function () {
  function FibonacciDecoder(compressedBuffer, numberOfValues, startByte, length) {
    this.numberOfValuesRead = -1;
    this.readBitId = -1;
    this.currentValue = -1;
    this.nextFibIndex = -1;
    this.previousBit8 = -1;
    this.numberOfValues = numberOfValues;
    this.buffer = compressedBuffer;
    this.data = new Uint8Array(this.buffer, startByte, length);
    this.rewind();
  }

  FibonacciDecoder.prototype.rewind = function () {
    this.numberOfValuesRead = 0;
    this.currentValue = 0;
    this.previousBit8 = 0;
    this.nextFibIndex = 0;
    this.readBitId = 0;
  };

  FibonacciDecoder.prototype.nextValue = function () {
    if (this.numberOfValuesRead >= this.numberOfValues) {
      throw Error('Reading past end of FibonacciDecoder');
    }

    this.numberOfValuesRead++; // Read until you find two 1 bits in a row. Before then, each 1 corresponds to the (n+1)th fibinacci number.
    // For example, 0010011 is read as 0*1 + 0*2 + 1*3 + 0*5 + 0*8 + 1*13 = 16. Subtract 1 to get the final value.

    for (var i = 0; i < FIBONACCI_MAX_LENGTH; i++) {
      var currentByte = this.data[Math.floor(this.readBitId / 8)];
      var currentBit8 = currentByte & 1 << 7 - this.readBitId % 8;

      if (currentBit8 !== 0) {
        if (this.previousBit8 !== 0 && this.nextFibIndex !== 0) {
          this.previousBit8 = currentBit8;
          var returnValue = this.currentValue - 1;
          this.currentValue = 0;
          this.nextFibIndex = 0;
          this.readBitId++;
          return returnValue;
        } else {
          this.currentValue += fibonacciLookup[this.nextFibIndex];
        }
      }

      this.previousBit8 = currentBit8;
      this.nextFibIndex++;
      this.readBitId++;
    }

    throw Error('Did not find termination bit');
  };

  return FibonacciDecoder;
}(); // Copyright 2019 Cognite AS


var NodeIdReader =
/** @class */
function () {
  function NodeIdReader(arrayBuffer, startLocation, lengthBytes) {
    this.location = 0;
    this.dataView = new DataView(arrayBuffer, startLocation, lengthBytes);
    this.location = 0;
  }

  NodeIdReader.prototype.nextNodeId = function () {
    var readValue = 0;

    for (var i = 0; i < BYTES_PER_NODE_ID; i++) {
      readValue += this.dataView.getUint8(this.location + i) * Math.pow(2, 8 * (BYTES_PER_NODE_ID - 1 - i));
    }

    this.location += BYTES_PER_NODE_ID;
    return readValue;
  };

  NodeIdReader.prototype.rewind = function () {
    this.location = 0;
  };

  return NodeIdReader;
}(); // Copyright 2019 Cognite AS


var CustomFileReader =
/** @class */
function () {
  function CustomFileReader(arrayBuffer) {
    this.originalBuffer = arrayBuffer;
    this.dataView = new DataView(arrayBuffer);
    this.location = 0; // Little endian / big endinan

    this.flip = true;
  } // Use for debugging


  CustomFileReader.prototype.dumpHex = function (numberOfValues) {
    for (var i = -numberOfValues; i < 0; i++) {
      // tslint:disable-next-line
      console.log(('00' + this.dataView.getUint8(this.location + i).toString(16)).slice(-2));
    } // tslint:disable-next-line


    console.log('~~~');

    for (var i = 0; i < numberOfValues; i++) {
      // tslint:disable-next-line
      console.log(('00' + this.dataView.getUint8(this.location + i).toString(16)).slice(-2));
    }
  };

  CustomFileReader.prototype.readUint8 = function () {
    var value = this.dataView.getUint8(this.location);
    this.location += 1;
    return value;
  };

  CustomFileReader.prototype.readUint32 = function () {
    var value = this.dataView.getUint32(this.location, this.flip);
    this.location += 4;
    return value;
  };

  CustomFileReader.prototype.readUint64 = function () {
    var value = this.dataView.getUint32(this.location + 4, this.flip);
    value = value * Math.pow(2, 32);
    value += this.dataView.getUint32(this.location, this.flip);
    this.location += 8;
    return value;
  };

  CustomFileReader.prototype.readFloat32 = function () {
    var value = this.dataView.getFloat32(this.location, this.flip);
    this.location += 4;
    return value;
  };

  CustomFileReader.prototype.readUint32Array = function (numberOfValues) {
    var newArray = [];

    for (var i = 0; i < numberOfValues; i++) {
      newArray.push(this.dataView.getUint32(this.location + i * 4, this.flip));
    }

    this.location += numberOfValues * 4;
    return newArray;
  };

  CustomFileReader.prototype.readUint16Array = function (numberOfValues) {
    var newArray = [];

    for (var i = 0; i < numberOfValues; i++) {
      newArray.push(this.dataView.getUint16(this.location + i * 2, this.flip));
    }

    this.location += numberOfValues * 2;
    return newArray;
  };

  CustomFileReader.prototype.readUint8Array = function (numberOfValues) {
    var newArray = [];

    for (var i = 0; i < numberOfValues; i++) {
      newArray.push(this.dataView.getUint8(this.location + i));
    }

    this.location += numberOfValues;
    return newArray;
  };

  CustomFileReader.prototype.readFloat32Array = function (numberOfValues) {
    var newArray = [];

    for (var i = 0; i < numberOfValues; i++) {
      newArray.push(this.dataView.getFloat32(this.location + i * 4, this.flip));
    }

    this.location += numberOfValues * 4;
    return newArray;
  };

  CustomFileReader.prototype.skip = function (numberOfBytes) {
    this.location += numberOfBytes;
  };

  CustomFileReader.prototype.readSectorMetadata = function () {
    return loadSectorMetadata(this);
  };

  CustomFileReader.prototype.readUncompressedValues = function () {
    return loadUncompressedValues(this);
  };

  CustomFileReader.prototype.readCompressedGeometryData = function (sectorEndLocation) {
    var geometryDataArray = loadGeometryIndices(this, sectorEndLocation);
    var instancedMesh;
    var mergedMesh;
    geometryDataArray.forEach(function (geometryData) {
      if (FilePrimitiveNames.indexOf(geometryData.type) !== -1) ;else if (geometryData.type === 'InstancedMesh') {
        instancedMesh = geometryData;
      } else if (geometryData.type === 'MergedMesh') {
        mergedMesh = geometryData;
      } else {
        // tslint:disable-next-line:no-console
        console.warn('Unrecognized geometry data type ' + geometryData.type);
      }
    });
    var primitiveHandlers = geometryDataArray.filter(function (geometryData) {
      return FilePrimitiveNames.indexOf(geometryData.type) !== -1;
    });
    return {
      primitives: primitiveHandlers,
      instancedMesh: instancedMesh,
      mergedMesh: mergedMesh
    };
  };

  CustomFileReader.prototype.getNodeIdReader = function (geometryCount) {
    var nodeIds = new NodeIdReader(this.originalBuffer, this.location, geometryCount * BYTES_PER_NODE_ID);
    this.location += geometryCount * BYTES_PER_NODE_ID;
    return nodeIds;
  };

  CustomFileReader.prototype.getFibonacciDecoder = function (byteCount, numberOfValues) {
    var indices = new FibonacciDecoder(this.originalBuffer, numberOfValues, this.location, byteCount);
    this.location += byteCount;
    return indices;
  };

  return CustomFileReader;
}(); // Copyright 2019 Cognite AS


function parseFullCustomFile(fileBuffer, meshLoader, filterOptions) {
  var fileReader = new CustomFileReader(fileBuffer);
  var maps = {
    treeIndexNodeIdMap: [],
    colorMap: [],
    nodeIdTreeIndexMap: new Map(),
    sectors: {}
  };
  var compressedData = {}; // Read root sector

  var rootSectorLength = fileReader.readUint32();
  var rootSectorMetadata = fileReader.readSectorMetadata();
  var rootSector = new Sector(rootSectorMetadata.sectorId, rootSectorMetadata.sectorBBoxMin, rootSectorMetadata.sectorBBoxMax);
  maps.sectors[rootSectorMetadata.sectorId] = rootSector;
  var uncompressedValues = fileReader.readUncompressedValues();
  compressedData[rootSector.path] = fileReader.readCompressedGeometryData(rootSectorLength); // Read remaining sectors

  while (fileReader.location < fileBuffer.byteLength) {
    var sectorStartLocation = fileReader.location;
    var sectorByteLength = fileReader.readUint32();
    var sectorMetadata = fileReader.readSectorMetadata();
    var sector = new Sector(rootSectorMetadata.sectorId, sectorMetadata.sectorBBoxMin, sectorMetadata.sectorBBoxMax);
    maps.sectors[sectorMetadata.sectorId] = sector;
    var parentSector = maps.sectors[sectorMetadata.parentSectorId];

    if (parentSector !== undefined) {
      parentSector.addChild(sector);
      parentSector.object3d.add(sector.object3d);
    } else {
      throw Error('Parent sector not found');
    }

    compressedData[sector.path] = fileReader.readCompressedGeometryData(sectorStartLocation + sectorByteLength);
  }

  return unpackData(rootSector, uncompressedValues, compressedData, maps, filterOptions);
}

function parseMultipleCustomFiles(sectorBuffers, meshLoader, filterOptions) {
  var maps = {
    treeIndexNodeIdMap: [],
    colorMap: [],
    nodeIdTreeIndexMap: new Map(),
    sectors: {}
  };
  var compressedData = {};
  var uncompressedValues;
  var rootSector;
  sectorBuffers.forEach(function (sectorBuffer) {
    var fileReader = new CustomFileReader(sectorBuffer);
    var sectorByteLength = fileReader.readUint32();
    var sectorMetadata = fileReader.readSectorMetadata();
    var sector = new Sector(sectorMetadata.sectorId, sectorMetadata.sectorBBoxMin, sectorMetadata.sectorBBoxMax);
    maps.sectors[sectorMetadata.sectorId] = sector;

    if (sectorMetadata.arrayCount > 0) {
      // Is root sector
      rootSector = sector;
      uncompressedValues = fileReader.readUncompressedValues();
    } else {
      var parentSector = maps.sectors[sectorMetadata.parentSectorId];

      if (parentSector !== undefined) {
        parentSector.addChild(sector);
      } else {
        throw Error('Did not find parent sector');
      }
    }

    compressedData[sector.path] = fileReader.readCompressedGeometryData(sectorByteLength);
  });

  if (rootSector === undefined || uncompressedValues === undefined) {
    throw Error('Did not find root sector');
  }

  return unpackData(rootSector, uncompressedValues, compressedData, maps, filterOptions);
}

function unpackData(rootSector, uncompressedValues, compressedData, maps, filterOptions) {
  var e_1, _a;

  var sceneStats = createSceneStats();
  unpackPrimitives(rootSector, uncompressedValues, compressedData, maps, filterOptions);
  unpackMergedMeshes(rootSector, uncompressedValues, compressedData, maps, sceneStats);
  unpackInstancedMeshes(rootSector, uncompressedValues, compressedData, maps, sceneStats);
  mergeInstancedMeshes(rootSector, sceneStats);

  try {
    for (var _b = __values(rootSector.traverseSectors()), _c = _b.next(); !_c.done; _c = _b.next()) {
      var sector = _c.value;
      sector.mergedMeshGroup.createTreeIndexMap();
      sector.instancedMeshGroup.createTreeIndexMap();
      sceneStats.numSectors++;
      sector.primitiveGroups.forEach(function (primitiveGroup) {
        sceneStats.geometryCount[primitiveGroup.type] += primitiveGroup.data.count;
      });
    }
  } catch (e_1_1) {
    e_1 = {
      error: e_1_1
    };
  } finally {
    try {
      if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
    } finally {
      if (e_1) throw e_1.error;
    }
  }

  sceneStats.numNodes = maps.treeIndexNodeIdMap.length;

  for (var treeIndex = 0; treeIndex < maps.treeIndexNodeIdMap.length; treeIndex++) {
    var nodeId = maps.treeIndexNodeIdMap[treeIndex];
    maps.nodeIdTreeIndexMap.set(nodeId, treeIndex);
  }

  return {
    rootSector: rootSector,
    sceneStats: sceneStats,
    maps: maps
  };
} // Copyright 2019 Cognite AS


export { Sector, parseProtobuf, parseFullCustomFile, parseMultipleCustomFiles, BoxGroup, CircleGroup, ConeGroup, EccentricConeGroup, EllipsoidSegmentGroup, GeneralCylinderGroup, GeneralRingGroup, GeometryGroup, MergedMeshMappings, MergedMesh, MergedMeshGroup, InstancedMeshMappings, InstancedMesh, InstancedMeshGroup, InstancedMeshCollection, NutGroup, PrimitiveGroup, QuadGroup, SphericalSegmentGroup, TorusSegmentGroup, TrapeziumGroup, computeBoundingBox };